import * as Konva from '../../assets/konva';
import {Sizes} from './sizes/sizes';
import {Partition} from './partition';
import {Shelf} from './shelf';
import {Drawer} from './drawer';

export class HingedFacadeSection {
  coef;
  coefDoor;
  initDoor;
  create;
  elements;
  onAfterResize: (() => void) | null = null;
  currentSplitterMap: any = null;
  building = false; // true під час перебудови корпусу — щоб тригери рефлоу не спрацьовували рекурсивно
  // true під час replay фасадного дерева (restoreFromTree). У цьому стані всі applyXxx / splitInto
  // не повинні тригерити syncPartitionsToCorpus — вона буде викликана ОДИН раз у кінці restore.
  restoring = false;
  // Малювати чи ні бейджі з номерами фасадів (1..N) у верхньому-лівому куті кожного фасаду.
  // Самі номери все одно обчислюються (assignFacadeNumbers) і шлються на бекенд як facade_number.
  // Перемикач — поки за замовчуванням НЕ показувати. Можна змінити на true або через UI-кнопку
  // (тоді треба викликати assignFacadeNumbers щоб ререндернути).
  showFacadeNumberBadges = false;
  // Контури фасадів (пунктир) + кнопка показу/сховування — лише на кроці шафи (type 17).
  // Живуть на ОКРЕМОМУ шарі Konva.Layer, щоб не плутатись з циклами по `shapesLayerw.children`.
  private facadeHintsLayer: any = null;
  private facadeOutlinesGroup: any = null;
  private facadeToggleButton: any = null;
  private facadeOutlinesVisible = true;

  // Створює (або повертає) окремий Konva.Layer для підказок про фасади.
  // Додається на той самий stage, ПІСЛЯ shapesLayerw — щоб був зверху.
  private ensureFacadeHintsLayer(): any {
    const stage = this.coef.shapesLayerw && this.coef.shapesLayerw.getStage && this.coef.shapesLayerw.getStage();
    if (!stage) return null;
    if (this.facadeHintsLayer && this.facadeHintsLayer.getStage && this.facadeHintsLayer.getStage() === stage) {
      return this.facadeHintsLayer;
    }
    if (this.facadeHintsLayer && this.facadeHintsLayer.destroy) this.facadeHintsLayer.destroy();
    this.facadeHintsLayer = new Konva.Layer();
    stage.add(this.facadeHintsLayer);
    return this.facadeHintsLayer;
  }

  constructor(coef, coefDoor, initDoor, onAfterResize?: () => void, create?: any, elements?: any) {
    this.coef = coef;
    this.coefDoor = coefDoor;
    this.initDoor = initDoor;
    this.onAfterResize = onAfterResize || null;
    this.create = create || null;
    this.elements = elements || null;
    this.installHingeRaiseListener();
  }

  // Слухач "add" на shapesLayerw що піднімає всі петлі на верх z-order'у після
  // додавання будь-якого нового елемента (шухляди, полиці, перегородки, труби...).
  // Спрацьовує ПІСЛЯ push() у children[] (Konva 2.1.3 fires 'add' після push), тому
  // на момент виклику новий елемент вже у children — moveToTop петель робить їх ВИЩЕ.
  // Скип для самих петель (не зациклюємо) та для класики.
  private installHingeRaiseListener() {
    if (!this.coef.shapesLayerw || typeof this.coef.shapesLayerw.on !== 'function') return;
    this.coef.shapesLayerw.off('add.hingeRaise');
    this.coef.shapesLayerw.on('add.hingeRaise', (e: any) => {
      if (this.coef.pramsId != 17) return;
      if (e && e.child && e.child.attrs && e.child.attrs.params && e.child.attrs.params.isHinge) return;
      const hinges = this.coef.shapesLayerw.children.filter(
        (c: any) => c && c.attrs && c.attrs.params && c.attrs.params.isHinge
      );
      for (const h of hinges) h.moveToTop();
      // КРИТИЧНО: Konva 2.1.3 не оновлює .index у решти дітей після moveToTop.
      // Будь-який код що іксує по children[node.index] потім знаходить чужий вузол
      // (manualTravel зокрема рухає не ту перегородку/полицю).
      if (typeof (this.coef.shapesLayerw as any)._setChildrenIndices === 'function') {
        (this.coef.shapesLayerw as any)._setChildrenIndices();
      }
      if (hinges.length > 0) {
        console.log('[RAISE-HINGES] add-event → moveToTop', {
          addedType: e.child && e.child.attrs && e.child.attrs.params && e.child.attrs.params.type,
          addedSubId: e.child && e.child.attrs && e.child.attrs.params && e.child.attrs.params.subId,
          raisedCount: hinges.length
        });
      }
    });
  }

  drawCabinetOutline(zoneName: string, x: number, y: number, width: number, height: number) {
    const flat = this.coef.global_size_flat;
    const legs = this.coef.height_legs;
    console.log('[HINGED] drawCabinetOutline', {
      zoneName: zoneName,
      cabinet_px: {x: x, y: y, w: width, h: height},
      flat_px: flat,
      legs_px: legs
    });
    const stroke = 'rgba(0,0,0,0.6)';
    const fill = 'rgba(0,0,0,0.04)';

    const left = new Konva.Rect({
      x: x, y: y, width: flat, height: height - legs,
      fill: fill, stroke: stroke, strokeWidth: 1
    });
    const right = new Konva.Rect({
      x: x + width - flat, y: y, width: flat, height: height - legs,
      fill: fill, stroke: stroke, strokeWidth: 1
    });
    const top = new Konva.Rect({
      x: x, y: y, width: width, height: flat,
      fill: fill, stroke: stroke, strokeWidth: 1
    });
    const bottom = new Konva.Rect({
      x: x, y: y + height - legs - flat, width: width, height: flat,
      fill: fill, stroke: stroke, strokeWidth: 1
    });
    const legsRect = new Konva.Rect({
      x: x, y: y + height - legs, width: width, height: legs,
      fill: 'rgba(0,0,0,0.04)', stroke: stroke, strokeWidth: 1
    });

    this.coefDoor.DoorWrapper.add(left);
    this.coefDoor.DoorWrapper.add(right);
    this.coefDoor.DoorWrapper.add(top);
    this.coefDoor.DoorWrapper.add(bottom);
    this.coefDoor.DoorWrapper.add(legsRect);

    [left, right, top, bottom, legsRect].forEach((r: any) => {
      r.attrs.params = {
        type: this.coef.id_element.hinged_facade_section,
        zoneName: zoneName,
        isCabinetOutline: true,
        listening: false
      };
      r.listening(false);
    });

    return {left, right, top, bottom, legsRect};
  }

  computeFacadeRect(cabinetX: number, cabinetY: number, cabinetW: number, cabinetH: number, isInset: boolean) {
    const flat = this.coef.global_size_flat;
    const legs = this.coef.height_legs;
    const hf = this.coef.hingedFacade || {};
    // Для inset (внутрішніх) зовнішній зазор = facade_gap_size (рівний зазору між фасадами).
    // Для overlay (зовнішніх) лишаються окремі facade_side_offset / facade_top_bottom_offset.
    const gapSize = hf.facade_gap_size || 0;
    const sideOffset = isInset ? gapSize : (hf.facade_side_offset || 0);
    const topBottomOffset = isInset ? gapSize : (hf.facade_top_bottom_offset || 0);

    let result;
    if (isInset) {
      result = {
        x: cabinetX + flat + sideOffset,
        y: cabinetY + flat + topBottomOffset,
        w: cabinetW - 2 * flat - 2 * sideOffset,
        h: cabinetH - 2 * flat - legs - 2 * topBottomOffset
      };
    } else {
      result = {
        x: cabinetX + sideOffset,
        y: cabinetY + topBottomOffset,
        w: cabinetW - 2 * sideOffset,
        h: cabinetH - legs - 2 * topBottomOffset
      };
    }
    console.log('[HINGED] computeFacadeRect', {
      mode: isInset ? 'Внутрішні (201)' : 'Зовнішні (200)',
      cabinet: {x: cabinetX, y: cabinetY, w: cabinetW, h: cabinetH},
      flat: flat,
      legs: legs,
      sideOffset: sideOffset,
      topBottomOffset: topBottomOffset,
      facadeRect: result
    });
    return result;
  }

  createRootZone(zoneName: string, cabinetX: number, cabinetY: number, cabinetW: number, cabinetH: number, isInset: boolean) {
    this.drawCabinetOutline(zoneName, cabinetX, cabinetY, cabinetW, cabinetH);
    const rect = this.computeFacadeRect(cabinetX, cabinetY, cabinetW, cabinetH, isInset);
    return this.createFacadeGroup(zoneName, rect.x, rect.y, rect.w, rect.h, isInset, 1, null, 0);
  }

  createFacadeGroup(zoneName: string, x: number, y: number, w: number, h: number, isInset: boolean, depth: number, lastDir: 'rows' | 'cols' | null, switchCount: number) {
    this.coef.countNameElement++;
    const group: any = new Konva.Group({
      x: x,
      y: y,
      name: 'element' + this.coef.countNameElement,
      params: {
        type: this.coef.id_element.hinged_facade_section,
        zoneName: zoneName,
        depth: depth,
        swingDir: null,
        facadeMaterialId: null,
        facadeOptionId: null,
        isInset: isInset,
        lastDir: lastDir,
        switchCount: switchCount,
        sectionKind: null
      }
    });

    const facade: any = new Konva.Rect({
      x: 0,
      y: 0,
      width: w,
      height: h,
      fill: this.coef.color,
      stroke: 'black',
      strokeWidth: 1,
      params: {
        type: this.coef.id_element.hinged_facade_section,
        zoneName: zoneName,
        isFacade: true
      }
    });

    facade.on('click', () => {
      if (this.coefDoor.reDesign && this.coefDoor.reDesign.attrs && this.coefDoor.reDesign.attrs.params) {
        const prev = this.coefDoor.reDesign;
        if (prev.attrs.params.type === this.coef.id_element.hinged_facade_section && prev.children && prev.children[0]) {
          prev.children[0].attrs.strokeWidth = 1;
          prev.children[0].attrs.stroke = 'black';
        }
      }
      this.coefDoor.reDesign = group;
      facade.attrs.strokeWidth = 3;
      facade.attrs.stroke = 'red';
      this.coefDoor.DoorWrapper.batchDraw();
      if (this.initDoor && this.initDoor.openSlid) {
        this.initDoor.openSlid.next({id: 'hinged', obj: group});
      }
    });

    group.add(facade);

    this.addSizeLabels(group, w, h);

    this.coefDoor.DoorWrapper.add(group);
    this.coefDoor.DoorWrapper.batchDraw();
    return group;
  }

  drawDrawerVisual(group: any, w: number, h: number, subId: number) {
    const handleColor = this.coef.silverColor || 'rgba(192,192,192,1)';
    const handleWidth = 16;
    const handleHeight = 5;
    const params = {type: this.coef.id_element.hinged_facade_section, isDrawerVisual: true};
    const isGrip = (subId === 26 || subId === 27);
    if (!isGrip) {
      // Звичайна шухляда — центральна ручка.
      const handle: any = new Konva.Rect({
        x: w / 2 - handleWidth / 2,
        y: h / 2 - handleHeight / 2,
        width: handleWidth,
        height: handleHeight,
        fill: handleColor,
        strokeWidth: 1,
        stroke: 'black',
        listening: false,
        params: params
      });
      group.add(handle);
    } else {
      // "На захват": темна смужка-профіль по верхньому краю на всю ширину фасаду,
      // без центральної ручки (як на іконці типу — чорна з прозорістю 0.5).
      const stripHeight = 5;
      const strip: any = new Konva.Rect({
        x: 0,
        y: 0,
        width: w,
        height: stripHeight,
        fill: 'rgba(0, 0, 0, 0.5)',
        listening: false,
        params: params
      });
      group.add(strip);
    }
    if (subId === 8 || subId === 10 || subId === 27) {
      const dText: any = new Konva.Text({
        x: w - 22,
        y: 5,
        text: 'Д',
        fontSize: 15,
        fontFamily: 'Calibri',
        fill: 'black',
        listening: false,
        params: params
      });
      group.add(dText);
    }
    if (subId === 9 || subId === 10) {
      const lockCircle: any = new Konva.Circle({
        x: 16,
        y: 16,
        radius: 6,
        fill: this.coef.silverColor || '#c0c0c0',
        strokeWidth: 1,
        stroke: 'black',
        listening: false,
        params: params
      });
      const lockKey: any = new Konva.Rect({
        x: 15,
        y: 13,
        width: 2,
        height: 6,
        fill: 'black',
        listening: false,
        params: params
      });
      group.add(lockCircle);
      group.add(lockKey);
    }
  }

  resolveFacadeColor(colorId: any): string {
    if (colorId == null) return this.coef.colorFacad || this.coef.color;
    const list = this.coef.settingsColor || [];
    for (const c of list) {
      if (c.id === +colorId) {
        if (this.coef.addOpacyti && typeof this.coef.addOpacyti === 'function') {
          return this.coef.addOpacyti(c.rgb);
        }
        return c.rgb;
      }
    }
    return this.coef.colorFacad || this.coef.color;
  }

  // Кеш завантажених HTML-картинок по URL — щоб не качати ту саму текстуру для кожного фасаду.
  private static __textureImageCache: {[url: string]: HTMLImageElement} = {};

  // Знайти повний об'єкт кольору з coef.settingsColor (id, name, rgb, textured, image).
  resolveFacadeColorObj(colorId: any): any {
    if (colorId == null) return null;
    const list = this.coef.settingsColor || [];
    for (const c of list) {
      if (c.id === +colorId) return c;
    }
    return null;
  }

  // Обертає HTML-картинку через offscreen canvas (як rotateHtmlImageToBase64 у класиці) і
  // повертає НОВУ Image з обернутою (base64) src. Колбек коли готова.
  // degrees: 90 / 180 / 270 (для нас зараз тільки 90).
  private static __rotateImageToBase64(src: HTMLImageElement, degrees: number, cb: (out: HTMLImageElement) => void): void {
    const inImg = new Image();
    inImg.crossOrigin = 'anonymous';
    inImg.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = degrees % 180 === 0 ? inImg.width : inImg.height;
      canvas.height = degrees % 180 === 0 ? inImg.height : inImg.width;
      if (degrees === 90) {
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(inImg, 0, -inImg.height);
      } else if (degrees === 180) {
        ctx.rotate(Math.PI);
        ctx.drawImage(inImg, -inImg.width, -inImg.height);
      } else if (degrees === 270) {
        ctx.rotate((3 * Math.PI) / 2);
        ctx.drawImage(inImg, -inImg.width, 0);
      } else {
        ctx.drawImage(inImg, 0, 0);
      }
      const dataUrl = canvas.toDataURL('image/jpeg');
      const out = new Image();
      out.onload = () => cb(out);
      out.onerror = (e) => console.error('[TEX] rotated image load FAILED', e);
      out.src = dataUrl;
    };
    inImg.onerror = (e) => console.error('[TEX] rotate input load FAILED', e);
    inImg.src = src.src;
  }

  // Отримати готову HTML-картинку для заданого url + rotation. Завантажує оригінал,
  // обертає (якщо треба) і кешує під ключем `url + '@<deg>'`. Колбек коли готова.
  private static __getTextureImage(url: string, rotation: 0 | 90, cb: (img: HTMLImageElement) => void, onfail: (e: any) => void): void {
    const cacheKey = rotation ? url + '@' + rotation : url;
    const cached = HingedFacadeSection.__textureImageCache[cacheKey];
    if (cached && cached.complete && cached.naturalWidth > 0) {
      cb(cached);
      return;
    }
    if (cached) {
      // Завантаження ще йде — підпишемось на onload.
      cached.onload = () => cb(cached);
      cached.onerror = (e: any) => onfail(e);
      return;
    }
    if (rotation === 0) {
      // Прямий шлях — оригінал.
      const img = new Image();
      HingedFacadeSection.__textureImageCache[cacheKey] = img;
      img.onload = () => cb(img);
      img.onerror = (e) => onfail(e);
      img.crossOrigin = 'anonymous';
      img.src = url;
      return;
    }
    // rotation === 90 — спочатку оригінал, потім обертаємо і кешуємо обернутий.
    HingedFacadeSection.__getTextureImage(url, 0, (origImg) => {
      HingedFacadeSection.__rotateImageToBase64(origImg, rotation, (rotatedImg) => {
        HingedFacadeSection.__textureImageCache[cacheKey] = rotatedImg;
        cb(rotatedImg);
      });
    }, onfail);
  }

  // Застосувати текстурну заливку на rect фасаду. План B: обертаємо саму картинку
  // через base64 (для reversed) і малюємо її БЕЗ Konva-rotation (rotation: 0, X/Y: 0).
  // fillPriority явно перемикаємо: 'pattern' коли картинка, 'color' коли однотон.
  applyFacadeFill(facadeRect: any, colorObj: any, isReversed: boolean) {
    if (!facadeRect) return;
    const w = facadeRect.attrs.width || 0;
    const h = facadeRect.attrs.height || 0;
    if (!colorObj) {
      facadeRect.fill(this.coef.colorFacad || this.coef.color);
      facadeRect.fillPatternImage(null);
      facadeRect.fillPriority('color');
      return;
    }
    const rgb = (this.coef.addOpacyti && typeof this.coef.addOpacyti === 'function')
      ? this.coef.addOpacyti(colorObj.rgb) : colorObj.rgb;
    facadeRect.fill(rgb);
    facadeRect.fillPatternImage(null);
    facadeRect.fillPriority('color');
    if (colorObj.textured && colorObj.image) {
      const url = colorObj.image;
      const rotation: 0 | 90 = isReversed ? 90 : 0;
      const apply = (img: HTMLImageElement) => {
        if (!facadeRect.attrs) return;
        const iw = img.naturalWidth || img.width || 1;
        const ih = img.naturalHeight || img.height || 1;
        facadeRect.fillPatternImage(img);
        facadeRect.fillPatternRepeat('no-repeat');
        facadeRect.fillPatternScale({x: w / iw, y: h / ih});
        facadeRect.fillPatternRotation(0);
        facadeRect.fillPatternX(0);
        facadeRect.fillPatternY(0);
        facadeRect.fillPriority('pattern');
        const layer = facadeRect.getLayer && facadeRect.getLayer();
        if (layer && layer.draw) layer.draw();
        else if (layer && layer.batchDraw) layer.batchDraw();
      };
      HingedFacadeSection.__getTextureImage(url, rotation, apply, (e) => {
        console.error('[TEX] failed to load texture', {url, rotation, error: e});
      });
    }
  }

  // Індикатор-смуга напряму текстури: 20px вздовж ЛІВОГО краю на повну висоту (vertical)
  // або вздовж ВЕРХНЬОГО краю на повну ширину (horizontal). Малюється ПОВЕРХ картинки.
  createTextureDirectionOverlay(w: number, h: number, isReversed: boolean): any {
    const stripThickness = 20;
    const url = isReversed
      ? 'assets/img/texture/left-right.svg'
      : 'assets/img/texture/index.svg';
    const g: any = new Konva.Group({
      x: 0, y: 0,
      listening: false,
      params: {type: this.coef.id_element.hinged_facade_section, isTextureOverlay: true}
    });
    const imgW = isReversed ? w : stripThickness;
    const imgH = isReversed ? stripThickness : h;
    const imgNode: any = new Konva.Image({
      x: 0, y: 0, width: imgW, height: imgH, listening: false
    } as any);
    g.add(imgNode);
    const cached = HingedFacadeSection.__textureImageCache[url];
    const apply = (img: HTMLImageElement) => {
      if (!imgNode.attrs) return;
      imgNode.image(img);
      const layer = imgNode.getLayer && imgNode.getLayer();
      if (layer && layer.batchDraw) layer.batchDraw();
    };
    if (cached && cached.complete && cached.naturalWidth > 0) {
      apply(cached);
    } else {
      const img = cached || new Image();
      if (!cached) {
        HingedFacadeSection.__textureImageCache[url] = img;
        img.src = url;
      }
      img.onload = () => apply(img);
    }
    return g;
  }

  // Публічна точка-входу для UI: перемкнути напрям текстури на конкретному ліст.
  setFacadeTextureDirection(group: any, reversed: boolean) {
    if (!group || !group.attrs || !group.attrs.params) return;
    group.attrs.params.isTextureReversed = !!reversed;
    this.refreshSizeLabels(group);
    this.coefDoor.DoorWrapper.batchDraw();
  }

  addSizeLabels(group, w, h) {
    const sizes = new Sizes(this.coef, null, this.coefDoor);

    const facadeRect = group.children && group.children[0];
    const params = group.attrs && group.attrs.params;
    const kindEarly = params && params.sectionKind;
    // Для 'open' фасаду тіла немає — текстуру/overlay не малюємо.
    if (facadeRect && params && kindEarly !== 'open') {
      const cId = params.facadeColorId;
      const colorObj = this.resolveFacadeColorObj(cId);
      const isReversed = !!params.isTextureReversed;
      // Заливка: image-pattern якщо є картинка, інакше однотон.
      this.applyFacadeFill(facadeRect, colorObj, isReversed);
      // Overlay-хвильки тільки якщо матеріал помічений textured.
      if (colorObj && colorObj.textured) {
        const overlay = this.createTextureDirectionOverlay(w, h, isReversed);
        if (overlay) group.add(overlay);
      }
    } else if (facadeRect && params && kindEarly === 'open') {
      // 'open' = порожня зона: світло-сіра напівпрозора заливка, без текстури.
      facadeRect.fill('rgba(220,220,220,0.4)');
      facadeRect.fillPatternImage(null);
      facadeRect.fillPriority('color');
    } else if (facadeRect && params) {
      // Без kind (untyped) — теж однотон як раніше.
      const cId = params.facadeColorId;
      if (cId != null) facadeRect.fill(this.resolveFacadeColor(cId));
    }

    const widthBind: any = {left: {attrs: {x: 0, width: 0}}};
    const widthElement: any = {attrs: {x: 0, y: h - 10, width: w, height: 0}};
    const widthGroup: any = sizes.createOneSizeHorizontDoor(widthBind, widthElement, {type: this.coef.id_element.hinged_facade_section, remove: true});
    if (widthGroup) {
      group.add(widthGroup);
    }

    const heightBind: any = {top: {attrs: {y: 0, height: 0}}};
    const heightElement: any = {attrs: {x: w + 6, y: 0, width: 0, height: h}};
    const heightGroup: any = sizes.createOneSizeVerticalDoor(heightBind, heightElement, false, {type: this.coef.id_element.hinged_facade_section, remove: true});
    if (heightGroup) {
      group.add(heightGroup);
    }

    const sd = group.attrs && group.attrs.params && group.attrs.params.swingDir;
    if (sd) {
      const handle = this.createSwingHandle(w, h, sd, group.attrs.params.openingType);
      if (handle) group.add(handle);
    }

    const kind = group.attrs && group.attrs.params && group.attrs.params.sectionKind;
    if (kind === 'drawers') {
      const subId = group.attrs.params.drawerSubId;
      if (subId != null) {
        this.drawDrawerVisual(group, w, h, +subId);
      }
    }

    // 'open' = порожня зона: X-перекреслення від кута до кута замість літери.
    if (kind === 'open') {
      const lineA: any = new Konva.Line({
        points: [0, 0, w, h],
        stroke: 'rgba(0,0,0,0.55)', strokeWidth: 1, listening: false,
        params: {type: this.coef.id_element.hinged_facade_section, isOpenZoneCross: true}
      });
      const lineB: any = new Konva.Line({
        points: [w, 0, 0, h],
        stroke: 'rgba(0,0,0,0.55)', strokeWidth: 1, listening: false,
        params: {type: this.coef.id_element.hinged_facade_section, isOpenZoneCross: true}
      });
      group.add(lineA);
      group.add(lineB);
    }

    const kindLabel = this.createKindLabel(w, h, kind);
    if (kindLabel) group.add(kindLabel);

    // Номер фасаду (1..N) у верхньому-лівому куті, на білій плашці — для звіту / друку.
    // Виставляється з assignFacadeNumbers() після кожного rebuild; зчитуємо тут і малюємо.
    // Малюємо лише якщо включено showFacadeNumberBadges (за замовчуванням false).
    const fn = group.attrs && group.attrs.params && group.attrs.params.facadeNumber;
    if (this.showFacadeNumberBadges && fn != null) {
      const badge = this.createFacadeNumberBadge(fn);
      if (badge) group.add(badge);
    }
  }

  // Білий бейдж з синім бордером і числом — у top-left куті фасаду.
  createFacadeNumberBadge(n: number): any {
    const g: any = new Konva.Group({
      x: 6, y: 6, listening: false,
      params: {type: this.coef.id_element.hinged_facade_section, isFacadeNumber: true}
    });
    g.add(new Konva.Rect({
      x: 0, y: 0, width: 22, height: 18,
      fill: 'white', stroke: 'rgb(0,0,180)', strokeWidth: 1, cornerRadius: 3, listening: false
    }));
    const txtCfg: any = {
      x: 0, y: 1, width: 22, height: 18,
      text: String(n), fontSize: 14, fontStyle: 'bold', fill: 'rgb(0,0,180)',
      align: 'center', verticalAlign: 'middle', listening: false
    };
    g.add(new Konva.Text(txtCfg));
    return g;
  }

  createKindLabel(w: number, h: number, kind: string | null): any {
    // 'open' → X-перекреслення через спеціальні Konva-вузли у addSizeLabels. Літери більше не використовуються.
    return null;
  }

  // Ручка з боку відкривання + умовне позначення типу відкривання:
  //   'common' — замальована ручка; 'soft-close' (дотяг) — замальована ручка + "Д";
  //   'push-up' (дотик) — ручка пунктирним контуром + "Т".
  // Літера — чорна у правому верхньому куті фасаду (як "Д" на внутрішніх відкривних і шухлядах).
  createSwingHandle(w: number, h: number, swingDir: string, openingType?: string): any {
    const thickness = 6;
    const length = 40;
    const margin = 4;
    let x: number, y: number, rectW: number, rectH: number;
    if (swingDir === 'left') {
      x = margin;
      y = (h - length) / 2;
      rectW = thickness;
      rectH = length;
    } else if (swingDir === 'right') {
      x = w - margin - thickness;
      y = (h - length) / 2;
      rectW = thickness;
      rectH = length;
    } else if (swingDir === 'up') {
      x = (w - length) / 2;
      y = margin;
      rectW = length;
      rectH = thickness;
    } else if (swingDir === 'down') {
      x = (w - length) / 2;
      y = h - margin - thickness;
      rectW = length;
      rectH = thickness;
    } else {
      return null;
    }
    const color = 'rgba(40, 80, 180, 0.9)';
    const g: any = new Konva.Group({
      listening: false,
      params: {type: this.coef.id_element.hinged_facade_section, isHandle: true}
    });
    const isPush = openingType === 'push-up';
    const handleCfg: any = {
      x: x,
      y: y,
      width: rectW,
      height: rectH,
      cornerRadius: 2,
      listening: false
    };
    if (isPush) {
      handleCfg.stroke = color;
      handleCfg.strokeWidth = 1;
      handleCfg.dash = [3, 2];
    } else {
      handleCfg.fill = color;
    }
    g.add(new Konva.Rect(handleCfg));
    const letter = isPush ? 'Т' : (openingType === 'soft-close' ? 'Д' : null);
    if (letter) {
      g.add(new Konva.Text({
        x: w - 26,
        y: 9,
        text: letter,
        fontSize: 18,
        fontFamily: 'Calibri',
        fill: 'black',
        listening: false
      }));
    }
    return g;
  }

  applySwingDir(group: any, dir: string | null) {
    if (!group || !group.attrs || !group.attrs.params) return;
    group.attrs.params.swingDir = dir;
    this.refreshSizeLabels(group);
    this.coefDoor.DoorWrapper.batchDraw();
    this.syncPartitionsToCorpus();
  }

  // Тип відкривання дверки ('common' | 'push-up' | 'soft-close') — лише позначка на фасаді
  // і поле opening_type для бека; на корпус/петлі не впливає, тому без syncPartitionsToCorpus.
  setOpeningType(group: any, type: string) {
    if (!group || !group.attrs || !group.attrs.params) return;
    group.attrs.params.openingType = type;
    // Петлі цієї дверки несуть тип відкривання для бека (door_count[].hinges і hingeBind корпусу).
    const layer = this.coef.shapesLayerw;
    if (layer && layer.children) {
      for (const c of layer.children) {
        const cp = c && c.attrs && c.attrs.params;
        if (cp && cp.isHinge && cp.doorKey === group._id) cp.openingType = type;
      }
    }
    this.refreshSizeLabels(group);
    this.coefDoor.DoorWrapper.batchDraw();
  }

  applySectionKind(group: any, kind: string | null) {
    if (!group || !group.attrs || !group.attrs.params) return;
    const params = group.attrs.params;
    params.sectionKind = kind;
    if (kind !== 'door' && params.swingDir) {
      params.swingDir = null;
    }
    // 'open' = порожня зона: скидаємо колір/матеріал/напрям до дефолтів — не має сенсу
    // зберігати юзерський вибір для зони якої фізично немає.
    // null (Скинути) = повернення до initial untyped стану — теж дефолти.
    if (kind === 'open' || kind == null) {
      params.facadeColorId = null;
      params.facadeMaterialId = null;
      params.facadeOptionId = null;
      params.isTextureReversed = false;
    }
    this.refreshSizeLabels(group);
    this.coefDoor.DoorWrapper.batchDraw();
    this.syncPartitionsToCorpus();
  }

  syncPartitionsToCorpus() {
    if (!this.coef.shapesLayerw || !this.coef.shapesLayerw.children) return;
    // Під час restoreFromTree applyXxx/splitInto клікають sync постійно — пропускаємо все,
    // restore сам викликає sync один раз у кінці.
    if (this.restoring) return;
    this.building = true; // блокуємо тригери рефлоу під час перебудови

    // Перенумеровуємо індекси перед знищеннями: sizes.ts.deleteOneSize робить пряму splice
    // без оновлення child.index → наступні Konva-destroy на застарілих індексах ріжуть чужі вузли.
    if (this.coef.Size && typeof (this.coef.Size as any)._setChildrenIndices === 'function') {
      (this.coef.Size as any)._setChildrenIndices();
    }
    if (this.coef.shapesLayerw && typeof (this.coef.shapesLayerw as any)._setChildrenIndices === 'function') {
      (this.coef.shapesLayerw as any)._setChildrenIndices();
    }

    for (let i = this.coef.shapesLayerw.children.length - 1; i >= 0; i--) {
      const c: any = this.coef.shapesLayerw.children[i];
      if (c.attrs && c.attrs.params && c.attrs.params.isHinge) {
        c.destroy();
      }
    }
    // Окремий цикл для drawer_zone — elements.deleteElement не видаляє їх (нема name/bind).
    // Спочатку прибираємо наші follow-listener'и з усіх children, потім destroy.
    for (const el of this.coef.shapesLayerw.children) {
      if (el && typeof el.off === 'function') el.off('dragmove.drawerZoneFollow');
      if (el && el.attrs && el.attrs.params && el.attrs.params.drawerZoneBind) {
        el.attrs.params.drawerZoneBind = [];
      }
    }
    for (let i = this.coef.shapesLayerw.children.length - 1; i >= 0; i--) {
      const c: any = this.coef.shapesLayerw.children[i];
      if (c.attrs && c.attrs.params && c.attrs.params.isDrawerZone) {
        c.destroy();
      }
    }

    if (this.elements && typeof this.elements.deleteElement === 'function') {
      const prevStartRemove = this.coef.startRemove;
      this.coef.startRemove = true;
      this.coef.hingedPurge = true;
      const snapshot = this.coef.shapesLayerw.children.slice();
      for (const evt of snapshot) {
        try {
          this.elements.deleteElement(evt, this.coef.shapesLayerw);
        } catch (err) {
          console.warn('[PART] cleanup deleteElement failed', err);
        }
      }
      this.coef.hingedPurge = false;
      this.coef.startRemove = prevStartRemove;
    } else {
      if (this.coef.Size && this.coef.Size.children) {
        for (let i = this.coef.Size.children.length - 1; i >= 0; i--) {
          const c: any = this.coef.Size.children[i];
          if (c.attrs && c.attrs.params && c.attrs.params.autoFromHinged) {
            c.destroy();
          }
        }
      }
      for (let i = this.coef.shapesLayerw.children.length - 1; i >= 0; i--) {
        const c: any = this.coef.shapesLayerw.children[i];
        if (c.attrs && c.attrs.params && c.attrs.params.autoFromHinged) {
          const bind = c.attrs.bind;
          if (Array.isArray(bind)) {
            for (const b of bind) {
              if (b && b.destroy) b.destroy();
            }
          }
          c.destroy();
        }
      }
    }

    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return;

    const rootBoundaries = {
      left: 'CAB_LEFT',
      right: 'CAB_RIGHT',
      top: 'CAB_TOP',
      bottom: 'CAB_BOTTOM'
    };
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c.attrs && c.attrs.params;
      if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
      if (p.depth !== 1) continue;
      this.attachBoundaries(c, rootBoundaries);
    }

    const splitterMap = this.buildSplitterMap();
    this.currentSplitterMap = splitterMap;

    const plans: any[] = [];
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c.attrs && c.attrs.params;
      if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
      if (p.depth !== 1) continue;
      this.collectPlansTreeBased(c, plans);
    }

    this.addAuxiliaryFromTree(plans, splitterMap);

    const sorted = this.topoSortPlans(plans);

    console.log('[PART] PLAN ORDER', sorted.map(p => ({
      id: p.id,
      direction: p.direction,
      axisPos_mm: Math.round(p.axisPos * this.coef.global_coef),
      rangeStart_mm: Math.round(p.rangeStart * this.coef.global_coef),
      rangeEnd_mm: Math.round(p.rangeEnd * this.coef.global_coef),
      startDep: p.startDep,
      endDep: p.endDep
    })));

    for (const plan of sorted) {
      this.executePlan(plan);
    }

    this.coef.shapesLayerw.batchDraw();
    if (this.coef.Size && this.coef.Size.batchDraw) this.coef.Size.batchDraw();
    const actualCount = this.coef.shapesLayerw.children.filter((x: any) => x.attrs && x.attrs.params && x.attrs.params.autoFromHinged).length;
    const verticalPlans = sorted.filter(p => p.direction === 'vertical').length;
    const horizontalPlans = sorted.filter(p => p.direction === 'horizontal').length;
    const auxPlans = sorted.filter(p => p.isAuxiliary).length;
    console.log('[PART] ACTUAL', {
      actual_total: actualCount,
      planned_total: sorted.length,
      vertical_plans: verticalPlans,
      horizontal_plans: horizontalPlans,
      auxiliary_plans: auxPlans,
      match: actualCount === sorted.length,
      mismatch_count: sorted.length - actualCount
    });

    this.building = false; // перебудову завершено — далі вже можна рефлоу
    this.syncCorpusDoublePartition();
    this.syncHingesToCorpus();
    this.syncDrawerZonesToCorpus();
    // Глобальна нумерація фасадів (1..N) — стабільна після rebuild, попадає в payload + canvas.
    this.assignFacadeNumbers();
  }

  // Пронумерувати всі leaf-фасади (не контейнери) у DoorWrapper за порядком
  // top→bottom, left→right. Записати params.facadeNumber + refresh-нути лейбли
  // щоб бейдж з номером з'явився/оновився на канвасі.
  assignFacadeNumbers() {
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return;
    const leaves: any[] = [];
    const walk = (zone: any) => {
      const p = zone && zone.attrs && zone.attrs.params;
      if (!p) return;
      if (p.isContainer) {
        for (const c of (p.children || [])) walk(c);
        return;
      }
      leaves.push(zone);
    };
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c && c.attrs && c.attrs.params;
      if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
      if (p.depth !== 1) continue;
      walk(c);
    }
    leaves.sort((a: any, b: any) => {
      if (a.attrs.y === b.attrs.y) return a.attrs.x - b.attrs.x;
      return a.attrs.y - b.attrs.y;
    });
    for (let i = 0; i < leaves.length; i++) {
      const n = i + 1;
      const p = leaves[i].attrs.params;
      if (p.facadeNumber !== n) {
        p.facadeNumber = n;
      }
      this.refreshSizeLabels(leaves[i]);
    }
    this.coefDoor.DoorWrapper.batchDraw();
    console.log('[HINGED] assignFacadeNumbers', {leaves: leaves.length});
  }

  // ====== DRAWER ZONES ======
  // Зони шухляд у корпусі: візуальний "X-перекреслений" прямокутник + захист від встановлення
  // полиці/перегородки + посилання на сусідніх контурах (drawerZoneBind) для бекенду.
  // Створюється для кожного leaf-фасаду з sectionKind === 'drawers'. Знищується разом з іншими
  // autoFromHinged через звичайний purge на початку syncPartitionsToCorpus.
  syncDrawerZonesToCorpus() {
    if (!this.coef.shapesLayerw || !this.coefDoor.DoorWrapper) return;
    // Очистити старі follow-listener'и + drawerZoneBind на контурах (бо старі зони вже знищено
    // через autoFromHinged purge у syncPartitionsToCorpus; залишки — посилання й closures).
    if (this.coef.shapesLayerw.children) {
      for (const el of this.coef.shapesLayerw.children) {
        if (el && typeof el.off === 'function') el.off('dragmove.drawerZoneFollow');
        if (el && el.attrs && el.attrs.params && el.attrs.params.drawerZoneBind) {
          el.attrs.params.drawerZoneBind = [];
        }
      }
    }
    // Перебираємо дерево DoorWrapper, шукаємо leaves з sectionKind === 'drawers'.
    const leaves: any[] = [];
    const walk = (zone: any) => {
      const p = zone && zone.attrs && zone.attrs.params;
      if (!p) return;
      if (p.isContainer) {
        for (const c of (p.children || [])) walk(c);
        return;
      }
      if (p.sectionKind === 'drawers') leaves.push(zone);
    };
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c && c.attrs && c.attrs.params;
      if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
      if (p.depth !== 1) continue;
      walk(c);
    }
    if (leaves.length === 0) return;
    for (const facadeZone of leaves) {
      const facadeChild = facadeZone.children && facadeZone.children[0];
      if (!facadeChild) continue;
      // Координати беремо ПРЯМО з фасаду без inset/overlay корекції — щоб не лишалось
      // зайвих пробілів між стек-фасадами. X/width в createDrawerZone все одно перерахуються
      // з контурів (left/right перегородок) — це дасть точну позицію.
      const fx = facadeZone.attrs.x;
      const fy = facadeZone.attrs.y;
      const fw = facadeChild.attrs.width || 0;
      const fh = facadeChild.attrs.height || 0;
      const fsub = facadeZone.attrs.params.drawerSubId;
      this.createDrawerZone(fx, fy, fw, fh, facadeZone._id, fsub);
    }
    this.coef.shapesLayerw.batchDraw();
  }

  // Створити одну зону шухляди + прив'язати слухачів на лівому/правому контурах
  // для авто-resize (як hingefollow для петель — namespaced, легко знімаються).
  // subId — тип шухляди з фасаду (drawerSubId); потрібен бекенду для розрахунку наповнення.
  createDrawerZone(x: number, y: number, w: number, h: number, doorKey: any, subId?: any) {
    if (h <= 0) return null;
    // Знайти ЛІВИЙ/ПРАВИЙ контури — копія логіки з getTangentElement, але лише L/R (нам Y/H не з контурів).
    const centerX = x + w / 2;
    const centerY = y + h / 2;
    let elemLeft: any = null, elemRight: any = null;
    let leftX = 0, rightX = 99999;
    if (this.coef.shapesLayerw && this.coef.shapesLayerw.children) {
      for (const element of this.coef.shapesLayerw.children) {
        if (!element || !element.attrs || !element.attrs.params) continue;
        const ep = element.attrs.params;
        if (ep.isDrawerZone) continue; // інші зони не контури
        // вертикальні елементи: partition / lateral_wall / double_partition
        const t = ep.type;
        if (t !== this.coef.id_element.partition
            && t !== this.coef.id_element.lateral_wall
            && t !== this.coef.id_element.double_partition) continue;
        const elH = element.attrs.height != null ? element.attrs.height : (ep.height || 0);
        if (centerY < element.attrs.y || centerY >= element.attrs.y + elH) continue;
        if (centerX > element.attrs.x && element.attrs.x > leftX) {
          leftX = element.attrs.x;
          elemLeft = element;
        }
        if (centerX < element.attrs.x && element.attrs.x < rightX) {
          rightX = element.attrs.x;
          elemRight = element;
        }
      }
    }
    // Якщо обидва знайдені — рахуємо x/width з контурів (правильно для snapped перегородок).
    // Y та height — з фасаду (як домовились).
    let zX = x, zW = w;
    if (elemLeft && elemRight) {
      zX = elemLeft.attrs.x + (elemLeft.attrs.width || 0);
      zW = elemRight.attrs.x - zX;
    }
    if (zW <= 0) return null;
    const group: any = new Konva.Group({
      x: zX, y: y,
      width: zW, height: h,
      listening: false,
      bind: [], // потрібно для циклів типу removeBindElement що ітерують element.attrs.bind
      params: {
        type: this.coef.id_element.drawer_zone,
        isDrawerZone: true,
        autoFromHinged: true,
        removable: false,
        doorKey: doorKey,
        drawerSubId: subId != null ? subId : null
      }
    });
    const bg: any = new Konva.Rect({
      x: 0, y: 0, width: zW, height: h,
      fill: 'rgba(120,120,120,0.10)',
      stroke: 'rgba(0,0,0,0.55)',
      strokeWidth: 0.8,
      dash: [4, 3],
      listening: false,
      params: {isDrawerZoneBg: true}
    });
    const lineA: any = new Konva.Line({
      points: [0, 0, zW, h],
      stroke: 'rgba(0,0,0,0.5)',
      strokeWidth: 0.8,
      listening: false,
      params: {isDrawerZoneCross: true}
    });
    const lineB: any = new Konva.Line({
      points: [zW, 0, 0, h],
      stroke: 'rgba(0,0,0,0.5)',
      strokeWidth: 0.8,
      listening: false,
      params: {isDrawerZoneCross: true}
    });
    group.add(bg, lineA, lineB);
    if (elemLeft && elemRight) {
      group.attrs.params.contoursLR = {left: elemLeft, right: elemRight};
      // Реєстр на контурах: бекенд знатиме що до перегородки прив'язана зона.
      const pushBind = (host: any) => {
        host.attrs.params.drawerZoneBind = host.attrs.params.drawerZoneBind || [];
        host.attrs.params.drawerZoneBind.push(group);
      };
      pushBind(elemLeft);
      pushBind(elemRight);
      // Авто-resize при русі контурів.
      const resyncFromContours = () => {
        const newX = elemLeft.attrs.x + (elemLeft.attrs.width || 0);
        const newW = elemRight.attrs.x - newX;
        if (newW <= 0) return;
        group.x(newX);
        group.width(newW);
        bg.width(newW);
        lineA.points([0, 0, newW, h]);
        lineB.points([newW, 0, 0, h]);
        this.coef.shapesLayerw.batchDraw();
      };
      elemLeft.on('dragmove.drawerZoneFollow', resyncFromContours);
      elemRight.on('dragmove.drawerZoneFollow', resyncFromContours);
    }
    this.coef.shapesLayerw.add(group);
    return group;
  }

  // ===== ФОРМУЛА КІЛЬКОСТІ ПЕТЕЛЬ (легко змінити тут) =====
  getHingeCount(doorSideMm: number, orientation: 'vertical' | 'horizontal'): number {
    const sv = this.coef.spec_values || {};
    const edgeOffset = orientation === 'vertical'
      ? (sv['hinge_vertical_edge_offset'] != null ? sv['hinge_vertical_edge_offset'] : 200)
      : (sv['hinge_horizontal_edge_offset'] != null ? sv['hinge_horizontal_edge_offset'] : 200);
    const innerStep = orientation === 'vertical'
      ? (sv['hinge_vertical_inner_step'] != null ? sv['hinge_vertical_inner_step'] : 500)
      : (sv['hinge_horizontal_inner_step'] != null ? sv['hinge_horizontal_inner_step'] : 500);
    const hingeLengthMm = sv['hinge_length'] != null ? sv['hinge_length'] : 100;
    // edge_offset — край-до-краю: між краєм перегородки і краєм петлі. Проміжок між ЦЕНТРАМИ
    // крайніх петель = сторона − 2*edge_offset − довжина петлі.
    const usable = doorSideMm - 2 * edgeOffset - hingeLengthMm;
    if (usable <= 0) return 2;
    // FORMULA: 2 крайні петлі + проміжні з кроком innerStep
    return Math.floor(usable / innerStep) + 2;
  }

  // Повертає позиції петель (в мм, абсолютна координата вздовж сторони)
  getHingePositionsMm(doorStartMm: number, doorSideMm: number, orientation: 'vertical' | 'horizontal'): number[] {
    const sv = this.coef.spec_values || {};
    const edgeOffset = orientation === 'vertical'
      ? (sv['hinge_vertical_edge_offset'] != null ? sv['hinge_vertical_edge_offset'] : 200)
      : (sv['hinge_horizontal_edge_offset'] != null ? sv['hinge_horizontal_edge_offset'] : 200);
    const hingeLengthMm = sv['hinge_length'] != null ? sv['hinge_length'] : 100;
    const count = this.getHingeCount(doorSideMm, orientation);
    const positions: number[] = [];
    if (count <= 1) {
      positions.push(doorStartMm + doorSideMm / 2);
      return positions;
    }
    // Маленька дверка: зі стандартним edge_offset петлі стали б ближче за min_hinges_offset
    // (напр. 300 мм → центри 135/165, петлі накладаються). Підтягуємо крайні петлі до країв,
    // але не ближче за min_hinge_*_edge_offset.
    const minEdgeMm = orientation === 'vertical'
      ? (sv['min_hinge_vertical_edge_offset'] != null ? sv['min_hinge_vertical_edge_offset'] : edgeOffset)
      : (sv['min_hinge_horizontal_edge_offset'] != null ? sv['min_hinge_horizontal_edge_offset'] : edgeOffset);
    const minCenterDistMm = (sv['min_hinges_offset'] != null ? sv['min_hinges_offset'] : 0) + hingeLengthMm;
    const needSpanMm = (count - 1) * minCenterDistMm;
    let edgeMm = edgeOffset;
    if (doorSideMm - 2 * edgeMm - hingeLengthMm < needSpanMm) {
      edgeMm = Math.max(Math.min(edgeOffset, minEdgeMm), Math.min(edgeOffset, (doorSideMm - hingeLengthMm - needSpanMm) / 2));
    }
    // край-до-краю: край крайньої петлі на edge_offset від краю → центр = +/- (edge_offset + довжина/2)
    const first = doorStartMm + edgeMm + hingeLengthMm / 2;
    const last = doorStartMm + doorSideMm - edgeMm - hingeLengthMm / 2;
    for (let i = 0; i < count; i++) {
      const t = i / (count - 1);
      positions.push(Math.round(first + t * (last - first))); // цілі мм (без коми)
    }
    return positions;
  }

  syncHingesToCorpus() {
    if (!this.coef.shapesLayerw || !this.coefDoor.DoorWrapper) return;
    // Прибираємо старі петлі (функція викликається і самостійно — на драг петлі)
    // Перенумеровуємо індекси перед циклом Konva.destroy() — інакше sizes.ts.deleteOneSize-stale
    // індекси спрямують splice на чужі вузли (наприклад, ріже groupsL/R партиції).
    if (this.coef.shapesLayerw && typeof (this.coef.shapesLayerw as any)._setChildrenIndices === 'function') {
      (this.coef.shapesLayerw as any)._setChildrenIndices();
    }
    if (this.coef.Size && typeof (this.coef.Size as any)._setChildrenIndices === 'function') {
      (this.coef.Size as any)._setChildrenIndices();
    }
    for (let i = this.coef.shapesLayerw.children.length - 1; i >= 0; i--) {
      const c: any = this.coef.shapesLayerw.children[i];
      if (c.attrs && c.attrs.params && c.attrs.params.isHinge) c.destroy();
    }
    // Всі петлі знищено — чистимо hingeBind на ВСІХ елементах. Нижче скидаються лише опори
    // поточних дверей; стіни (боковини/кришка/дно) не перестворюються, тож без цього на них
    // лишались би знищені петлі від дверей, яких уже нема, і йшли б на бекенд як зайві отвори.
    for (const el of this.coef.shapesLayerw.children) {
      if (el && el.attrs && el.attrs.params && Array.isArray(el.attrs.params.hingeBind)) {
        el.attrs.params.hingeBind = [];
      }
    }
    // Прибираємо старі підписи розмірів петель
    if (this.coef.Size && this.coef.Size.children) {
      for (let i = this.coef.Size.children.length - 1; i >= 0; i--) {
        const c: any = this.coef.Size.children[i];
        if (c.attrs && c.attrs.params && c.attrs.params.isHingeDim) c.destroy();
      }
    }
    const coefG = this.coef.global_coef;
    const sv = this.coef.spec_values || {};
    const hingeLengthMm = sv['hinge_length'] != null ? sv['hinge_length'] : 100;
    const hingeLengthPx = hingeLengthMm / coefG;
    const hingeThickPx = 20 / coefG;
    const flatPx = this.coef.global_size_flat;
    // Внутрішній отвір корпусу — опора для ПРИСТІННИХ дверей (боковина/стеля/дно):
    // петля лише в межах отвору, а не по самому шматку стіни (ніжки / повна ширина стелі).
    const cabW = this.coef.setingsWardrobe.width / coefG;
    const cabH = this.coef.setingsWardrobe.height / coefG;
    const cabLeftX = (this.coef.widthWrapper - cabW) / 2;
    const cabInnerLeft = cabLeftX + flatPx;
    const cabInnerRight = cabLeftX + cabW - flatPx;
    const cabInnerTop = this.coef.topPositaionWrapper + flatPx;
    const cabInnerBottom = this.coef.topPositaionWrapper + cabH - flatPx - this.coef.height_legs;

    // Лінію кріплення дверки прив'язуємо до ЦЕНТРУ перегородки/полиці (зі снапом),
    // а саму петлю зсуваємо на бік СВОЄЇ дверки (вправо/вліво), щоб було видно чия петля.
    const elLen = (el: any, vertical: boolean) => {
      if (vertical) return (el.attrs.height != null ? el.attrs.height : (el.attrs.params && el.attrs.params.height)) || 0;
      return (el.attrs.width != null ? el.attrs.width : (el.attrs.params && el.attrs.params.width)) || 0;
    };
    const autoVerticals: any[] = [];   // авто-перегородки (для снапу опори)
    const autoHorizontals: any[] = []; // авто-полиці (для снапу опори)
    for (const el of this.coef.shapesLayerw.children) {
      const p = el.attrs && el.attrs.params;
      if (!p || p.isHinge) continue;
      if (p.type === this.coef.id_element.partition && p.autoFromHinged) autoVerticals.push(el);
      else if (p.type === this.coef.id_element.shelf && p.autoFromHinged) autoHorizontals.push(el);
      else if (p.type === this.coef.id_element.double_partition) autoVerticals.push(el);
    }
    // hingeBind для опор скидаємо нижче (після prepared), щоб охопити і стіни для пристінних дверей
    const tolPx = 35 / coefG;
    // повертає {center, el} найближчої авто-перегородки (для снапу + реєстрації завіс), або null
    const snapVertical = (edgeX: number, yStart: number, yEnd: number) => {
      let best: any = null;
      let bestDist = tolPx;
      for (const el of autoVerticals) {
        const cx = el.attrs.x + elLen(el, false) / 2;
        const d = Math.abs(cx - edgeX);
        if (d > bestDist) continue;
        const top = el.attrs.y;
        const bot = el.attrs.y + elLen(el, true);
        if (bot < yStart - tolPx || top > yEnd + tolPx) continue;
        best = {center: cx, el: el};
        bestDist = d;
      }
      return best;
    };
    const snapHorizontal = (edgeY: number, xStart: number, xEnd: number) => {
      let best: any = null;
      let bestDist = tolPx;
      for (const el of autoHorizontals) {
        const cy = el.attrs.y + elLen(el, true) / 2;
        const d = Math.abs(cy - edgeY);
        if (d > bestDist) continue;
        const left = el.attrs.x;
        const right = el.attrs.x + elLen(el, false);
        if (right < xStart - tolPx || left > xEnd + tolPx) continue;
        best = {center: cy, el: el};
        bestDist = d;
      }
      return best;
    };

    // Збираємо всі дверні листи
    const doors: any[] = [];
    const walk = (zone: any) => {
      if (!zone || !zone.attrs || !zone.attrs.params) return;
      const p = zone.attrs.params;
      if (p.isContainer) {
        for (const c of (p.children || [])) walk(c);
        return;
      }
      if (p.type === this.coef.id_element.hinged_facade_section && p.sectionKind === 'door' && p.swingDir) {
        doors.push(zone);
      }
    };
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c.attrs && c.attrs.params;
      if (p && p.type === this.coef.id_element.hinged_facade_section && p.depth === 1) walk(c);
    }

    // 1) Лінія кріплення (зі снапом на перегородку/полицю) для кожної дверки
    const prepared: any[] = [];
    for (const door of doors) {
      const facade = door.children[0];
      const sd = door.attrs.params.swingDir;
      const orientation: 'vertical' | 'horizontal' = (sd === 'left' || sd === 'right') ? 'vertical' : 'horizontal';
      let attachLine: number;
      let snapped: boolean;
      let ownerEl: any = null;
      if (orientation === 'vertical') {
        const edgeX = (sd === 'left') ? door.attrs.x + facade.attrs.width : door.attrs.x;
        const s = snapVertical(edgeX, door.attrs.y, door.attrs.y + facade.attrs.height);
        snapped = s != null;
        attachLine = snapped ? s.center : edgeX;
        ownerEl = snapped ? s.el : null;
      } else {
        const edgeY = (sd === 'up') ? door.attrs.y + facade.attrs.height : door.attrs.y;
        const s = snapHorizontal(edgeY, door.attrs.x, door.attrs.x + facade.attrs.width);
        snapped = s != null;
        attachLine = snapped ? s.center : edgeY;
        ownerEl = snapped ? s.el : null;
      }
      // supportEl — на якому елементі сидять петлі цієї дверки (для bind-обходу при перевірках)
      const supportEl = ownerEl || this.findWallSupport(orientation, attachLine);
      prepared.push({door, facade, sd, orientation, attachLine, snapped, ownerEl, supportEl});
    }
    // Скидаємо реєстр петель на ВСІХ опорах перед перерисом (включно зі стінами для пристінних)
    const supportsSeen: any[] = [];
    for (const it of prepared) {
      const s = it.supportEl;
      if (s && s.attrs && s.attrs.params && supportsSeen.indexOf(s) < 0) {
        s.attrs.params.hingeBind = [];
        supportsSeen.push(s);
      }
    }

    // 2) Малюємо петлі: зсув на бік своєї дверки (faceOffset) + застосовуємо ручні offset'и.
    //    Петлі робимо перетягуваними вздовж осі (крок 5).
    // Перебудова з формули — на кроці фасадів. Manual offsets не переживають перебудову
    // (геометрія могла кардинально змінитись), тому НЕ використовуємо їх для розрахунку.
    const minEdgeMmV = sv['min_hinge_vertical_edge_offset'] != null ? sv['min_hinge_vertical_edge_offset']
      : (sv['hinge_vertical_edge_offset'] != null ? sv['hinge_vertical_edge_offset'] : 70);
    const minEdgeMmH = sv['min_hinge_horizontal_edge_offset'] != null ? sv['min_hinge_horizontal_edge_offset']
      : (sv['hinge_horizontal_edge_offset'] != null ? sv['hinge_horizontal_edge_offset'] : 70);
    const minShelfClearMm = sv['min_shelf_hinge_offset'] != null ? sv['min_shelf_hinge_offset'] : 0;
    const minPartClearMm = sv['min_partition_hinge_offset'] != null ? sv['min_partition_hinge_offset'] : 0;
    // Будує валідні інтервали для розміщення центру петлі: [lo, hi] мінус смуги полиць/перегородок.
    const buildIntervals = (lo: number, hi: number, sup: any, perpType: number, clearPx: number, vertical: boolean): number[][] => {
      let intervals: number[][] = [[lo, hi]];
      if (!sup || !Array.isArray(sup.attrs.bind)) return intervals;
      const bands: number[][] = [];
      for (const b of sup.attrs.bind) {
        if (!b || !b.attrs || !b.attrs.params || b.attrs.params.type !== perpType) continue;
        if (vertical) {
          const sTop = b.attrs.y, sBot = b.attrs.y + (b.attrs.height || 0);
          bands.push([sTop - clearPx - hingeLengthPx / 2, sBot + clearPx + hingeLengthPx / 2]);
        } else {
          const pL = b.attrs.x, pR = b.attrs.x + (b.attrs.width || 0);
          bands.push([pL - clearPx - hingeLengthPx / 2, pR + clearPx + hingeLengthPx / 2]);
        }
      }
      for (const band of bands) {
        const next: number[][] = [];
        for (const [a, b] of intervals) {
          if (band[1] <= a || band[0] >= b) { next.push([a, b]); continue; }
          if (band[0] <= a && band[1] >= b) { continue; }
          if (band[0] > a && band[1] < b) { next.push([a, band[0]]); next.push([band[1], b]); continue; }
          if (band[0] <= a) { next.push([band[1], b]); continue; }
          next.push([a, band[0]]);
        }
        intervals = next.filter(([a, b]) => b > a);
      }
      return intervals;
    };
    const minCenterDistPx = ((sv['min_hinges_offset'] != null ? sv['min_hinges_offset'] : 0) / coefG) + hingeLengthPx;
    const inIntervals = (c: number, ivs: number[][]) => ivs.some(([a, b]) => c >= a - 1e-6 && c <= b + 1e-6);
    // Найближча точка в бік preferLow (менша координата: вгору / вліво), інакше — в інший бік.
    const directionalInIntervals = (c: number, ivs: number[][], preferLow: boolean): number | null => {
      let low: number = null, high: number = null;
      for (const [a, b] of ivs) {
        if (a <= c) { const v = Math.min(b, c); if (low == null || v > low) low = v; }
        if (b >= c) { const v = Math.max(a, c); if (high == null || v < high) high = v; }
      }
      return preferLow ? (low != null ? low : high) : (high != null ? high : low);
    };
    // Двосторонні петлі: якщо позиція потрапила в зону петлі з іншого боку опори — зсуваємо
    // спершу вгору (вертик.) / вправо (гориз.), якщо там немає місця — в інший бік. Не
    // перескакуємо через полицю/перегородку (шукаємо в межах того ж відрізка), не підходимо
    // до вже поставлених петель цієї ж дверки ближче за min_hinges_offset.
    const resolveDoubleSide = (cPx: number, intervals: number[][], oppBands: number[][], placedPx: number[],
                               preferLow: boolean, doorKey: any, idx: number): number => {
      if (oppBands.length === 0) return cPx;
      const full = this.subtractBands(intervals, oppBands);
      if (inIntervals(cPx, full)) return cPx;
      const ownBands = placedPx.map(c => [c - minCenterDistPx + 0.01, c + minCenterDistPx - 0.01]);
      const allowed = this.subtractBands(full, ownBands);
      const seg = intervals.find(([a, b]) => cPx >= a - 1e-6 && cPx <= b + 1e-6);
      const inSeg = seg ? allowed.filter(([a, b]) => b > seg[0] && a < seg[1])
        .map(([a, b]) => [Math.max(a, seg[0]), Math.min(b, seg[1])]) : [];
      const res = directionalInIntervals(cPx, inSeg.length ? inSeg : allowed, preferLow);
      if (res == null) {
        console.warn('[HINGE-PLACE] no place away from opposite-side hinge', {doorKey, idx, center_mm: Math.round(cPx * coefG)});
        return cPx;
      }
      return res;
    };
    const closestInIntervals = (c: number, intervals: number[][]): number | null => {
      if (intervals.length === 0) return null;
      let best: number = null, bestDist = Infinity;
      for (const [a, b] of intervals) {
        const cl = Math.max(a, Math.min(b, c));
        const d = Math.abs(cl - c);
        if (d < bestDist) { bestDist = d; best = cl; }
      }
      return best;
    };
    for (const item of prepared) {
      const door = item.door;
      const facade = item.facade;
      const orientation = item.orientation;
      const attachLine = item.attachLine;
      const sd = item.sd;
      // Зсув петлі від attachLine. Для перегородки (snapped) — flat/2 (бо attachLine=центр).
      // Для стіни (snapped=false) — залежить від типу фасаду:
      //   - inset (внутрішні): 0 → петля впритул до внутр. краю стіни (= краю фасаду).
      //   - overlay (зовнішні): flat → петля зсунута на товщину стіни всередину корпусу,
      //     щоб не "ховатись" під накладним фасадом.
      const facadeIsInset = door && door.attrs && door.attrs.params && door.attrs.params.isInset !== false;
      const faceOffsetPx = item.snapped
        ? flatPx / 2
        : (facadeIsInset ? 0 : flatPx);
      const doorKey = door._id;
      const ownerEl = item.ownerEl;
      const supportEl = item.supportEl; // ownerEl АБО стіна (для пристінних) — куди пушимо hingeBind
      // На перебудові на кроці фасадів — manual offsets скидаємо
      door.attrs.params.hingeManualOffsets = [];

      if (orientation === 'vertical') {
        const mountStartPx = ownerEl ? Math.max(door.attrs.y, ownerEl.attrs.y) : Math.max(door.attrs.y, cabInnerTop);
        const mountEndPx = ownerEl
          ? Math.min(door.attrs.y + facade.attrs.height, ownerEl.attrs.y + elLen(ownerEl, true))
          : Math.min(door.attrs.y + facade.attrs.height, cabInnerBottom);
        const formula = this.getHingePositionsMm(mountStartPx * coefG, (mountEndPx - mountStartPx) * coefG, 'vertical');
        // Будуємо валідні інтервали (з врахуванням смуг полиць/перегородок на опорі) і
        // знаходимо найближчу валідну позицію до формульної — щоб петля не виходила на полицю.
        const lo = mountStartPx + (minEdgeMmV / coefG) + hingeLengthPx / 2;
        const hi = mountEndPx - (minEdgeMmV / coefG) - hingeLengthPx / 2;
        const intervals = buildIntervals(lo, hi, supportEl, this.coef.id_element.shelf, minShelfClearMm / coefG, true);
        const oppBands = this.oppositeHingeBands(supportEl, doorKey, 'vertical');
        const placedPx: number[] = [];
        const display = formula.map((c, i) => {
          const cPx = c / coefG;
          const shifted = closestInIntervals(cPx, intervals);
          if (shifted == null) {
            console.warn('[HINGE-PLACE] no valid placement (entire support blocked)', {doorKey, idx: i, formula_mm: Math.round(c)});
            return c;
          }
          const finalPx = resolveDoubleSide(shifted, intervals, oppBands, placedPx, true, doorKey, i);
          placedPx.push(finalPx);
          return Math.round(finalPx * coefG);
        });
        const rectX = (sd === 'left') ? attachLine - faceOffsetPx - hingeThickPx : attachLine + faceOffsetPx;
        const followOffsetPx = rectX - attachLine;
        for (let i = 0; i < display.length; i++) {
          const centerMm = display[i];
          const hinge: any = new Konva.Rect({
            x: rectX,
            y: centerMm / coefG - hingeLengthPx / 2,
            width: hingeThickPx,
            height: hingeLengthPx,
            fill: 'rgba(255, 140, 0, 0.95)',
            stroke: 'black',
            strokeWidth: 0.5,
            listening: true,
            bind: [], // потрібно для циклів типу removeBindElement що ітерують element.attrs.bind
            params: {type: this.coef.id_element.hinge, autoFromHinged: true, isHinge: true,
                     doorKey: doorKey, hingeIndex: i, formulaCenterMm: formula[i], orientation: 'vertical',
                     followOffsetPx: followOffsetPx, supportEl: supportEl,
                     side: (sd === 'left' ? 'left' : 'right'),
                     isInset: facadeIsInset,
                     openingType: door.attrs.params.openingType || 'common'}
          });
          this.makeHingeDraggable(hinge, door, 'vertical', mountStartPx, mountEndPx);
          this.coef.shapesLayerw.add(hinge);
          if (supportEl && supportEl.attrs.params) (supportEl.attrs.params.hingeBind = supportEl.attrs.params.hingeBind || []).push(hinge);
        }
      } else {
        const mountStartPx = ownerEl ? Math.max(door.attrs.x, ownerEl.attrs.x) : Math.max(door.attrs.x, cabInnerLeft);
        const mountEndPx = ownerEl
          ? Math.min(door.attrs.x + facade.attrs.width, ownerEl.attrs.x + elLen(ownerEl, false))
          : Math.min(door.attrs.x + facade.attrs.width, cabInnerRight);
        const formula = this.getHingePositionsMm(mountStartPx * coefG, (mountEndPx - mountStartPx) * coefG, 'horizontal');
        const lo = mountStartPx + (minEdgeMmH / coefG) + hingeLengthPx / 2;
        const hi = mountEndPx - (minEdgeMmH / coefG) - hingeLengthPx / 2;
        const intervals = buildIntervals(lo, hi, supportEl, this.coef.id_element.partition, minPartClearMm / coefG, false);
        const oppBands = this.oppositeHingeBands(supportEl, doorKey, 'horizontal');
        const placedPx: number[] = [];
        const display = formula.map((c, i) => {
          const cPx = c / coefG;
          const shifted = closestInIntervals(cPx, intervals);
          if (shifted == null) {
            console.warn('[HINGE-PLACE] no valid placement (entire support blocked)', {doorKey, idx: i, formula_mm: Math.round(c)});
            return c;
          }
          const finalPx = resolveDoubleSide(shifted, intervals, oppBands, placedPx, false, doorKey, i);
          placedPx.push(finalPx);
          return Math.round(finalPx * coefG);
        });
        const rectY = (sd === 'up') ? attachLine - faceOffsetPx - hingeThickPx : attachLine + faceOffsetPx;
        const followOffsetPx = rectY - attachLine;
        for (let i = 0; i < display.length; i++) {
          const centerMm = display[i];
          const hinge: any = new Konva.Rect({
            x: centerMm / coefG - hingeLengthPx / 2,
            y: rectY,
            width: hingeLengthPx,
            height: hingeThickPx,
            fill: 'rgba(255, 140, 0, 0.95)',
            stroke: 'black',
            strokeWidth: 0.5,
            listening: true,
            bind: [], // потрібно для циклів типу removeBindElement що ітерують element.attrs.bind
            params: {type: this.coef.id_element.hinge, autoFromHinged: true, isHinge: true,
                     doorKey: doorKey, hingeIndex: i, formulaCenterMm: formula[i], orientation: 'horizontal',
                     followOffsetPx: followOffsetPx, supportEl: supportEl,
                     side: (sd === 'up' ? 'left' : 'right'),
                     isInset: facadeIsInset,
                     openingType: door.attrs.params.openingType || 'common'}
          });
          this.makeHingeDraggable(hinge, door, 'horizontal', mountStartPx, mountEndPx);
          this.coef.shapesLayerw.add(hinge);
          if (supportEl && supportEl.attrs.params) (supportEl.attrs.params.hingeBind = supportEl.attrs.params.hingeBind || []).push(hinge);
        }
      }
    }
    this.coef.shapesLayerw.batchDraw();
    // Рендеримо розміри петель для кожної опори (край→центр, центр→центр, центр→край)
    for (const s of supportsSeen) this.renderHingeDimensions(s);
    // Живі оновлення: СЕЛЕКТИВНО за target. Юзерські елементи не впливають на геометрію
    // наших опор → не ререндеримо їх (інакше — мигання). Для петлі — її supportEl,
    // для нашої auto-полиці/перегородки — самого elem (петлі їдуть з ним).
    this.coef.shapesLayerw.off('dragmove.hingedims');
    this.coef.shapesLayerw.on('dragmove.hingedims', (e: any) => {
      const t = e && e.target;
      if (!t || !t.attrs || !t.attrs.params) return;
      const tp = t.attrs.params;
      if (tp.isHinge && tp.supportEl) {
        this.renderHingeDimensions(tp.supportEl);
        return;
      }
      if (tp.autoFromHinged
          && (tp.type === this.coef.id_element.shelf || tp.type === this.coef.id_element.partition)) {
        this.renderHingeDimensions(t);
        // Якщо рух нашої auto ресайзить сусідню НАШУ auto з петлями (через bind) —
        // оновлюємо і її розміри. Юзерські сусіди не торкаємо (не мають hingeBind).
        if (Array.isArray(t.attrs.bind)) {
          for (const b of t.attrs.bind) {
            const bp = b && b.attrs && b.attrs.params;
            if (!bp || !bp.autoFromHinged) continue;
            const hb = bp.hingeBind;
            if (!Array.isArray(hb) || hb.length === 0) continue;
            this.renderHingeDimensions(b);
          }
        }
        return;
      }
      // юзерський елемент — нічого не ререндеримо
    });
    // Контури фасадів (пунктир) + кнопка перемикача — поверх корпусу.
    this.renderFacadeOutlines(prepared);
    this.renderFacadeToggleButton();
    // Заборонити drag auto-перегородок/полиць ЯКЩО на них сидять петлі (юзер тоді не може
    // зрушити). Перегородки без петель — драгабельні як раніше.
    if (this.coef.shapesLayerw && this.coef.shapesLayerw.children) {
      for (const el of this.coef.shapesLayerw.children) {
        const p = el && el.attrs && el.attrs.params;
        if (!p || !p.autoFromHinged) continue;
        if (p.type !== this.coef.id_element.partition && p.type !== this.coef.id_element.shelf) continue;
        const hasHinges = Array.isArray(p.hingeBind) && p.hingeBind.length > 0;
        el.draggable(!hasHinges);
      }
    }
    console.log('[HINGED] syncHingesToCorpus', {doors: doors.length});
  }

  // Пунктирні контури фасадів — на окремому шарі. Жодних взаємодій з shapesLayerw.children.
  renderFacadeOutlines(prepared: any[]) {
    if (this.facadeOutlinesGroup && this.facadeOutlinesGroup.destroy) {
      this.facadeOutlinesGroup.destroy();
    }
    this.facadeOutlinesGroup = null;
    if (!prepared || prepared.length === 0) return;
    const layer = this.ensureFacadeHintsLayer();
    if (!layer) return;
    const group = new Konva.Group({listening: false, params: {isFacadeOutline: true}});
    for (const it of prepared) {
      const door = it && it.door;
      const facade = it && it.facade;
      if (!door || !facade) continue;
      const rect = new Konva.Rect({
        x: door.attrs.x,
        y: door.attrs.y,
        width: facade.attrs.width,
        height: facade.attrs.height,
        fill: undefined,
        stroke: '#2d7ee7',          /* primary blue з панелі — узгоджуємо з кнопкою */
        strokeWidth: 0.7,
        dash: [6, 4],
        listening: false
      });
      group.add(rect);
    }
    group.visible(this.facadeOutlinesVisible);
    layer.add(group);
    this.facadeOutlinesGroup = group;
    layer.batchDraw();
  }

  // Кнопка-перемикач — теж на окремому шарі.
  renderFacadeToggleButton() {
    if (this.facadeToggleButton && this.facadeToggleButton.destroy) {
      this.facadeToggleButton.destroy();
    }
    this.facadeToggleButton = null;
    const layer = this.ensureFacadeHintsLayer();
    if (!layer) return;
    const coefG = this.coef.global_coef;
    const cabW = this.coef.setingsWardrobe.width / coefG;
    const centerPosition = (this.coef.widthWrapper - cabW) / 2;
    const depthX = centerPosition + cabW / 2 - 20;
    const depthY = this.coef.heightWrapper - 20;
    const btnX = depthX + 110;
    const btnY = depthY - 10;   // підняли на 6px щоб кнопка h=26 не виходила за низ canvas
    const w = 140, h = 26;
    const group = new Konva.Group({x: btnX, y: btnY, listening: true, params: {isFacadeToggle: true}});
    const bg = new Konva.Rect({
      x: 0, y: 0, width: w, height: h,
      fill: 'white', stroke: '#2d7ee7', strokeWidth: 1, cornerRadius: 4, listening: true
    });
    // Konva 2.1.3 не підтримує verticalAlign — центруємо по Y вручну через y offset.
    const fontSize = 13;
    const label = new Konva.Text({
      x: 0,
      y: (h - fontSize) / 2,
      width: w,
      align: 'center',
      text: this.facadeOutlinesVisible ? 'Сховати фасади' : 'Показати фасади',
      fontSize: fontSize,
      fontFamily: 'FSElliotPro, Arial, sans-serif',
      fill: '#2d7ee7',
      listening: false
    });
    group.add(bg, label);
    const stage = layer.getStage && layer.getStage();
    group.on('mouseenter', () => { if (stage && stage.container && stage.container()) stage.container().style.cursor = 'pointer'; });
    group.on('mouseleave', () => { if (stage && stage.container && stage.container()) stage.container().style.cursor = 'default'; });
    group.on('click', (e: any) => {
      if (e && e.cancelBubble !== undefined) e.cancelBubble = true;
      this.facadeOutlinesVisible = !this.facadeOutlinesVisible;
      if (this.facadeOutlinesGroup) this.facadeOutlinesGroup.visible(this.facadeOutlinesVisible);
      label.text(this.facadeOutlinesVisible ? 'Сховати фасади' : 'Показати фасади');
      layer.batchDraw();
    });
    layer.add(group);
    this.facadeToggleButton = group;
    layer.batchDraw();
  }

  // Збір фасадів для бекенду (price + save). Плоский список листів дерева (door/drawers/open)
  // з координатами у Konva-px (як класичні шафи). Для дверей — масив петель за doorKey.
  collectFacadesForBackend(): any[] {
    const result: any[] = [];
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return result;
    const defaultColorId = this.coef.facade_color_id != null ? this.coef.facade_color_id : null;
    // Згрупувати всі петлі за doorKey (значенням _id дверки)
    const hingesByDoor: any = {};
    if (this.coef.shapesLayerw && this.coef.shapesLayerw.children) {
      for (const c of this.coef.shapesLayerw.children) {
        const p = c.attrs && c.attrs.params;
        if (!p || !p.isHinge) continue;
        const key = p.doorKey;
        if (key == null) continue;
        if (!hingesByDoor[key]) hingesByDoor[key] = [];
        const supParams = p.supportEl && p.supportEl.attrs && p.supportEl.attrs.params;
        hingesByDoor[key].push({
          x: c.attrs.x,
          y: c.attrs.y,
          width: c.attrs.width || 0,
          height: c.attrs.height || 0,
          orientation: p.orientation || null,
          hinge_index: p.hingeIndex != null ? p.hingeIndex : null,
          support_type: supParams ? supParams.type : null,
          opening_type: p.openingType || 'common',
          hinge_type: this.hingeTypeOf(c)
        });
      }
    }
    // Рекурсивний обхід дерева
    const walk = (zone: any) => {
      const p = zone && zone.attrs && zone.attrs.params;
      if (!p) return;
      if (p.isContainer) {
        for (const c of (p.children || [])) walk(c);
        return;
      }
      // Лист — фасад. Координати + розмір беремо з самого group + його першої дитини (Konva.Rect).
      const facadeChild = zone.children && zone.children[0];
      const w = facadeChild ? (facadeChild.attrs.width || 0) : 0;
      const h = facadeChild ? (facadeChild.attrs.height || 0) : 0;
      const kind = p.sectionKind || null;
      const obj: any = {
        x: zone.attrs.x,
        y: zone.attrs.y,
        width: w,
        height: h,
        kind: kind,
        facade_number: p.facadeNumber != null ? p.facadeNumber : null,
        color_id: p.facadeMaterialId != null ? p.facadeMaterialId : defaultColorId,
        facade_option_id: p.facadeOptionId != null ? p.facadeOptionId : null,
        isTextureReversed: !!p.isTextureReversed,
        is_inset: !!p.isInset
      };
      if (kind === 'door') {
        obj.swing_dir = p.swingDir || null;
        obj.opening_type = p.openingType || 'common';
        obj.hinges = hingesByDoor[zone._id] || [];
      } else if (kind === 'drawers') {
        obj.drawer_sub_id = p.drawerSubId != null ? p.drawerSubId : null;
      }
      result.push(obj);
    };
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c && c.attrs && c.attrs.params;
      if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
      if (p.depth !== 1) continue;
      walk(c);
    }
    return result;
  }

  // Вкладене дерево фасадів для ВІДНОВЛЕННЯ (edit) ордера. На відміну від collectFacadesForBackend
  // (плоский список для виробництва) — тут зберігаємо структуру: контейнери з напрямком,
  // позиції сплітерів, і всі параметри leaf-ів. Достатньо щоб повторити sequence дій юзера.
  collectFacadeTreeForBackend(): any[] {
    const result: any[] = [];
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return result;
    const splitterToScalar = (s: any) => {
      if (!s || !s.attrs) return null;
      const sp = s.attrs.params || {};
      return {
        splitter_id: sp.splitterId != null ? sp.splitterId : null,
        x: s.attrs.x,
        y: s.attrs.y,
        width: s.attrs.width || 0,
        height: s.attrs.height || 0,
        manual_gap_offset: sp.manualGapOffset != null ? sp.manualGapOffset : 0
      };
    };
    const nodeToScalar = (zone: any): any => {
      const p = zone && zone.attrs && zone.attrs.params;
      if (!p) return null;
      const facadeChild = zone.children && zone.children[0];
      const w = facadeChild ? (facadeChild.attrs.width || 0) : 0;
      const h = facadeChild ? (facadeChild.attrs.height || 0) : 0;
      const obj: any = {
        x: zone.attrs.x,
        y: zone.attrs.y,
        width: w,
        height: h,
        depth: p.depth != null ? p.depth : null,
        zone_name: p.zoneName || null,
        is_inset: !!p.isInset
      };
      if (p.isContainer) {
        obj.node_type = 'container';
        obj.container_direction = p.containerDirection || null;
        obj.splitters = (p.innerSplitters || []).map(splitterToScalar).filter((x: any) => x);
        obj.children = (p.children || []).map(nodeToScalar).filter((x: any) => x);
      } else {
        obj.node_type = 'leaf';
        obj.kind = p.sectionKind || null;
        obj.facade_number = p.facadeNumber != null ? p.facadeNumber : null;
        obj.color_id = p.facadeMaterialId != null ? p.facadeMaterialId : null;
        obj.facade_option_id = p.facadeOptionId != null ? p.facadeOptionId : null;
        obj.isTextureReversed = !!p.isTextureReversed;
        if (p.sectionKind === 'door') {
          obj.swing_dir = p.swingDir || null;
          obj.opening_type = p.openingType || 'common';
          // manual hinge offsets (per-door) — для точного відновлення позицій петель
          obj.hinge_manual_offsets = Array.isArray(p.hingeManualOffsets) ? p.hingeManualOffsets.slice() : [];
        } else if (p.sectionKind === 'drawers') {
          obj.drawer_sub_id = p.drawerSubId != null ? p.drawerSubId : null;
        }
      }
      return obj;
    };
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c && c.attrs && c.attrs.params;
      if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
      if (p.depth !== 1) continue;
      const node = nodeToScalar(c);
      if (node) result.push(node);
    }
    return result;
  }

  // Відновлення фасадного дерева на edit. Корені вже створені у initHingedRootZones (1 main або 2
  // при stik з double_partition). Тут "програємо" збережені user-actions: спочатку контейнери
  // (splitInto + рух сплітерів), потім лісти (kind/swing/openingType/drawerSubId/color/option),
  // а manual offsets петель застосовуємо вже ПІСЛЯ фінального syncPartitionsToCorpus.
  restoreFromTree(tree: any[]) {
    console.log('[HINGED-RESTORE] start', {
      tree_is_array: Array.isArray(tree),
      tree_length: Array.isArray(tree) ? tree.length : null,
      has_DoorWrapper: !!this.coefDoor.DoorWrapper,
      DoorWrapper_children: this.coefDoor.DoorWrapper && this.coefDoor.DoorWrapper.children
        ? this.coefDoor.DoorWrapper.children.length : null
    });
    if (!Array.isArray(tree) || tree.length === 0) {
      console.warn('[HINGED-RESTORE] EARLY RETURN: tree empty or not array');
      return;
    }
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) {
      console.warn('[HINGED-RESTORE] EARLY RETURN: no DoorWrapper or children');
      return;
    }
    // Парні (root, node). Root-и шукаємо за depth=1 у DoorWrapper, у тому ж порядку, що і в save.
    const roots: any[] = [];
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c && c.attrs && c.attrs.params;
      if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
      if (p.depth !== 1) continue;
      roots.push(c);
    }
    console.log('[HINGED-RESTORE] roots found', {
      live_roots_count: roots.length,
      tree_roots_count: tree.length,
      id_element_hinged_facade_section: this.coef.id_element.hinged_facade_section
    });
    if (roots.length !== tree.length) {
      console.warn('[HINGED-RESTORE] root count mismatch', {tree_roots: tree.length, live_roots: roots.length});
    }
    const n = Math.min(roots.length, tree.length);
    this.restoring = true;
    try {
      for (let i = 0; i < n; i++) {
        console.log('[HINGED-RESTORE] entering root', i, {tree_node: tree[i], live_root_params: roots[i] && roots[i].attrs && roots[i].attrs.params});
        this.restoreNode(tree[i], roots[i]);
      }
    } finally {
      this.restoring = false;
    }
    // Один фінальний rebuild — отримуємо актуальні auto-перегородки/полиці/петлі/розміри/зони.
    console.log('[HINGED-RESTORE] before final syncPartitionsToCorpus');
    this.syncPartitionsToCorpus();
    // Накладаємо збережені ручні офсети петель на щойно створені петлі.
    this._applyPendingHingeManualOffsets();
    console.log('[HINGED-RESTORE] done', {roots: n});
  }

  private restoreNode(node: any, zone: any) {
    console.log('[HINGED-RESTORE] restoreNode', {
      node_type: node && node.node_type,
      kind: node && node.kind,
      zone_name: node && node.zone_name,
      has_zone: !!zone,
      zone_params: zone && zone.attrs && zone.attrs.params
    });
    if (!node || !zone || !zone.attrs || !zone.attrs.params) {
      console.warn('[HINGED-RESTORE] restoreNode EARLY RETURN: invalid args');
      return;
    }
    if (node.node_type === 'container') {
      const dir = node.container_direction;
      const children = Array.isArray(node.children) ? node.children : [];
      const splitters = Array.isArray(node.splitters) ? node.splitters : [];
      if (dir !== 'cols' && dir !== 'rows') {
        console.warn('[HINGED-RESTORE] container missing direction', node);
        return;
      }
      if (children.length < 2) {
        console.warn('[HINGED-RESTORE] container with <2 children', node);
        return;
      }
      console.log('[HINGED-RESTORE] calling splitInto', {dir, children_count: children.length, zone_name: node.zone_name});
      this.splitInto(zone, dir, children.length);
      console.log('[HINGED-RESTORE] after splitInto', {
        innerSplitters_count: (zone.attrs.params.innerSplitters || []).length,
        children_count: (zone.attrs.params.children || []).length
      });
      const liveSplitters = zone.attrs.params.innerSplitters || [];
      const liveChildren = zone.attrs.params.children || [];
      // Рух сплітерів до збережених позицій (резайз сусідів через існуючу dragmove-логіку).
      const sCount = Math.min(liveSplitters.length, splitters.length);
      for (let i = 0; i < sCount; i++) {
        const saved = splitters[i];
        const splitter = liveSplitters[i];
        if (!splitter || !saved) continue;
        const isVertical = dir === 'cols';
        if (isVertical && saved.x != null) {
          splitter.x(saved.x);
        } else if (!isVertical && saved.y != null) {
          splitter.y(saved.y);
        }
        splitter.fire('dragmove');
        if (saved.manual_gap_offset != null) {
          splitter.attrs.params.manualGapOffset = saved.manual_gap_offset;
        }
      }
      // Recursive
      const cCount = Math.min(liveChildren.length, children.length);
      for (let i = 0; i < cCount; i++) {
        this.restoreNode(children[i], liveChildren[i]);
      }
      return;
    }
    // leaf
    const params = zone.attrs.params;
    if (node.color_id != null) params.facadeMaterialId = node.color_id;
    if (node.facade_option_id != null) params.facadeOptionId = node.facade_option_id;
    params.isTextureReversed = !!node.isTextureReversed;
    if (node.kind === 'drawers' && node.drawer_sub_id != null) {
      params.drawerSubId = node.drawer_sub_id;
    }
    if (node.kind === 'door') {
      params.openingType = node.opening_type || 'common';
      // Запам'ятаємо офсети на час фінального sync (sync обнулить hingeManualOffsets).
      if (Array.isArray(node.hinge_manual_offsets) && node.hinge_manual_offsets.length > 0) {
        params._pendingHingeManualOffsets = node.hinge_manual_offsets.slice();
      }
    }
    if (node.kind === 'door' || node.kind === 'open' || node.kind === 'drawers') {
      this.applySectionKind(zone, node.kind);
    }
    if (node.kind === 'door' && node.swing_dir) {
      this.applySwingDir(zone, node.swing_dir);
    }
  }

  // Після фінального syncPartitionsToCorpus петлі створено наново (offsets обнулено).
  // Накладаємо збережені офсети на кожну петлю за doorKey/hingeIndex.
  private _applyPendingHingeManualOffsets() {
    if (!this.coef.shapesLayerw || !this.coef.shapesLayerw.children) return;
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return;
    const coefG = this.coef.global_coef;
    // Збираємо всі двері з pending-офсетами
    const pendingByDoor: any = {};
    const doorByKey: any = {};
    const collect = (zone: any) => {
      const p = zone && zone.attrs && zone.attrs.params;
      if (!p) return;
      if (p.isContainer) {
        for (const c of (p.children || [])) collect(c);
        return;
      }
      if (Array.isArray(p._pendingHingeManualOffsets) && p._pendingHingeManualOffsets.length > 0) {
        pendingByDoor[zone._id] = p._pendingHingeManualOffsets;
        doorByKey[zone._id] = zone;
      }
    };
    for (const c of this.coefDoor.DoorWrapper.children) {
      const p = c && c.attrs && c.attrs.params;
      if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
      if (p.depth !== 1) continue;
      collect(c);
    }
    let appliedCount = 0;
    // Збираємо унікальні supportEl'и петель що були зсунуті — щоб у кінці перерахувати їхні
    // підписи розмірів. Інакше підписи лишаються від формульних позицій і не збігаються з
    // реальними (треба тиснути drag щоб тригернути 'dragmove.hingedims').
    const touchedSupports = new Set<any>();
    for (const hinge of this.coef.shapesLayerw.children) {
      const hp = hinge && hinge.attrs && hinge.attrs.params;
      if (!hp || !hp.isHinge) continue;
      const offsets = pendingByDoor[hp.doorKey];
      if (!offsets) continue;
      const idx = hp.hingeIndex;
      if (idx == null || idx < 0 || idx >= offsets.length) continue;
      const deltaMm = offsets[idx];
      if (!deltaMm) continue;
      const deltaPx = deltaMm / coefG;
      if (hp.orientation === 'vertical') hinge.y(hinge.attrs.y + deltaPx);
      else hinge.x(hinge.attrs.x + deltaPx);
      if (hp.supportEl) touchedSupports.add(hp.supportEl);
      appliedCount++;
    }
    // Зберігаємо офсети в hingeManualOffsets дверки (sync обнуляє), щоб save-round-trip працював.
    for (const key in pendingByDoor) {
      const door = doorByKey[key];
      if (door && door.attrs && door.attrs.params) {
        door.attrs.params.hingeManualOffsets = pendingByDoor[key].slice();
        delete door.attrs.params._pendingHingeManualOffsets;
      }
    }
    if (appliedCount > 0) {
      // Перерахувати підписи розмірів петель для усіх affected supports — інакше підписи
      // залишаються від формульних позицій, а петлі вже на manual-offsets.
      touchedSupports.forEach((s: any) => this.renderHingeDimensions(s));
      this.coef.shapesLayerw.batchDraw();
    }
    console.log('[HINGED-RESTORE] applied hinge offsets', {applied: appliedCount, doors: Object.keys(pendingByDoor).length, supportsRerendered: touchedSupports.size});
  }

  // Вільний проміжок по осі руху (для "впирається" під час драгу): межі, в яких елемент
  // може рухатись, не наїхавши на петлю. Знаходимо петлі ЧЕРЕЗ BIND (relevantHinges),
  // а не геометричним сканом. Повертає {min, max} для верху полиці (Y) / лівого краю перегородки (X).
  hingeGapForMove(elem: any, excludeHinges?: any[]): {min: number, max: number} {
    const res = {min: -1e9, max: 1e9};
    if (!this.coef.shapesLayerw || !elem || !elem.attrs) return res;
    const p = elem.attrs.params || {};
    const kind: 'shelf' | 'partition' = (p.type === this.coef.id_element.shelf) ? 'shelf' : 'partition';
    const coefG = this.coef.global_coef;
    const sv = this.coef.spec_values || {};
    const x = elem.attrs.x, y = elem.attrs.y;
    const w = elem.attrs.width || 0, h = elem.attrs.height || 0;
    const hinges = this.relevantHinges(elem, kind, excludeHinges);
    // === ДІАГНОСТИКА: показує, що бачить bind-обхід для цієї полиці/перегородки ===
    const c = p.contours;
    const tName = (e: any) => (e && e.attrs && e.attrs.params && e.attrs.params.type);
    const hbLen = (e: any) => (e && e.attrs && e.attrs.params && Array.isArray(e.attrs.params.hingeBind) ? e.attrs.params.hingeBind.length : -1);
    // (лог нижче доповнимо проміжком + y0 після обчислення)
    let dbgPosMm = 0;
    const dbgBands: any[] = [];
    if (kind === 'shelf') {
      const minClearPx = (sv['min_shelf_hinge_offset'] != null ? sv['min_shelf_hinge_offset'] : 0) / coefG;
      const y0 = y;
      dbgPosMm = Math.round(y0 * coefG);
      for (const el of hinges) {
        const a = el.attrs.y - minClearPx - h;
        const b = el.attrs.y + (el.attrs.height || 0) + minClearPx;
        const aMm = Math.round(a * coefG), bMm = Math.round(b * coefG);
        const branch = (b <= y0) ? 'min<-b' : (a >= y0) ? 'max<-a' : 'straddle (ignored)';
        dbgBands.push({a_mm: aMm, b_mm: bMm, branch});
        if (b <= y0) res.min = Math.max(res.min, b);
        else if (a >= y0) res.max = Math.min(res.max, a);
      }
      // Полиця може ресайзити перегородку з петлями (якщо вона є contours.top АБО contours.bottom).
      // Тоді край перегородки не має наблизитись до крайньої петлі ближче за min_hinge_vertical_edge_offset.
      // Пошук: проходимо всі перегородки з hingeBind і дивимось чий контур = ця полиця (НЕ через bind).
      // Межі ОБОВ'ЯЗКОВО снапаємо на сітку shelf_facade_gap_step від стартового y (інакше виходить
      // "9 + 1 мм" замість суворого кроку).
      const minEdgePx = (sv['min_hinge_vertical_edge_offset'] != null ? sv['min_hinge_vertical_edge_offset']
        : (sv['hinge_vertical_edge_offset'] != null ? sv['hinge_vertical_edge_offset'] : 70)) / coefG;
      const stepPx = (sv['shelf_facade_gap_step'] != null ? sv['shelf_facade_gap_step'] : 1) / coefG;
      const snapMax = (raw: number) => y + stepPx * Math.floor((raw - y) / stepPx);
      const snapMin = (raw: number) => y + stepPx * Math.ceil((raw - y) / stepPx);
      for (const part of this.coef.shapesLayerw.children) {
        const pp = part && part.attrs && part.attrs.params;
        if (!pp || pp.type !== this.coef.id_element.partition) continue;
        const hb = pp.hingeBind;
        if (!Array.isArray(hb) || hb.length === 0) continue;
        const cn = pp.contours;
        const isTopContour = cn && cn.top === elem;
        const isBottomContour = cn && cn.bottom === elem;
        if (!isTopContour && !isBottomContour) continue;
        let topHy = +Infinity, botHy = -Infinity;
        for (const hg of hb) {
          if (!hg || !hg.attrs || !hg.attrs.params || !hg.attrs.params.isHinge) continue;
          const hgTop = hg.attrs.y;
          const hgBot = hg.attrs.y + (hg.attrs.height || 0);
          if (hgTop < topHy) topHy = hgTop;
          if (hgBot > botHy) botHy = hgBot;
        }
        if (topHy === +Infinity) continue;
        if (isTopContour) {
          // полиця = top-контур → partTop = shelf.y + h. Має бути partTop <= topHy - minEdgePx.
          res.max = Math.min(res.max, snapMax(topHy - minEdgePx - h));
        } else {
          // полиця = bottom-контур → partBot = shelf.y. Має бути partBot >= botHy + minEdgePx.
          res.min = Math.max(res.min, snapMin(botHy + minEdgePx));
        }
      }
    } else {
      const minClearPx = (sv['min_partition_hinge_offset'] != null ? sv['min_partition_hinge_offset'] : 0) / coefG;
      const x0 = x;
      dbgPosMm = Math.round(x0 * coefG);
      for (const el of hinges) {
        const a = el.attrs.x - minClearPx - w;
        const b = el.attrs.x + (el.attrs.width || 0) + minClearPx;
        const aMm = Math.round(a * coefG), bMm = Math.round(b * coefG);
        const branch = (b <= x0) ? 'min<-b' : (a >= x0) ? 'max<-a' : 'straddle (ignored)';
        dbgBands.push({a_mm: aMm, b_mm: bMm, branch});
        if (b <= x0) res.min = Math.max(res.min, b);
        else if (a >= x0) res.max = Math.min(res.max, a);
      }
      // Симетрично: користувацька перегородка може ресайзити полицю з петлями (горизонтальні дверки).
      // Пошук — через contours: перегородка є contours.left АБО contours.right полиці з hingeBind.
      // Снапаємо на сітку partition_facade_gap_step від стартового x.
      const minEdgePx = (sv['min_hinge_horizontal_edge_offset'] != null ? sv['min_hinge_horizontal_edge_offset']
        : (sv['hinge_horizontal_edge_offset'] != null ? sv['hinge_horizontal_edge_offset'] : 70)) / coefG;
      const stepPx = (sv['partition_facade_gap_step'] != null ? sv['partition_facade_gap_step'] : 1) / coefG;
      const snapMax = (raw: number) => x + stepPx * Math.floor((raw - x) / stepPx);
      const snapMin = (raw: number) => x + stepPx * Math.ceil((raw - x) / stepPx);
      for (const shf of this.coef.shapesLayerw.children) {
        const sp = shf && shf.attrs && shf.attrs.params;
        if (!sp || sp.type !== this.coef.id_element.shelf) continue;
        const hb = sp.hingeBind;
        if (!Array.isArray(hb) || hb.length === 0) continue;
        const cn = sp.contours;
        const isLeftContour = cn && cn.left === elem;
        const isRightContour = cn && cn.right === elem;
        if (!isLeftContour && !isRightContour) continue;
        let leftHx = +Infinity, rightHx = -Infinity;
        for (const hg of hb) {
          if (!hg || !hg.attrs || !hg.attrs.params || !hg.attrs.params.isHinge) continue;
          const hgL = hg.attrs.x;
          const hgR = hg.attrs.x + (hg.attrs.width || 0);
          if (hgL < leftHx) leftHx = hgL;
          if (hgR > rightHx) rightHx = hgR;
        }
        if (leftHx === +Infinity) continue;
        if (isLeftContour) {
          // перегородка = лівий контур → shelf_left = part.x + w. Має бути <= leftHx - minEdgePx.
          res.max = Math.min(res.max, snapMax(leftHx - minEdgePx - w));
        } else {
          // перегородка = правий контур → shelf_right = part.x. Має бути >= rightHx + minEdgePx.
          res.min = Math.max(res.min, snapMin(rightHx + minEdgePx));
        }
      }
    }
    // Зони шухляд блокують ТІЛЬКИ ЮЗЕРСЬКІ елементи (без autoFromHinged). Наші auto-елементи
    // (top/bottom полиці, left/right перегородки) рухаються вільно — або проходять, або
    // ресайзять зону через `dragmove.drawerZoneFollow`.
    if (!p.autoFromHinged && this.coef.shapesLayerw.children) {
      for (const dz of this.coef.shapesLayerw.children) {
        const dp = dz && dz.attrs && dz.attrs.params;
        if (!dp || !dp.isDrawerZone) continue;
        const bg = dz.children && dz.children[0];
        const zX = dz.attrs.x;
        const zY = dz.attrs.y;
        const zW = bg ? (bg.attrs.width || 0) : 0;
        const zH = bg ? (bg.attrs.height || 0) : 0;
        if (kind === 'shelf') {
          // overlap по X? Якщо ні — зона не в дорозі.
          if (x + w < zX || x > zX + zW) continue;
          const a = zY - h;
          const b = zY + zH;
          if (b <= y) res.min = Math.max(res.min, b);
          else if (a >= y) res.max = Math.min(res.max, a);
        } else {
          // partition: overlap по Y?
          if (y + h < zY || y > zY + zH) continue;
          const a = zX - w;
          const b = zX + zW;
          if (b <= x) res.min = Math.max(res.min, b);
          else if (a >= x) res.max = Math.min(res.max, a);
        }
      }
    }
    console.log('[HINGE-GAP-BIND]', {
      kind,
      autoFromHinged: !!p.autoFromHinged,
      hasContours: !!c,
      contourTypes: c ? {left: tName(c.left), right: tName(c.right), top: tName(c.top), bottom: tName(c.bottom)} : null,
      contourHingeBindLen: c ? {left: hbLen(c.left), right: hbLen(c.right), top: hbLen(c.top), bottom: hbLen(c.bottom)} : null,
      bindTypes: (elem.attrs.bind || []).map((b: any) => tName(b)),
      bindHingeBindLen: (elem.attrs.bind || []).map((b: any) => hbLen(b)),
      excludeCount: (excludeHinges || []).length,
      hingesFound: hinges.length,
      pos_mm: dbgPosMm,
      bands_mm: dbgBands,
      gap_mm: {
        min: res.min === -1e9 ? '-inf' : Math.round(res.min * coefG),
        max: res.max === 1e9 ? 'inf' : Math.round(res.max * coefG)
      }
    });
    return res;
  }

  // Композитний знімок для facadeImage (3-й крок). Бере DoorWrapper (facade-панелі) як основу,
  // додає петлі з shapesLayerw (тимчасово ховаючи решту), і малює власні dim-вузли від
  // країв ФАСАДУ (а не від країв опори) до центрів петель. Стан сцен НЕ міняє після виходу:
  // try/finally відновлює visibility навіть якщо щось впаде.
  async composeFacadeImageWithHinges(): Promise<string | null> {
    try {
      const doorWrapper = this.coefDoor.DoorWrapper;
      const shapesLayer = this.coef.shapesLayerw;
      if (!doorWrapper || !shapesLayer) return null;
      const doorStage = doorWrapper.getStage && doorWrapper.getStage();
      if (!doorStage) return null;
      const w = doorStage.width();
      const h = doorStage.height();
      const coefG = this.coef.global_coef;

      // 1. База — DoorWrapper як є
      const baseURL = doorWrapper.toDataURL({pixelRatio: 1});

      // 2. Петлі — ховаємо все на shapesLayerw крім isHinge, робимо знімок, відновлюємо
      const hidden: any[] = [];
      try {
        if (shapesLayer.children) {
          for (const c of shapesLayer.children) {
            const p = c && c.attrs && c.attrs.params;
            if (!p || !p.isHinge) {
              if (c.visible && c.visible()) {
                c.visible(false);
                hidden.push(c);
              }
            }
          }
          shapesLayer.batchDraw();
        }
        var hingeURL: string = shapesLayer.toDataURL({pixelRatio: 1});
      } finally {
        for (const c of hidden) { if (c.visible) c.visible(true); }
        shapesLayer.batchDraw();
      }

      // 3. Тимчасовий canvas для composite
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      if (!ctx) return null;

      // 4. Завантажити обидва images і намалювати
      const loadImg = (url: string): Promise<HTMLImageElement> => new Promise((resolve, reject) => {
        const im = new Image();
        im.onload = () => resolve(im);
        im.onerror = reject;
        im.src = url;
      });
      const [baseImg, hingeImg] = await Promise.all([loadImg(baseURL), loadImg(hingeURL)]);
      ctx.drawImage(baseImg, 0, 0);
      ctx.drawImage(hingeImg, 0, 0);

      // 5. Малюємо власні dim-вузли від країв ФАСАДУ до центрів петель.
      // Знаходимо всі door-leaf у дереві DoorWrapper.
      const doorLeaves: any[] = [];
      const walk = (zone: any) => {
        const p = zone && zone.attrs && zone.attrs.params;
        if (!p) return;
        if (p.isContainer) {
          for (const c of (p.children || [])) walk(c);
          return;
        }
        if (p.sectionKind === 'door') doorLeaves.push(zone);
      };
      for (const c of doorWrapper.children) {
        const p = c && c.attrs && c.attrs.params;
        if (!p || p.type !== this.coef.id_element.hinged_facade_section) continue;
        if (p.depth !== 1) continue;
        walk(c);
      }

      // Стилі — як у renderHingeDimensions
      const stroke = 'rgba(0,0,0,0.55)';
      const textFill = 'rgba(0,0,0,0.85)';
      const strokeW = 0.5;
      const tick = 4;       // pixel-canvas одиниці
      const gutter = 25;    // відступ dim-line від краю фасаду
      const fontSize = 9;
      ctx.font = `${fontSize}px Calibri`;
      ctx.lineWidth = strokeW;
      ctx.strokeStyle = stroke;
      ctx.fillStyle = textFill;

      // Для кожної door-leaf шукаємо її петлі за doorKey
      for (const door of doorLeaves) {
        const doorKey = door._id;
        const facadeRect = door.children && door.children[0];
        if (!facadeRect) continue;
        const fw = facadeRect.attrs.width || 0;
        const fh = facadeRect.attrs.height || 0;
        const dx = door.attrs.x;
        const dy = door.attrs.y;

        // Збираємо петлі цієї дверки
        const myHinges: any[] = [];
        for (const hc of shapesLayer.children || []) {
          const hp = hc && hc.attrs && hc.attrs.params;
          if (!hp || !hp.isHinge) continue;
          if (hp.doorKey !== doorKey) continue;
          myHinges.push(hc);
        }
        if (myHinges.length === 0) continue;

        const firstHp = myHinges[0].attrs.params;
        const vertical = (firstHp.orientation === 'vertical');

        if (vertical) {
          // Петлі вертикальні (на cols-перегородці) → boundaries уздовж Y.
          // Сортуємо за центром Y.
          myHinges.sort((a, b) => (a.attrs.y + (a.attrs.height || 0) / 2) - (b.attrs.y + (b.attrs.height || 0) / 2));
          const centers = myHinges.map(hh => hh.attrs.y + (hh.attrs.height || 0) / 2);
          const boundaries = [dy, ...centers, dy + fh];
          // Визначити сторону: петлі ближче до лівого чи правого краю фасаду
          const firstX = myHinges[0].attrs.x + (myHinges[0].attrs.width || 0) / 2;
          const facadeMidX = dx + fw / 2;
          const nearLeft = firstX < facadeMidX;
          const dimX = nearLeft ? (dx - gutter) : (dx + fw + gutter);
          const supEdge = nearLeft ? dx : (dx + fw);
          for (let i = 0; i < boundaries.length - 1; i++) {
            const from = boundaries[i];
            const to = boundaries[i + 1];
            const valueMm = Math.round((to - from) * coefG);
            if (valueMm <= 0) continue;
            // extension lines: від краю фасаду до dim line
            ctx.beginPath();
            ctx.moveTo(supEdge, from); ctx.lineTo(dimX, from);
            ctx.moveTo(supEdge, to); ctx.lineTo(dimX, to);
            // dim line
            ctx.moveTo(dimX, from); ctx.lineTo(dimX, to);
            // ticks (хрестики на кінцях)
            ctx.moveTo(dimX - tick, from - tick); ctx.lineTo(dimX + tick, from + tick);
            ctx.moveTo(dimX - tick, to - tick); ctx.lineTo(dimX + tick, to + tick);
            ctx.stroke();
            // text — повернутий -90°
            const txt = String(valueMm);
            const midY = (from + to) / 2;
            const textW = ctx.measureText(txt).width;
            ctx.save();
            ctx.translate(dimX, midY);
            ctx.rotate(-Math.PI / 2);
            // білий фон під текстом
            ctx.fillStyle = 'rgba(255,255,255,0.9)';
            ctx.fillRect(-textW / 2 - 1.5, -fontSize / 2 - 1.5, textW + 3, fontSize + 3);
            ctx.fillStyle = textFill;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(txt, 0, 0);
            ctx.restore();
          }
        } else {
          // Петлі горизонтальні (на rows-полиці) → boundaries уздовж X.
          myHinges.sort((a, b) => (a.attrs.x + (a.attrs.width || 0) / 2) - (b.attrs.x + (b.attrs.width || 0) / 2));
          const centers = myHinges.map(hh => hh.attrs.x + (hh.attrs.width || 0) / 2);
          const boundaries = [dx, ...centers, dx + fw];
          const firstY = myHinges[0].attrs.y + (myHinges[0].attrs.height || 0) / 2;
          const facadeMidY = dy + fh / 2;
          const nearTop = firstY < facadeMidY;
          const dimY = nearTop ? (dy - gutter) : (dy + fh + gutter);
          const supEdge = nearTop ? dy : (dy + fh);
          for (let i = 0; i < boundaries.length - 1; i++) {
            const from = boundaries[i];
            const to = boundaries[i + 1];
            const valueMm = Math.round((to - from) * coefG);
            if (valueMm <= 0) continue;
            ctx.beginPath();
            ctx.moveTo(from, supEdge); ctx.lineTo(from, dimY);
            ctx.moveTo(to, supEdge); ctx.lineTo(to, dimY);
            ctx.moveTo(from, dimY); ctx.lineTo(to, dimY);
            ctx.moveTo(from - tick, dimY - tick); ctx.lineTo(from + tick, dimY + tick);
            ctx.moveTo(to - tick, dimY - tick); ctx.lineTo(to + tick, dimY + tick);
            ctx.stroke();
            const txt = String(valueMm);
            const midX = (from + to) / 2;
            const textW = ctx.measureText(txt).width;
            ctx.fillStyle = 'rgba(255,255,255,0.9)';
            ctx.fillRect(midX - textW / 2 - 1.5, dimY - fontSize / 2 - 1.5, textW + 3, fontSize + 3);
            ctx.fillStyle = textFill;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(txt, midX, dimY);
          }
        }
      }

      return canvas.toDataURL('image/png', 1);
    } catch (e) {
      console.warn('[composeFacadeImageWithHinges] failed', e);
      return null;
    }
  }

  // Розміри для петель на опорі: край→центр[0], центр→центр (між сусідами), центр[N]→край.
  // Малюємо як CAD: extension lines + dim line з засічками + текст. Колонка з боку, де
  // стирчать петлі (визначається по позиції петлі відносно центру опори).
  renderHingeDimensions(support: any) {
    if (!support || !support.attrs || !support.attrs.params || !this.coef.Size) return;
    const params = support.attrs.params;
    const hingeBind = params.hingeBind;
    // ДІАГНОСТИКА: хто, скільки петель, що в _hingeDimensions ДО ререндеру
    const _idElement = this.coef.id_element || {};
    const _typeName = (t: number) => {
      const m: any = {
        [_idElement.partition]: 'partition',
        [_idElement.shelf]: 'shelf',
        [_idElement.lateral_wall]: 'lateral_wall',
        [_idElement.top_wall]: 'top_wall',
        [_idElement.bottom_wall]: 'bottom_wall',
        [_idElement.double_partition]: 'double_partition'
      };
      return m[t] || ('type=' + t);
    };
    const _stack = (new Error()).stack || '';
    const _caller = _stack.split('\n').slice(2, 4).map(s => s.trim()).join(' / ');
    const _coefG = this.coef.global_coef;
    const _oldDims = Array.isArray(params._hingeDimensions) ? params._hingeDimensions.length : 'no_array';
    const _supXmm = Math.round((support.attrs.x || 0) * _coefG);
    const _supYmm = Math.round((support.attrs.y || 0) * _coefG);
    const _supWmm = Math.round(((support.attrs.width != null ? support.attrs.width : (params.width || 0))) * _coefG);
    const _supHmm = Math.round(((support.attrs.height != null ? support.attrs.height : (params.height || 0))) * _coefG);
    const _hbCount = Array.isArray(hingeBind) ? hingeBind.length : 'no_array';
    console.log('[HINGE-DIM]', {
      support_type: _typeName(params.type),
      support_pos_mm: {x: _supXmm, y: _supYmm, w: _supWmm, h: _supHmm},
      hingeBind_count: _hbCount,
      oldDims_count: _oldDims,
      caller: _caller
    });
    // ENTRY: стан coef.Size ДО будь-якої моєї діяльності
    {
      let _oE = 0, _xE = 0;
      if (this.coef.Size && this.coef.Size.children) {
        for (const c of this.coef.Size.children) {
          if (c && c.attrs && c.attrs.params && c.attrs.params.isHingeDim) _oE++;
          else _xE++;
        }
      }
      console.log('[HINGE-DIM] ENTRY', {
        support_type: _typeName(params.type),
        entry_ours: _oE,
        entry_others: _xE,
        entry_total: _oE + _xE
      });
    }
    if (Array.isArray(params._hingeDimensions)) {
      // Перенумерувати індекси в coef.Size — бо sizes.ts.deleteOneSize робить пряму splice
      // без оновлення child.index. Без цього наш g.destroy() може зрізати чужий вузол
      // за застарілим індексом.
      if (this.coef.Size && typeof (this.coef.Size as any)._setChildrenIndices === 'function') {
        (this.coef.Size as any)._setChildrenIndices();
      }
      // ЗАХИСТ: знищуємо тільки ті що мають маркер isHingeDim — не зачіпаємо випадкових чужих
      let _idx = 0;
      for (const g of params._hingeDimensions) {
        if (!g || !g.destroy) { _idx++; continue; }
        // ДІАГНОСТИКА КОЖНОГО елементу в масиві перед знищенням
        console.log('[HINGE-DIM] ARRAY-ITEM', {
          idx: _idx,
          isOursByCheck: !!(g.attrs && g.attrs.params && g.attrs.params.isHingeDim),
          params: g.attrs ? g.attrs.params : '?',
          x: g.attrs ? g.attrs.x : '?',
          y: g.attrs ? g.attrs.y : '?',
          name: g.attrs ? g.attrs.name : '?',
          className: g.className || '?',
          parent_layer: g.getParent ? (g.getParent() === this.coef.Size ? 'coef.Size' : 'other/none') : '?',
          isDestroyed: g._isDestroyed || g.isDestroyed || false
        });
        _idx++;
        const isOurs = g.attrs && g.attrs.params && g.attrs.params.isHingeDim;
        if (!isOurs) {
          console.warn('[HINGE-DIM] FOREIGN IN ARRAY — not destroying', {
            support_type: _typeName(params.type),
            stranger_params: g.attrs ? g.attrs.params : '?',
            stranger_x: g.attrs ? g.attrs.x : '?',
            stranger_y: g.attrs ? g.attrs.y : '?',
            stranger_name: g.attrs ? g.attrs.name : '?'
          });
          continue;
        }
        g.destroy();
      }
    }
    params._hingeDimensions = [];
    // ДІАГНОСТИКА: стан coef.Size ПІСЛЯ знищення, ДО створення нових
    {
      let _o = 0, _x = 0;
      if (this.coef.Size && this.coef.Size.children) {
        for (const c of this.coef.Size.children) {
          if (c && c.attrs && c.attrs.params && c.attrs.params.isHingeDim) _o++;
          else _x++;
        }
      }
      console.log('[HINGE-DIM] INTERMEDIATE', {
        support_type: _typeName(params.type),
        after_destroy_ours: _o,
        after_destroy_others: _x,
        total: _o + _x
      });
    }
    if (!Array.isArray(hingeBind) || hingeBind.length === 0) {
      console.log('[HINGE-DIM] EARLY-RETURN: empty hingeBind', {support_type: _typeName(params.type)});
      this.coef.Size.batchDraw();
      return;
    }
    const coefG = this.coef.global_coef;
    const stype = params.type;
    const isVertical = (stype === this.coef.id_element.partition
      || stype === this.coef.id_element.lateral_wall
      || stype === this.coef.id_element.double_partition);
    // Геометрія опори: уздовж осі (along) і поперек (cross)
    const supAlongStart = isVertical ? support.attrs.y : support.attrs.x;
    const supAlongLen = isVertical
      ? (support.attrs.height != null ? support.attrs.height : (params.height || 0))
      : (support.attrs.width != null ? support.attrs.width : (params.width || 0));
    const supAlongEnd = supAlongStart + supAlongLen;
    const supCrossStart = isVertical ? support.attrs.x : support.attrs.y;
    const supCrossLen = isVertical
      ? (support.attrs.width != null ? support.attrs.width : (params.width || 0))
      : (support.attrs.height != null ? support.attrs.height : (params.height || 0));
    const supCrossEnd = supCrossStart + supCrossLen;
    const supCrossCenter = supCrossStart + supCrossLen / 2;
    // Розбиваємо петлі по сторонах: 'near' = з боку малих координат, 'far' = з боку великих
    const nearSide: any[] = [], farSide: any[] = [];
    for (const h of hingeBind) {
      const hCross = isVertical
        ? (h.attrs.x + (h.attrs.width || 0) / 2)
        : (h.attrs.y + (h.attrs.height || 0) / 2);
      if (hCross < supCrossCenter) nearSide.push(h); else farSide.push(h);
    }
    const gutterPx = 30 / coefG;   // відступ від краю опори до dim line
    const tickPx = 4 / coefG;       // засічка 45° на кінцях dim line
    const fontSize = 9;
    const stroke = 'rgba(0,0,0,0.55)';
    const sortAlong = (h: any) =>
      isVertical ? (h.attrs.y + (h.attrs.height || 0) / 2) : (h.attrs.x + (h.attrs.width || 0) / 2);
    const drawColumn = (sideHinges: any[], near: boolean) => {
      if (sideHinges.length === 0) return;
      const sorted = sideHinges.slice().sort((a, b) => sortAlong(a) - sortAlong(b));
      const centers = sorted.map(sortAlong);
      const boundaries = [supAlongStart, ...centers, supAlongEnd];
      const dimCoord = near ? (supCrossStart - gutterPx) : (supCrossEnd + gutterPx);
      const supEdge = near ? supCrossStart : supCrossEnd;
      for (let i = 0; i < boundaries.length - 1; i++) {
        const fromPx = boundaries[i];
        const toPx = boundaries[i + 1];
        const valueMm = Math.round((toPx - fromPx) * coefG);
        if (valueMm <= 0) continue;
        const midPx = (fromPx + toPx) / 2;
        const g = new Konva.Group({listening: false, params: {isHingeDim: true}});
        const ext = (atAlong: number) => {
          // лінія від краю опори до dim line, по cross-осі
          const p = isVertical
            ? [supEdge, atAlong, dimCoord, atAlong]
            : [atAlong, supEdge, atAlong, dimCoord];
          g.add(new Konva.Line({points: p, stroke: stroke, strokeWidth: 0.5, listening: false}));
        };
        const tickMark = (atAlong: number) => {
          // засічка 45° на dim line
          const p = isVertical
            ? [dimCoord - tickPx, atAlong - tickPx, dimCoord + tickPx, atAlong + tickPx]
            : [atAlong - tickPx, dimCoord - tickPx, atAlong + tickPx, dimCoord + tickPx];
          g.add(new Konva.Line({points: p, stroke: stroke, strokeWidth: 0.5, listening: false}));
        };
        ext(fromPx);
        ext(toPx);
        // dim line
        const dimLine = isVertical
          ? [dimCoord, fromPx, dimCoord, toPx]
          : [fromPx, dimCoord, toPx, dimCoord];
        g.add(new Konva.Line({points: dimLine, stroke: stroke, strokeWidth: 0.5, listening: false}));
        tickMark(fromPx);
        tickMark(toPx);
        // текст: між засічками. На вертикальній опорі — повертаємо на -90 (читається знизу вверх).
        const textStr = String(valueMm);
        const approxW = textStr.length * (fontSize * 0.55);
        const textNode: any = {text: textStr, fontSize, fill: 'rgba(0,0,0,0.85)', listening: false};
        if (isVertical) {
          // повернутий текст по центру dim line: займає по X від x до x+fontSize.
          // Центр по X = dimCoord → x = dimCoord - fontSize/2
          textNode.rotation = -90;
          textNode.y = midPx + approxW / 2;
          textNode.x = dimCoord - fontSize / 2;
        } else {
          textNode.x = midPx - approxW / 2;
          textNode.y = dimCoord - fontSize / 2;
        }
        // Білий бекграунд під цифру (для читабельності, перекриває dim line у місці тексту)
        const bgPad = 1.5 / coefG;
        let bgX: number, bgY: number, bgW: number, bgH: number;
        if (isVertical) {
          // повернутий: X від x до x+fontSize, Y від y-approxW до y
          bgX = textNode.x - bgPad;
          bgY = textNode.y - approxW - bgPad;
          bgW = fontSize + 2 * bgPad;
          bgH = approxW + 2 * bgPad;
        } else {
          bgX = textNode.x - bgPad;
          bgY = textNode.y - bgPad;
          bgW = approxW + 2 * bgPad;
          bgH = fontSize + 2 * bgPad;
        }
        g.add(new Konva.Rect({
          x: bgX, y: bgY, width: bgW, height: bgH,
          fill: 'white', listening: false
        }));
        g.add(new Konva.Text(textNode));
        this.coef.Size.add(g);
        params._hingeDimensions.push(g);
      }
    };
    drawColumn(nearSide, true);
    drawColumn(farSide, false);
    // Розбиваємо total у coef.Size: наші hinge-dim vs чужі (від sizes.ts тощо)
    let _ours = 0, _others = 0;
    if (this.coef.Size && this.coef.Size.children) {
      for (const c of this.coef.Size.children) {
        if (c && c.attrs && c.attrs.params && c.attrs.params.isHingeDim) _ours++;
        else _others++;
      }
    }
    console.log('[HINGE-DIM] DONE', {
      support_type: _typeName(params.type),
      nearSide_hinges: nearSide.length,
      farSide_hinges: farSide.length,
      groups_created: params._hingeDimensions.length,
      coefSize_total: _ours + _others,
      coefSize_ours_hingeDim: _ours,
      coefSize_others: _others
    });
    this.coef.Size.batchDraw();
  }

  // Знайти стіну (боковина / стеля / дно), на якій сидять петлі пристінної дверки —
  // щоб додавати ці петлі в її .hingeBind, і bind-обхід їх знаходив.
  findWallSupport(orientation: 'vertical' | 'horizontal', attachLine: number): any {
    const tol = this.coef.global_size_flat + 2;
    const wantTypes = orientation === 'vertical'
      ? [this.coef.id_element.lateral_wall]
      : [this.coef.id_element.top_wall, this.coef.id_element.bottom_wall];
    for (const el of this.coef.shapesLayerw.children) {
      const p = el.attrs && el.attrs.params;
      if (!p || wantTypes.indexOf(p.type) < 0) continue;
      if (orientation === 'vertical') {
        const a = el.attrs.x;
        const b = el.attrs.x + (el.attrs.width || 0);
        if (Math.abs(a - attachLine) <= tol || Math.abs(b - attachLine) <= tol) return el;
      } else {
        const a = el.attrs.y;
        const b = el.attrs.y + (el.attrs.height != null ? el.attrs.height : (p.height || 0));
        if (Math.abs(a - attachLine) <= tol || Math.abs(b - attachLine) <= tol) return el;
      }
    }
    return null;
  }

  // Збирає петлі, що можуть впертися в policю/перегородку, через bind:
  // — контури елемента (left/right для полиці, top/bottom для перегородки) → їх .hingeBind;
  // — перпендикулярні елементи в elem.bind (партиції під полицею / полиці на перегородці) → їх .hingeBind.
  relevantHinges(elem: any, kind: 'shelf' | 'partition', excludeHinges?: any[]): any[] {
    const seen: any[] = [];
    const isOwn = (h: any) => excludeHinges && excludeHinges.indexOf(h) >= 0;
    const collectFrom = (host: any) => {
      if (!host || !host.attrs || !host.attrs.params) return;
      const hb = host.attrs.params.hingeBind;
      if (!Array.isArray(hb)) return;
      for (const h of hb) {
        if (!h || !h.attrs || !h.attrs.params || !h.attrs.params.isHinge) continue;
        if (isOwn(h)) continue;
        if (seen.indexOf(h) >= 0) continue;
        seen.push(h);
      }
    };
    const params = elem.attrs && elem.attrs.params;
    const contours = params && params.contours;
    if (contours) {
      if (kind === 'shelf') { collectFrom(contours.left); collectFrom(contours.right); }
      else                  { collectFrom(contours.top);  collectFrom(contours.bottom); }
    }
    const bind = elem.attrs.bind;
    if (Array.isArray(bind)) {
      const perpType = kind === 'shelf' ? this.coef.id_element.partition : this.coef.id_element.shelf;
      for (const b of bind) {
        if (!b || !b.attrs || !b.attrs.params) continue;
        if (b.attrs.params.type === perpType) collectFrom(b);
      }
    }
    return seen;
  }

  // Симетрія: коли ЛЮДИНА тягне петлю — вона теж впирається в полиці/перегородки.
  // Заборонені смуги (px, по осі руху петлі) від полиць (вертик.) / перегородок (гориз.),
  // що дотягуються до лінії петлі (її поперечної координати).
  hingeShelfBands(hinge: any, orientation: 'vertical' | 'horizontal'): number[][] {
    const bands: number[][] = [];
    const support = hinge.attrs && hinge.attrs.params && hinge.attrs.params.supportEl;
    if (!support || !support.attrs || !Array.isArray(support.attrs.bind)) return bands;
    const coefG = this.coef.global_coef;
    const sv = this.coef.spec_values || {};
    const hingeLenPx = (sv['hinge_length'] != null ? sv['hinge_length'] : 100) / coefG;
    const wantType = orientation === 'vertical' ? this.coef.id_element.shelf : this.coef.id_element.partition;
    const minClearPx = (sv[orientation === 'vertical' ? 'min_shelf_hinge_offset' : 'min_partition_hinge_offset'] != null
      ? sv[orientation === 'vertical' ? 'min_shelf_hinge_offset' : 'min_partition_hinge_offset']
      : 0) / coefG;
    // Беремо перпендикулярні елементи (полиці для вертик. петлі / перегородки для гориз.), що
    // прив'язані до ОПОРИ цієї петлі (через bind стіни/перегородки/полиці), і робимо смуги.
    for (const b of support.attrs.bind) {
      if (!b || !b.attrs || !b.attrs.params || b.attrs.params.type !== wantType) continue;
      if (orientation === 'vertical') {
        const sTop = b.attrs.y, sBot = b.attrs.y + (b.attrs.height || 0);
        bands.push([sTop - minClearPx - hingeLenPx / 2, sBot + minClearPx + hingeLenPx / 2]);
      } else {
        const pLeft = b.attrs.x, pRight = b.attrs.x + (b.attrs.width || 0);
        bands.push([pLeft - minClearPx - hingeLenPx / 2, pRight + minClearPx + hingeLenPx / 2]);
      }
    }
    return bands;
  }

  // Заборона встановлення: чи падає полиця/перегородка на петлю (ближче min_*_hinge_offset).
  // true → ставити НЕ можна (петля стоїть, полиця в неї впирається). Петлі НЕ рухаємо.
  hingeBlocksPlacement(kind: 'shelf' | 'partition', xy: any, contours: any): boolean {
    if (!this.coef.shapesLayerw || !contours) return false;
    const coefG = this.coef.global_coef;
    const sv = this.coef.spec_values || {};
    const flat = this.coef.global_size_flat;
    // Кандидати на конфлікт — петлі, прив'язані до контурів нового елемента (через bind)
    const candidates: any[] = [];
    const collectFrom = (host: any) => {
      const hb = host && host.attrs && host.attrs.params && host.attrs.params.hingeBind;
      if (Array.isArray(hb)) for (const h of hb) if (h && h.attrs && h.attrs.params && h.attrs.params.isHinge) candidates.push(h);
    };
    if (kind === 'shelf') {
      collectFrom(contours.left); collectFrom(contours.right);
      const minClearPx = (sv['min_shelf_hinge_offset'] != null ? sv['min_shelf_hinge_offset'] : 0) / coefG;
      const zTop = xy.y - minClearPx;
      const zBot = xy.y + flat + minClearPx;
      for (const el of candidates) {
        const hTop = el.attrs.y;
        const hBot = el.attrs.y + (el.attrs.height || 0);
        if (hBot < zTop || hTop > zBot) continue;
        return true;
      }
    } else {
      collectFrom(contours.top); collectFrom(contours.bottom);
      const minClearPx = (sv['min_partition_hinge_offset'] != null ? sv['min_partition_hinge_offset'] : 0) / coefG;
      const zLeft = xy.x - minClearPx;
      const zRight = xy.x + flat + minClearPx;
      for (const el of candidates) {
        const hLeft = el.attrs.x;
        const hRight = el.attrs.x + (el.attrs.width || 0);
        if (hRight < zLeft || hLeft > zRight) continue;
        return true;
      }
    }
    return false;
  }

  // Заборона встановлення нового елемента в зоні шухляди. Перевіряємо чи xy потрапляє в bbox
  // будь-якої drawer_zone у `shapesLayerw`. true → ставити не можна.
  drawerZoneBlocksPlacement(kind: 'shelf' | 'partition', xy: any): boolean {
    if (!this.coef.shapesLayerw || !this.coef.shapesLayerw.children) return false;
    const flat = this.coef.global_size_flat;
    // Майбутній елемент: полиця має ширину секції, але по Y — товщина flat. Для перегородки навпаки.
    // Для перевірки беремо бекбокс товщини flat по головній осі — як перетин зі смугою зони.
    const newTop = xy.y;
    const newBot = xy.y + flat;
    const newLeft = xy.x;
    const newRight = xy.x + flat;
    for (const c of this.coef.shapesLayerw.children) {
      const p = c && c.attrs && c.attrs.params;
      if (!p || !p.isDrawerZone) continue;
      const zX = c.attrs.x;
      const zY = c.attrs.y;
      // Розмір зони беремо з фону (першої дитини) — це актуальний розмір після resize.
      const bg = c.children && c.children[0];
      const zW = bg ? (bg.attrs.width || 0) : 0;
      const zH = bg ? (bg.attrs.height || 0) : 0;
      if (kind === 'shelf') {
        // полиця кладеться горизонтально → перетин по Y, повний overlap по X
        if (newBot < zY || newTop > zY + zH) continue;
        if (newRight < zX || newLeft > zX + zW) continue;
      } else {
        // перегородка вертикально → перетин по X
        if (newRight < zX || newLeft > zX + zW) continue;
        if (newBot < zY || newTop > zY + zH) continue;
      }
      return true;
    }
    return false;
  }

  // Дверка-власник петлі (лист DoorWrapper-дерева з _id === doorKey).
  findDoorByKey(doorKey: any): any {
    const walk = (zone: any): any => {
      if (!zone || !zone.attrs || !zone.attrs.params) return null;
      if (zone._id === doorKey) return zone;
      for (const c of (zone.attrs.params.children || [])) {
        const found = walk(c);
        if (found) return found;
      }
      return null;
    };
    const roots = (this.coefDoor.DoorWrapper && this.coefDoor.DoorWrapper.children) || [];
    for (const r of roots) {
      const found = walk(r);
      if (found) return found;
    }
    return null;
  }

  // Інтервали мінус заборонені смуги [from, to].
  subtractBands(intervals: number[][], bands: number[][]): number[][] {
    for (const band of bands) {
      const next: number[][] = [];
      for (const [a, b] of intervals) {
        if (band[1] <= a || band[0] >= b) { next.push([a, b]); continue; }
        if (band[0] <= a && band[1] >= b) { continue; }                  // повністю накриває
        if (band[0] > a && band[1] < b) { next.push([a, band[0]]); next.push([band[1], b]); continue; }
        if (band[0] <= a) { next.push([band[1], b]); continue; }         // зрізає зліва
        next.push([a, band[0]]);                                          // зрізає справа
      }
      intervals = next.filter(([a, b]) => b > a);
    }
    return intervals;
  }

  // Двосторонні петлі: на полиці/перегородці петлі дверок з різних боків не можуть стояти на одній
  // висоті (ширині) — центри мінімум на double_side_hinges_offset один від одного. Повертає смуги
  // [центр − offset, центр + offset] навколо петель ІНШИХ дверок на цій опорі (px, по осі петлі).
  oppositeHingeBands(support: any, doorKey: any, orientation: 'vertical' | 'horizontal'): number[][] {
    const sp = support && support.attrs && support.attrs.params;
    if (!sp || (sp.type !== this.coef.id_element.partition && sp.type !== this.coef.id_element.shelf)) return [];
    const sv = this.coef.spec_values || {};
    const offMm = sv['double_side_hinges_offset'] != null ? sv['double_side_hinges_offset'] : 0;
    if (!(offMm > 0)) return [];
    const offPx = offMm / this.coef.global_coef;
    const eps = 0.01; // межа (рівно offset від центру) — дозволена позиція, не вирізаємо її
    const bands: number[][] = [];
    for (const h of (sp.hingeBind || [])) {
      const hp = h && h.attrs && h.attrs.params;
      if (!hp || !hp.isHinge || hp.doorKey === doorKey || hp.orientation !== orientation) continue;
      const c = orientation === 'vertical'
        ? h.attrs.y + (h.attrs.height || 0) / 2
        : h.attrs.x + (h.attrs.width || 0) / 2;
      bands.push([c - offPx + eps, c + offPx - eps]);
    }
    return bands;
  }

  // Валідні інтервали центру петлі по її осі — ЄДИНЕ джерело меж і для драгу, і для стрілок:
  //  - межі = перетин дверки й опори (опору могли ресайзнути — рахуємо динамічно) ± min_edge_offset;
  //  - сусідні петлі тієї ж дверки: min/max_hinges_offset; крайні — max_edge_offset;
  //  - мінус заборонені смуги полиць/перегородок;
  //  - мінус зони навколо петель дверки з іншого боку тієї ж полиці/перегородки (oppositeHingeBands).
  // logTag — лише для діагностики драгу.
  computeHingeIntervals(hinge: any, door: any, orientation: 'vertical' | 'horizontal', logTag?: string): number[][] {
    const coefG = this.coef.global_coef;
    const p = hinge.attrs.params;
    const sv = this.coef.spec_values || {};
    const hingeLengthMm = sv['hinge_length'] != null ? sv['hinge_length'] : 100;
    const hingeLengthPx = hingeLengthMm / coefG;
    const minEdgeMm = orientation === 'vertical'
      ? (sv['min_hinge_vertical_edge_offset'] != null ? sv['min_hinge_vertical_edge_offset'] : (sv['hinge_vertical_edge_offset'] || 70))
      : (sv['min_hinge_horizontal_edge_offset'] != null ? sv['min_hinge_horizontal_edge_offset'] : (sv['hinge_horizontal_edge_offset'] || 70));
    const minEdgePx = minEdgeMm / coefG;
    const maxEdgeMm = orientation === 'vertical'
      ? (sv['max_hinge_vertical_edge_offset'] != null ? sv['max_hinge_vertical_edge_offset'] : 999999)
      : (sv['max_hinge_horizontal_edge_offset'] != null ? sv['max_hinge_horizontal_edge_offset'] : 999999);
    const maxEdgePx = maxEdgeMm / coefG;
    // Відстань МІЖ петлями — edge-to-edge: у центрах це (offset + довжина петлі).
    const minBetweenMm = sv['min_hinges_offset'] != null ? sv['min_hinges_offset'] : 0;
    const maxBetweenMm = sv['max_hinges_offset'] != null ? sv['max_hinges_offset'] : 999999;
    const minCenterDistPx = (minBetweenMm + hingeLengthMm) / coefG;
    const maxCenterDistPx = (maxBetweenMm + hingeLengthMm) / coefG;
    const doorKey = p.doorKey;
    const thisIndex = p.hingeIndex;

    const sup = p.supportEl;
    const facade = door && door.children && door.children[0];
    let mountStart: number, mountEnd: number;
    if (orientation === 'vertical') {
      const supTop = sup ? sup.attrs.y : door.attrs.y;
      const supLen = sup ? ((sup.attrs.height != null ? sup.attrs.height : ((sup.attrs.params && sup.attrs.params.height) || 0))) : (facade ? facade.attrs.height : 0);
      const supBot = supTop + supLen;
      mountStart = door ? Math.max(door.attrs.y, supTop) : supTop;
      mountEnd = door ? Math.min(door.attrs.y + (facade ? facade.attrs.height : 0), supBot) : supBot;
    } else {
      const supLeft = sup ? sup.attrs.x : door.attrs.x;
      const supLen = sup ? ((sup.attrs.width != null ? sup.attrs.width : ((sup.attrs.params && sup.attrs.params.width) || 0))) : (facade ? facade.attrs.width : 0);
      const supRight = supLeft + supLen;
      mountStart = door ? Math.max(door.attrs.x, supLeft) : supLeft;
      mountEnd = door ? Math.min(door.attrs.x + (facade ? facade.attrs.width : 0), supRight) : supRight;
    }
    let lo = mountStart + minEdgePx + hingeLengthPx / 2;   // край-до-краю по опорі
    let hi = mountEnd - minEdgePx - hingeLengthPx / 2;
    let maxIndex = thisIndex;
    let upperC: number = null; // центр найближчої петлі (index-1)
    let lowerC: number = null; // центр найближчої петлі (index+1)
    for (const c of this.coef.shapesLayerw.children) {
      const cp = c.attrs && c.attrs.params;
      if (!cp || !cp.isHinge || cp.doorKey !== doorKey || c === hinge) continue;
      if (cp.hingeIndex > maxIndex) maxIndex = cp.hingeIndex;
      const center = orientation === 'vertical' ? c.attrs.y + hingeLengthPx / 2 : c.attrs.x + hingeLengthPx / 2;
      if (cp.hingeIndex === thisIndex - 1) upperC = center;
      if (cp.hingeIndex === thisIndex + 1) lowerC = center;
    }
    const loFromEdge = lo;
    const loFromUpper = (upperC != null) ? (upperC + minCenterDistPx) : null;
    const loFromLower = (lowerC != null) ? (lowerC - maxCenterDistPx) : null;
    if (upperC != null) { lo = Math.max(lo, upperC + minCenterDistPx); hi = Math.min(hi, upperC + maxCenterDistPx); }
    if (lowerC != null) { hi = Math.min(hi, lowerC - minCenterDistPx); lo = Math.max(lo, lowerC - maxCenterDistPx); }
    if (thisIndex === 0) hi = Math.min(hi, mountStart + maxEdgePx + hingeLengthPx / 2);
    if (thisIndex === maxIndex) lo = Math.max(lo, mountEnd - maxEdgePx - hingeLengthPx / 2);
    if (logTag) {
      // ДІАГНОСТИКА драгу петлі: висота/Y опори, Y петлі та звідки взялась межа зупинки.
      const mm = (v: any) => (v == null ? null : Math.round(v * coefG));
      console.log(logTag, {
        orientation,
        hingeIndex: thisIndex,
        support: {
          y_mm: mm(sup && sup.attrs ? sup.attrs.y : null),
          x_mm: mm(sup && sup.attrs ? sup.attrs.x : null),
          height_mm: mm(sup && sup.attrs ? (sup.attrs.height != null ? sup.attrs.height : (sup.attrs.params && sup.attrs.params.height)) : null),
          width_mm: mm(sup && sup.attrs ? (sup.attrs.width != null ? sup.attrs.width : (sup.attrs.params && sup.attrs.params.width)) : null)
        },
        mountStart_mm: mm(mountStart),
        mountEnd_mm: mm(mountEnd),
        hinge_y_mm: mm(hinge.attrs.y),
        hinge_x_mm: mm(hinge.attrs.x),
        hinge_height_mm: mm(hinge.attrs.height),
        hinge_width_mm: mm(hinge.attrs.width),
        hinge_length_spec_mm: hingeLengthMm,
        hinge_center_mm: mm(orientation === 'vertical' ? hinge.attrs.y + hingeLengthPx / 2 : hinge.attrs.x + hingeLengthPx / 2),
        upperC_mm: mm(upperC),
        lowerC_mm: mm(lowerC),
        // Кожне з джерел мінімуму (lo) у мм — щоб видно було, що саме затискає вгору
        lo_fromEdge_mm: mm(loFromEdge),                 // mountStart + min_edge_offset + len/2
        lo_fromUpperHinge_mm: mm(loFromUpper),          // upperC + min_hinges_offset + len
        lo_fromLowerHinge_mm: mm(loFromLower),          // lowerC - (max_hinges_offset + len)
        lo_final_mm: mm(lo),
        hi_final_mm: mm(hi),
        // У розмірах, які видно: від краю опори до центру петлі (як на лейблах)
        gapTopToCenterAtLo_mm: mm(lo - mountStart),
        gapTopToCenterNow_mm: mm((orientation === 'vertical' ? hinge.attrs.y + hingeLengthPx / 2 : hinge.attrs.x + hingeLengthPx / 2) - mountStart)
      });
    }
    // Будуємо НАБІР валідних інтервалів: [lo, hi] мінус усі заборонені смуги полиць/перегородок.
    // Це єдиний "істинний" набір місць, де петля МОЖЕ стояти. Усе інше — заборонено.
    const bands = this.hingeShelfBands(hinge, orientation)
      .concat(this.oppositeHingeBands(sup, doorKey, orientation));
    return this.subtractBands([[lo, hi]], bands);
  }

  // Після ручного руху петлі (драг або стрілки): зберегти зсув у дверці (hingeManualOffsets —
  // переживає перебілд і йде у facade_tree) і перерахувати фальш-панелі шухляд на опорі.
  commitHingeMove(hinge: any, door: any) {
    const p = hinge.attrs.params;
    const coefG = this.coef.global_coef;
    const sv = this.coef.spec_values || {};
    const hingeLengthPx = (sv['hinge_length'] != null ? sv['hinge_length'] : 100) / coefG;
    const newCenterMm = p.orientation === 'vertical'
      ? (hinge.attrs.y + hingeLengthPx / 2) * coefG
      : (hinge.attrs.x + hingeLengthPx / 2) * coefG;
    const delta = Math.round(newCenterMm - p.formulaCenterMm);
    if (door) {
      if (!Array.isArray(door.attrs.params.hingeManualOffsets)) door.attrs.params.hingeManualOffsets = [];
      door.attrs.params.hingeManualOffsets[p.hingeIndex] = delta;
    }
    this._recomputeDrawerPlanksForContour(p.supportEl);
  }

  // Клавіатурний "поштовх" петлі — ті самі інтервали що й драг (computeHingeIntervals),
  // знаходить найближчу валідну точку до бажаного нового центру.
  // axis: 'x' для горизонтальної петлі, 'y' для вертикальної. signedMm: ±1 мм за один поштовх.
  nudgeHinge(hinge: any, axis: 'x' | 'y', signedMm: number) {
    if (!hinge || !hinge.attrs || !hinge.attrs.params || !hinge.attrs.params.isHinge) return;
    const p = hinge.attrs.params;
    const orientation: 'vertical' | 'horizontal' = p.orientation;
    if (orientation === 'vertical' && axis !== 'y') return;
    if (orientation === 'horizontal' && axis !== 'x') return;
    const coefG = this.coef.global_coef;
    const sv = this.coef.spec_values || {};
    const hingeLengthPx = (sv['hinge_length'] != null ? sv['hinge_length'] : 100) / coefG;
    const door = this.findDoorByKey(p.doorKey);
    const intervals = this.computeHingeIntervals(hinge, door, orientation);
    if (intervals.length === 0) return;
    const centerNow = orientation === 'vertical'
      ? hinge.attrs.y + hingeLengthPx / 2
      : hinge.attrs.x + hingeLengthPx / 2;
    const target = centerNow + signedMm / coefG;
    // Лише в межах ПОТОЧНОГО інтервалу (того, де петля стоїть): стрілка впирається в межу,
    // а не перестрибує через смугу полиці в інший інтервал.
    let own: number[] = null;
    for (const iv of intervals) {
      if (centerNow >= iv[0] - 0.5 / coefG && centerNow <= iv[1] + 0.5 / coefG) { own = iv; break; }
    }
    let best: number;
    if (own) {
      best = Math.max(own[0], Math.min(own[1], target));
    } else {
      // Петля поза валідними місцями (напр. опору ресайзнули) — до найближчої валідної точки.
      let bestDist = Infinity;
      best = centerNow;
      for (const [a, b] of intervals) {
        const cl = Math.max(a, Math.min(b, target));
        const d = Math.abs(cl - target);
        if (d < bestDist) { bestDist = d; best = cl; }
      }
    }
    const finalCenter = Math.round(best * coefG) / coefG; // цілі мм
    if (orientation === 'vertical') hinge.y(finalCenter - hingeLengthPx / 2);
    else                            hinge.x(finalCenter - hingeLengthPx / 2);
    this.commitHingeMove(hinge, door);
    // Оновлюємо розміри (петля рухається без dragmove-події з шару)
    const sup = p.supportEl;
    if (sup && sup.attrs && sup.attrs.params) this.renderHingeDimensions(sup);
    this.coef.shapesLayerw.batchDraw();
  }

  // Крок 5: петля перетягується вздовж своєї осі (вертикальна дверка — по Y, горизонтальна — по X).
  // Обмеження: computeHingeIntervals (спільні з клавіатурою).
  // Зсув зберігається у дверці (hingeManualOffsets[index]) і переживає перемалювання.
  makeHingeDraggable(hinge: any, door: any, orientation: 'vertical' | 'horizontal', mountStartPx: number, mountEndPx: number) {
    const coefG = this.coef.global_coef;
    const p = hinge.attrs.params;
    if (!door) return;
    const sv = this.coef.spec_values || {};
    const hingeLengthMm = sv['hinge_length'] != null ? sv['hinge_length'] : 100;
    const hingeLengthPx = hingeLengthMm / coefG;

    hinge.draggable(true);
    const stage = this.coef.shapesLayerw && this.coef.shapesLayerw.getStage();
    hinge.on('mouseenter', () => { if (stage && stage.container()) stage.container().style.cursor = orientation === 'vertical' ? 'ns-resize' : 'ew-resize'; });
    hinge.on('mouseleave', () => { if (stage && stage.container()) stage.container().style.cursor = 'default'; });

    // dragstart: рахуємо й кешуємо межі + заборонені смуги ОДИН раз (як це роблять полиці),
    // бо під час одного перетягування сусіди/опора/полиці не рухаються.
    hinge.on('dragstart', () => {
      p._drag = {intervals: this.computeHingeIntervals(hinge, door, orientation, '[HINGE-DRAG-START]')};
    });

    hinge.dragBoundFunc((pos: any) => {
      const d = p._drag || {intervals: [[-1e9, 1e9]]};
      // Немає жодного дозволеного місця — петля стоїть (як і для стрілок), а не їде за курсором.
      if (d.intervals.length === 0) return hinge.getAbsolutePosition();
      let c = orientation === 'vertical' ? pos.y + hingeLengthPx / 2 : pos.x + hingeLengthPx / 2;
      // Знаходимо найближчу точку у ВСЬОМУ наборі валідних інтервалів — це і є переприг,
      // який вже за побудовою враховує всі обмеження одночасно.
      let best = null, bestDist = Infinity;
      for (const [a, b] of d.intervals) {
        const clamped = Math.max(a, Math.min(b, c));
        const dist = Math.abs(clamped - c);
        if (dist < bestDist) { bestDist = dist; best = clamped; }
      }
      c = (best != null) ? best : c;
      c = Math.round(c * coefG) / coefG; // цілі мм (без коми)
      if (orientation === 'vertical') return {x: hinge.getAbsolutePosition().x, y: c - hingeLengthPx / 2};
      return {x: c - hingeLengthPx / 2, y: hinge.getAbsolutePosition().y};
    });

    hinge.on('dragend', () => {
      p._drag = null;
      // КРОК ШАФИ: НЕ перебілдимо петлі. Петля лишається там, де її кинули (persist);
      // delta збережено лише для майбутнього перебілду на КРОЦІ ФАСАДІВ.
      this.coef.shapesLayerw.batchDraw();
      if (this.onAfterResize) this.onAfterResize();
      // Зсув у дверку + рух петлі по Y міг змінити її перекриття з шухлядами цієї колонки.
      this.commitHingeMove(hinge, door);
    });
    // Live recompute під час драгу — щоб юзер відразу бачив зміни планок.
    hinge.on('dragmove.drawerPlankSync', () => {
      this._recomputeDrawerPlanksForContour(p.supportEl);
    });
  }

  // Виклик з hinge dragmove/dragend: пройти всіх drawer-ів прив'язаних до supportEl
  // (тобто на одній перегородці/стіні в одній колонці) і перерахувати їхні фальш-панелі.
  private _recomputeDrawerPlanksForContour(supportEl: any) {
    if (!supportEl || !supportEl.attrs || !Array.isArray(supportEl.attrs.bind)) return;
    const drawerType = this.coef.id_element.drawer;
    for (const child of supportEl.attrs.bind) {
      if (!child || !child.attrs || !child.attrs.params) continue;
      if (child.attrs.params.type !== drawerType) continue;
      try {
        Drawer.recomputeDrawerPlanks(child, this.coef);
      } catch (e) {
        console.warn('[DRAWER-PLANKS] recompute failed', e);
      }
    }
  }

  syncCorpusDoublePartition() {
    if (!this.coefDoor.DoorWrapper || !this.coef.shapesLayerw) return;
    const splType = this.coef.id_element.hinged_splitter;
    let stik: any = null;
    for (const c of this.coefDoor.DoorWrapper.children) {
      if (c.attrs && c.attrs.params && c.attrs.params.type === splType && c.attrs.params.isRootStik) {
        stik = c;
        break;
      }
    }
    if (!stik) return;
    const visual = stik.children && stik.children[0];
    if (!visual) return;
    const flat = this.coef.global_size_flat;
    const coefG = this.coef.global_coef;
    const stikCenter = stik.attrs.x + visual.attrs.width / 2;

    const stikCenter_mm = stikCenter * coefG;
    const cabW = this.coef.setingsWardrobe.width / coefG;
    const cabLeftX = (this.coef.widthWrapper - cabW) / 2;
    const cabCenterX_mm = (cabLeftX + cabW / 2) * coefG;
    const snappedCenter_mm = this.snapMmTowardCabinetCenter(stikCenter_mm, cabCenterX_mm);
    const newDpX = (snappedCenter_mm / coefG) - flat;

    let dp: any = null;
    for (const c of this.coef.shapesLayerw.children) {
      if (c.attrs && c.attrs.params && c.attrs.params.type === this.coef.id_element.double_partition) {
        dp = c;
        break;
      }
    }
    if (!dp) return;
    const dx = newDpX - dp.attrs.x;
    if (Math.abs(dx) < 0.01) return;
    dp.x(newDpX);
    if (typeof dp.fire === 'function') {
      dp.fire('dragmove');
    }
    this.coef.shapesLayerw.batchDraw();
    console.log('[HINGED] syncCorpusDoublePartition', {newDpX_mm: Math.round(newDpX * coefG), dx_mm: Math.round(dx * coefG), snappedCenter_mm});
  }

  attachBoundaries(zone: any, parentBoundaries: any) {
    if (!zone.attrs || !zone.attrs.params) return;
    zone.attrs.params.boundaries = parentBoundaries;
    const params = zone.attrs.params;
    if (!params.isContainer) return;
    const direction = params.containerDirection;
    const splitters = params.innerSplitters || [];
    const children = params.children || [];
    const splitterIds = splitters.map((s: any) =>
      (s.attrs && s.attrs.params && s.attrs.params.splitterId) || null
    );
    for (let i = 0; i < children.length; i++) {
      let childB: any;
      if (direction === 'cols') {
        const left = i === 0 ? parentBoundaries.left : splitterIds[i - 1];
        const right = i === children.length - 1 ? parentBoundaries.right : splitterIds[i];
        childB = {
          left: left,
          right: right,
          top: parentBoundaries.top,
          bottom: parentBoundaries.bottom
        };
      } else {
        const top = i === 0 ? parentBoundaries.top : splitterIds[i - 1];
        const bottom = i === children.length - 1 ? parentBoundaries.bottom : splitterIds[i];
        childB = {
          left: parentBoundaries.left,
          right: parentBoundaries.right,
          top: top,
          bottom: bottom
        };
      }
      this.attachBoundaries(children[i], childB);
    }
  }

  buildSplitterMap(): any {
    const map: any = {};
    const visit = (zone: any) => {
      const params = zone && zone.attrs && zone.attrs.params;
      if (!params || !params.isContainer) return;
      const splitters = params.innerSplitters || [];
      const direction = params.containerDirection;
      for (const s of splitters) {
        if (s && s.attrs && s.attrs.params && s.attrs.params.splitterId) {
          map[s.attrs.params.splitterId] = {splitter: s, parent: zone, direction: direction};
        }
      }
      for (const c of params.children || []) visit(c);
    };
    if (this.coefDoor.DoorWrapper && this.coefDoor.DoorWrapper.children) {
      for (const c of this.coefDoor.DoorWrapper.children) {
        const p = c.attrs && c.attrs.params;
        if (p && p.type === this.coef.id_element.hinged_facade_section && p.depth === 1) {
          visit(c);
        }
      }
    }
    return map;
  }

  makeSplitterPlan(splitter: any, direction: 'rows' | 'cols', parentZone: any, isAuxiliary: boolean): any {
    const visual = splitter.children && splitter.children[0];
    if (!visual) return null;
    const sx = splitter.attrs.x;
    const sy = splitter.attrs.y;
    const sw = visual.attrs.width;
    const sh = visual.attrs.height;
    const id = splitter.attrs.params.splitterId;
    const myBoundaries = parentZone.attrs.params.boundaries || {
      left: 'CAB_LEFT', right: 'CAB_RIGHT', top: 'CAB_TOP', bottom: 'CAB_BOTTOM'
    };
    if (direction === 'cols') {
      return {
        id: id,
        direction: 'vertical',
        axisPos: sx + sw / 2,
        rangeStart: sy,
        rangeEnd: sy + sh,
        startDep: myBoundaries.top,
        endDep: myBoundaries.bottom,
        isAuxiliary: isAuxiliary
      };
    }
    return {
      id: id,
      direction: 'horizontal',
      axisPos: sy + sh / 2,
      rangeStart: sx,
      rangeEnd: sx + sw,
      startDep: myBoundaries.left,
      endDep: myBoundaries.right,
      isAuxiliary: isAuxiliary
    };
  }

  addAuxiliaryFromTree(plans: any[], splitterMap: any) {
    const planIds: any = {};
    for (const p of plans) planIds[p.id] = true;
    let safety = 0;
    let added = true;
    while (added && safety < 32) {
      safety++;
      added = false;
      for (const p of plans.slice()) {
        for (const depKey of ['startDep', 'endDep']) {
          const depId = p[depKey];
          if (!depId) continue;
          if (typeof depId === 'string' && depId.indexOf('CAB_') === 0) continue;
          if (planIds[depId]) continue;
          const info = splitterMap[depId];
          if (!info) continue;
          const aux = this.makeSplitterPlan(info.splitter, info.direction, info.parent, true);
          if (!aux) continue;
          plans.push(aux);
          planIds[aux.id] = true;
          added = true;
          console.log('[PART] AUX added', {forPlan: p.id, on: depKey, auxId: aux.id, direction: aux.direction});
        }
      }
    }
  }

  collectPlansTreeBased(zone: any, plans: any[]) {
    if (!zone.attrs || !zone.attrs.params) return;
    if (!zone.attrs.params.isContainer) return;
    const splitters = zone.attrs.params.innerSplitters || [];
    const children = zone.attrs.params.children || [];
    const direction = zone.attrs.params.containerDirection;
    const myBoundaries = zone.attrs.params.boundaries;
    for (let i = 0; i < splitters.length; i++) {
      const splitter = splitters[i];
      const leftZone = children[i];
      const rightZone = children[i + 1];
      if (!this.shouldDrawPartition(leftZone, rightZone, direction)) continue;
      const visual = splitter.children && splitter.children[0];
      if (!visual) continue;
      const sx = splitter.attrs.x;
      const sy = splitter.attrs.y;
      const sw = visual.attrs.width;
      const sh = visual.attrs.height;
      const splitterId = splitter.attrs.params.splitterId;
      if (direction === 'cols') {
        plans.push({
          id: splitterId,
          direction: 'vertical',
          axisPos: sx + sw / 2,
          rangeStart: sy,
          rangeEnd: sy + sh,
          startDep: myBoundaries.top,
          endDep: myBoundaries.bottom,
          isAuxiliary: false
        });
      } else {
        plans.push({
          id: splitterId,
          direction: 'horizontal',
          axisPos: sy + sh / 2,
          rangeStart: sx,
          rangeEnd: sx + sw,
          startDep: myBoundaries.left,
          endDep: myBoundaries.right,
          isAuxiliary: false
        });
      }
    }
    for (const c of children) {
      this.collectPlansTreeBased(c, plans);
    }
  }

  collectPlans(zone: any, plans: any[], makeId: () => string) {
    if (!zone.attrs || !zone.attrs.params) return;
    if (!zone.attrs.params.isContainer) return;
    const splitters = zone.attrs.params.innerSplitters || [];
    const children = zone.attrs.params.children || [];
    const direction = zone.attrs.params.containerDirection;
    for (let i = 0; i < splitters.length; i++) {
      const splitter = splitters[i];
      const leftZone = children[i];
      const rightZone = children[i + 1];
      if (!this.shouldDrawPartition(leftZone, rightZone, direction)) continue;
      const visual = splitter.children && splitter.children[0];
      if (!visual) continue;
      const sx = splitter.attrs.x;
      const sy = splitter.attrs.y;
      const sw = visual.attrs.width;
      const sh = visual.attrs.height;
      if (direction === 'cols') {
        plans.push({
          id: makeId(),
          direction: 'vertical',
          axisPos: sx + sw / 2,
          rangeStart: sy,
          rangeEnd: sy + sh,
          isAuxiliary: false,
          startDep: 'cabinet',
          endDep: 'cabinet'
        });
      } else {
        plans.push({
          id: makeId(),
          direction: 'horizontal',
          axisPos: sy + sh / 2,
          rangeStart: sx,
          rangeEnd: sx + sw,
          isAuxiliary: false,
          startDep: 'cabinet',
          endDep: 'cabinet'
        });
      }
    }
    for (const c of children) {
      this.collectPlans(c, plans, makeId);
    }
  }

  addAuxiliaryPlans(plans: any[], makeId: () => string) {
    const flat = this.coef.global_size_flat;
    const cabW = this.coef.setingsWardrobe.width / this.coef.global_coef;
    const cabH = this.coef.setingsWardrobe.height / this.coef.global_coef;
    const centerX = (this.coef.widthWrapper - cabW) / 2;
    const cabInnerLeft = centerX + flat;
    const cabInnerRight = centerX + cabW - flat;
    const cabInnerTop = this.coef.topPositaionWrapper + flat;
    const cabInnerBottom = this.coef.topPositaionWrapper + cabH - flat - this.coef.height_legs;
    const tol = 0.5;
    const half = flat / 2;

    const eq = (a: number, b: number) => Math.abs(a - b) < tol;
    const within = (x: number, c: number) => x >= c - half - tol && x <= c + half + tol;

    const findVerticalAt = (x: number, y: number) => {
      for (const p of plans) {
        if (p.direction !== 'vertical') continue;
        if (!within(x, p.axisPos)) continue;
        if (y >= p.rangeStart - tol && y <= p.rangeEnd + tol) return p;
      }
      return null;
    };
    const findHorizontalAt = (y: number, x: number) => {
      for (const p of plans) {
        if (p.direction !== 'horizontal') continue;
        if (!within(y, p.axisPos)) continue;
        if (x >= p.rangeStart - tol && x <= p.rangeEnd + tol) return p;
      }
      return null;
    };

    let safety = 0;
    let added = true;
    while (added && safety < 8) {
      added = false;
      safety++;
      for (const p of plans.slice()) {
        if (p.direction === 'horizontal') {
          if (!eq(p.rangeStart, cabInnerLeft) && p.startDep === 'cabinet') {
            const v = findVerticalAt(p.rangeStart, p.axisPos);
            if (v) {
              p.startDep = v.id;
            } else {
              const aux = {
                id: makeId(),
                direction: 'vertical',
                axisPos: p.rangeStart,
                rangeStart: cabInnerTop,
                rangeEnd: cabInnerBottom,
                isAuxiliary: true,
                startDep: 'cabinet',
                endDep: 'cabinet'
              };
              plans.push(aux);
              p.startDep = aux.id;
              added = true;
            }
          }
          if (!eq(p.rangeEnd, cabInnerRight) && p.endDep === 'cabinet') {
            const v = findVerticalAt(p.rangeEnd, p.axisPos);
            if (v) {
              p.endDep = v.id;
            } else {
              const aux = {
                id: makeId(),
                direction: 'vertical',
                axisPos: p.rangeEnd,
                rangeStart: cabInnerTop,
                rangeEnd: cabInnerBottom,
                isAuxiliary: true,
                startDep: 'cabinet',
                endDep: 'cabinet'
              };
              plans.push(aux);
              p.endDep = aux.id;
              added = true;
            }
          }
        } else {
          if (!eq(p.rangeStart, cabInnerTop) && p.startDep === 'cabinet') {
            const h = findHorizontalAt(p.rangeStart, p.axisPos);
            if (h) {
              p.startDep = h.id;
            } else {
              const aux = {
                id: makeId(),
                direction: 'horizontal',
                axisPos: p.rangeStart,
                rangeStart: cabInnerLeft,
                rangeEnd: cabInnerRight,
                isAuxiliary: true,
                startDep: 'cabinet',
                endDep: 'cabinet'
              };
              plans.push(aux);
              p.startDep = aux.id;
              added = true;
            }
          }
          if (!eq(p.rangeEnd, cabInnerBottom) && p.endDep === 'cabinet') {
            const h = findHorizontalAt(p.rangeEnd, p.axisPos);
            if (h) {
              p.endDep = h.id;
            } else {
              const aux = {
                id: makeId(),
                direction: 'horizontal',
                axisPos: p.rangeEnd,
                rangeStart: cabInnerLeft,
                rangeEnd: cabInnerRight,
                isAuxiliary: true,
                startDep: 'cabinet',
                endDep: 'cabinet'
              };
              plans.push(aux);
              p.endDep = aux.id;
              added = true;
            }
          }
        }
      }
    }
  }

  topoSortPlans(plans: any[]): any[] {
    const byId: any = {};
    for (const p of plans) byId[p.id] = p;
    const visited: any = {};
    const result: any[] = [];
    const visit = (p: any) => {
      if (visited[p.id]) return;
      visited[p.id] = true;
      if (p.startDep && p.startDep !== 'cabinet' && byId[p.startDep]) visit(byId[p.startDep]);
      if (p.endDep && p.endDep !== 'cabinet' && byId[p.endDep]) visit(byId[p.endDep]);
      result.push(p);
    };
    for (const p of plans) visit(p);
    return result;
  }

  snapMmTowardCabinetCenter(valueMm: number, cabinetCenterMm: number): number {
    const floor = Math.floor(valueMm);
    const ceil = Math.ceil(valueMm);
    if (floor === ceil) return valueMm;
    const frac = valueMm - floor;
    if (Math.abs(frac - 0.5) < 0.001) {
      if (valueMm < cabinetCenterMm - 0.001) return ceil;
      return floor;
    }
    return Math.round(valueMm);
  }

  // Знайти БЕЗПОСЕРЕДНЬОГО сусіда (door-leaf) на боці перегородки. Для простого кейсу
  // (leftFacade/rightFacade сам по собі лист) — повертає його. Для контейнерів — копає
  // у потрібний бік (рекурсивно). Повертає null якщо не знайдено leaf з sectionKind='door'.
  // side: 'left' = ми шукаємо ліву сусідню дверку (тобто з боку leftFacade сплітера),
  //       'right' = праву.
  findNeighborDoorLeaf(facade: any, fromDirection: 'cols' | 'rows', wantSide: 'left' | 'right' | 'top' | 'bottom'): any {
    if (!facade || !facade.attrs || !facade.attrs.params) return null;
    const p = facade.attrs.params;
    if (!p.isContainer) {
      // Це лист. Дверка з петлями що сидять у нашому напрямку?
      if (p.sectionKind !== 'door') return null;
      return facade;
    }
    // Контейнер. Копаємо у бік wantSide.
    const dir = p.containerDirection;
    const children = p.children || [];
    if (children.length === 0) return null;
    // Для cols-контейнера межа з нами по horizontal — беремо крайнього дітя за wantSide.
    if (fromDirection === 'cols') {
      // wantSide: 'left' = ми ЗЛІВА від сплітера → перейти у найправішого дітя в leftFacade.
      //          'right' = ми справа → найлівіший дитя у rightFacade.
      if (dir === 'cols') {
        const idx = wantSide === 'left' ? children.length - 1 : 0;
        return this.findNeighborDoorLeaf(children[idx], fromDirection, wantSide);
      }
      // dir === 'rows' — у вертикальному стеку всі діти потенційно межують зі сплітером.
      // Беремо ПЕРШОГО з door-leaf (як спрощення).
      for (const c of children) {
        const found = this.findNeighborDoorLeaf(c, fromDirection, wantSide);
        if (found) return found;
      }
      return null;
    }
    // fromDirection === 'rows' — аналогічно для горизонтального сплітера (полиця).
    if (dir === 'rows') {
      const idx = wantSide === 'top' ? children.length - 1 : 0;
      return this.findNeighborDoorLeaf(children[idx], fromDirection, wantSide);
    }
    for (const c of children) {
      const found = this.findNeighborDoorLeaf(c, fromDirection, wantSide);
      if (found) return found;
    }
    return null;
  }

  // Чи сидять на сплітері петлі сусідньої дверки. Тип петлі визначає бек (на перегородці —
  // завжди напівнакладна), тож така перегородка/полиця стоїть рівно по центру зазору фасадів.
  // splitter: Konva-вузол сплітера; direction: 'cols' (vertical partition) / 'rows' (horizontal shelf).
  splitterCarriesHinges(splitter: any, direction: 'cols' | 'rows'): boolean {
    if (!splitter || !splitter.attrs || !splitter.attrs.params) return false;
    const leftFacade = splitter.attrs.params.leftFacade;
    const rightFacade = splitter.attrs.params.rightFacade;
    if (direction === 'cols') {
      const leftDoor = this.findNeighborDoorLeaf(leftFacade, 'cols', 'left');
      const rightDoor = this.findNeighborDoorLeaf(rightFacade, 'cols', 'right');
      return !!((leftDoor && leftDoor.attrs.params.swingDir === 'left')
        || (rightDoor && rightDoor.attrs.params.swingDir === 'right'));
    }
    const topDoor = this.findNeighborDoorLeaf(leftFacade, 'rows', 'top');
    const bottomDoor = this.findNeighborDoorLeaf(rightFacade, 'rows', 'bottom');
    return !!((topDoor && topDoor.attrs.params.swingDir === 'up')
      || (bottomDoor && bottomDoor.attrs.params.swingDir === 'down'));
  }

  // Зсув (мм) перегородки/полиці сплітера, якщо відкрита секція торкається його рівно з одного
  // боку: на крок partition/shelf_facade_gap_step у бік від неї (+ = вправо/вниз). Відкрита з обох
  // боків (сховатись нікуди) або з жодного — null.
  openSectionGapOffsetMm(splitter: any, direction: 'cols' | 'rows'): number | null {
    const sp = splitter && splitter.attrs && splitter.attrs.params;
    if (!sp || !sp.splitterId) return null;
    const id = sp.splitterId;
    const openBefore = this.zoneHasOpenLeafOnBoundary(sp.leftFacade, direction === 'cols' ? 'right' : 'bottom', id);
    const openAfter = this.zoneHasOpenLeafOnBoundary(sp.rightFacade, direction === 'cols' ? 'left' : 'top', id);
    if (openBefore === openAfter) return null;
    const sv = this.coef.spec_values || {};
    const key = direction === 'cols' ? 'partition_facade_gap_step' : 'shelf_facade_gap_step';
    const stepMm = sv[key] > 0 ? sv[key] : Math.round(this.coef.global_size_flat * this.coef.global_coef / 2);
    return openBefore ? stepMm : -stepMm;
  }

  zoneHasOpenLeafOnBoundary(zone: any, side: 'left' | 'right' | 'top' | 'bottom', splitterId: any): boolean {
    const p = zone && zone.attrs && zone.attrs.params;
    if (!p) return false;
    if (p.isContainer) {
      return (p.children || []).some((c: any) => this.zoneHasOpenLeafOnBoundary(c, side, splitterId));
    }
    return p.sectionKind === 'open' && !!p.boundaries && p.boundaries[side] === splitterId;
  }

  // Тип петлі для бекенду. Лише для петель на НАШИХ перегородках/полицях (стіни/подвійна
  // перегородка → null, бек визначає сам): по центру зазору — 'half'; зсунута під дверку цієї
  // петлі — 'outer'; зсунута від неї — 'inner'. Рахуємо з поточної геометрії, тож враховує і драг.
  hingeTypeOf(hinge: any): 'half' | 'outer' | 'inner' | null {
    const hp = hinge && hinge.attrs && hinge.attrs.params;
    const sup = hp && hp.supportEl;
    const sp = sup && sup.attrs && sup.attrs.params;
    if (!sp || !sp.autoFromHinged || sp.gapCenterPx == null) return null;
    const coefG = this.coef.global_coef;
    const isVertical = hp.orientation === 'vertical';
    const center = (isVertical ? sup.attrs.x : sup.attrs.y) + this.coef.global_size_flat / 2;
    const offMm = (center - sp.gapCenterPx) * coefG;
    const sv = this.coef.spec_values || {};
    const key = isVertical ? 'partition_facade_gap_step' : 'shelf_facade_gap_step';
    const stepMm = sv[key] > 0 ? sv[key] : this.coef.global_size_flat * coefG / 2;
    if (Math.abs(offMm) < stepMm / 2) return 'half';
    // followOffsetPx < 0 — петля (і її дверка) зліва/зверху від опори
    const doorSign = (hp.followOffsetPx || 0) < 0 ? -1 : 1;
    return Math.sign(offMm) === doorSign ? 'outer' : 'inner';
  }

  executePlan(plan: any) {
    if (!this.create) return;
    const coefG = this.coef.global_coef;
    const flatHalf = this.coef.global_size_flat / 2;
    const cabW = this.coef.setingsWardrobe.width / coefG;
    const cabH = this.coef.setingsWardrobe.height / coefG;
    const cabLeftX = (this.coef.widthWrapper - cabW) / 2;
    const cabCenterX_px = cabLeftX + cabW / 2;
    const cabCenterY_px = this.coef.topPositaionWrapper + cabH / 2;
    // Ручний зсув перегородки/полиці відносно зазору фасадів (зберігається на сплітері)
    const splInfo = this.currentSplitterMap ? this.currentSplitterMap[plan.id] : null;
    // Відкрита секція рівно з одного боку → зсув на крок від неї (ховаємось під фасад навпроти).
    // Інакше перегородка/полиця з петлями — по центру зазору; скидаємо і старий авто-зсув
    // (відкрита секція могла зникнути), і offset зі старих збережень.
    if (splInfo && splInfo.splitter) {
      const sp = splInfo.splitter.attrs.params;
      const openMm = this.openSectionGapOffsetMm(splInfo.splitter, splInfo.direction);
      if (openMm != null) {
        sp.manualGapOffset = openMm;
        sp.gapOffsetFromOpen = true;
      } else if (sp.gapOffsetFromOpen || this.splitterCarriesHinges(splInfo.splitter, splInfo.direction)) {
        sp.manualGapOffset = 0;
        sp.gapOffsetFromOpen = false;
      }
    }
    const manualMm = (splInfo && splInfo.splitter && splInfo.splitter.attrs.params.manualGapOffset)
      ? splInfo.splitter.attrs.params.manualGapOffset : 0;
    let dropX: number, dropY: number;
    if (plan.direction === 'vertical') {
      dropX = (plan.axisPos + manualMm / coefG) - flatHalf;
      dropY = (plan.rangeStart + plan.rangeEnd) / 2;
      const dropX_mm = dropX * coefG;
      const snapped_mm = this.snapMmTowardCabinetCenter(dropX_mm, cabCenterX_px * coefG);
      dropX = snapped_mm / coefG;
    } else {
      dropX = (plan.rangeStart + plan.rangeEnd) / 2;
      dropY = (plan.axisPos + manualMm / coefG) - flatHalf;
      const dropY_mm = dropY * coefG;
      const snapped_mm = this.snapMmTowardCabinetCenter(dropY_mm, cabCenterY_px * coefG);
      dropY = snapped_mm / coefG;
    }
    const pos = {evt: {layerX: dropX, layerY: dropY}};
    const xy = {x: dropX, y: dropY};
    console.log('[PART] executePlan', {
      id: plan.id,
      direction: plan.direction,
      auxiliary: plan.isAuxiliary,
      dropX_mm: Math.round(dropX * coefG),
      dropY_mm: Math.round(dropY * coefG)
    });
    const beforeCount = this.coef.shapesLayerw.children.length;
    try {
      if (plan.direction === 'vertical') {
        new Partition(this.coef, this.create, true).createFromParitation(pos, xy);
      } else {
        new Shelf(this.coef, this.create, true, 20).createShell(pos, xy, true, true);
      }
    } catch (err) {
      console.warn('[PART] executePlan failed', err);
    }
    const afterCount = this.coef.shapesLayerw.children.length;
    if (afterCount === beforeCount) {
      console.warn('[PART] executePlan REJECTED by validation', {
        id: plan.id,
        direction: plan.direction,
        auxiliary: plan.isAuxiliary,
        dropX_mm: Math.round(dropX * coefG),
        dropY_mm: Math.round(dropY * coefG),
        rangeStart_mm: Math.round(plan.rangeStart * coefG),
        rangeEnd_mm: Math.round(plan.rangeEnd * coefG),
        startDep: plan.startDep,
        endDep: plan.endDep
      });
    } else {
      console.log('[PART] executePlan OK', {id: plan.id, added: afterCount - beforeCount});
    }
    const wantType = plan.direction === 'vertical' ? this.coef.id_element.partition : this.coef.id_element.shelf;
    for (let i = beforeCount; i < afterCount; i++) {
      const newElem: any = this.coef.shapesLayerw.children[i];
      if (newElem && newElem.attrs && newElem.attrs.params) {
        newElem.attrs.params.autoFromHinged = true;
        const sizes = newElem.attrs.params.size;
        if (Array.isArray(sizes)) {
          for (const s of sizes) {
            if (s && s.attrs && s.attrs.params) {
              s.attrs.params.autoFromHinged = true;
            }
          }
        }
        // Крок 4: перегородку/полицю можна рухати з нашим кроком; завіси їдуть з нею.
        if (newElem.attrs.params.type === wantType) {
          newElem.attrs.params.sourceSplitterId = plan.id;
          newElem.attrs.params.gapCenterPx = plan.axisPos;
          newElem.attrs.params.planDirection = plan.direction;
          newElem.attrs.params.hingeBind = [];
          this.attachHingedAutoDrag(newElem);
        }
      }
    }
  }

  // Крок 4: перетягування авто-перегородки (вертик.) / авто-полиці (гориз.) відносно зазору фасадів.
  // Крок partition/shelf_facade_gap_step, клам ±max_*_facade_gap_offset. Сусіди ресайзяться самі
  // (bindingTocounters). Завіси їдуть за елементом (params.hingeBind). offset → на сплітер.
  // min-size.service для цих елементів робить return, тож цей dragBoundFunc не перетирається.
  attachHingedAutoDrag(elem: any) {
    const coefG = this.coef.global_coef;
    const sv = this.coef.spec_values || {};
    const flatHalf = this.coef.global_size_flat / 2;
    const isVertical = elem.attrs.params.planDirection === 'vertical';
    const gapCenterPx = elem.attrs.params.gapCenterPx;
    const stepMm = isVertical
      ? (sv['partition_facade_gap_step'] != null ? sv['partition_facade_gap_step'] : 1)
      : (sv['shelf_facade_gap_step'] != null ? sv['shelf_facade_gap_step'] : 1);
    // Лише 3 позиції відносно gapCenterPx: −step, 0, +step. maxOff = step (а НЕ зі спеки).
    const step = (stepMm > 0 ? stepMm : 1) / coefG;
    const maxOff = step;

    const snapClampCenter = (centerPx: number) => {
      let off = centerPx - gapCenterPx;
      off = Math.round(off / step) * step;
      off = Math.max(-maxOff, Math.min(maxOff, off));
      const resultPx = gapCenterPx + off;
      return Math.round(resultPx * coefG) / coefG; // цілі мм (без коми)
    };

    elem.draggable(true);
    const stage = this.coef.shapesLayerw && this.coef.shapesLayerw.getStage();
    elem.on('mouseenter', () => { if (stage && stage.container()) stage.container().style.cursor = isVertical ? 'ew-resize' : 'ns-resize'; });
    elem.on('mouseleave', () => { if (stage && stage.container()) stage.container().style.cursor = 'default'; });

    // dragstart: кешуємо вільний проміжок до петель (ВИКЛЮЧАЮЧИ власні петлі — вони їдуть із елементом)
    elem.on('dragstart', () => {
      elem.attrs.params._hingeGap = this.hingeGapForMove(elem, elem.attrs.params.hingeBind);
    });

    elem.dragBoundFunc((pos: any) => {
      const hg = elem.attrs.params._hingeGap;
      if (isVertical) {
        let left = snapClampCenter(pos.x + flatHalf) - flatHalf;   // крок 9 + клам ±18 від центру зазору
        if (hg) left = Math.max(hg.min, Math.min(hg.max, left));    // + впирається в чужі петлі
        return {x: left, y: elem.getAbsolutePosition().y};
      } else {
        let top = snapClampCenter(pos.y + flatHalf) - flatHalf;
        if (hg) top = Math.max(hg.min, Math.min(hg.max, top));
        return {x: elem.getAbsolutePosition().x, y: top};
      }
    });

    // завіси їдуть за елементом: ставимо їх на (новий центр + збережений followOffset)
    elem.off('dragmove.hingefollow');
    elem.on('dragmove.hingefollow', () => {
      const center = isVertical ? elem.attrs.x + flatHalf : elem.attrs.y + flatHalf;
      const hb = elem.attrs.params.hingeBind || [];
      for (const h of hb) {
        if (!h || !h.attrs) continue;
        const off = (h.attrs.params && h.attrs.params.followOffsetPx) || 0;
        if (isVertical) h.x(center + off); else h.y(center + off);
      }
      this.coef.shapesLayerw.batchDraw();
    });

    elem.on('dragend', () => {
      const centerPx = isVertical ? elem.attrs.x + flatHalf : elem.attrs.y + flatHalf;
      const offMm = Math.round((centerPx - gapCenterPx) * coefG);
      const splId = elem.attrs.params.sourceSplitterId;
      const info = this.currentSplitterMap ? this.currentSplitterMap[splId] : null;
      if (info && info.splitter) info.splitter.attrs.params.manualGapOffset = offMm;
      elem.attrs.params._hingeGap = null;
      // КРОК ШАФИ: НЕ перебілдимо петлі. Вони вже поїхали з перегородкою (hingefollow) під час драгу;
      // offMm збережено лише для майбутнього перебілду на КРОЦІ ФАСАДІВ.
      this.coef.shapesLayerw.batchDraw();
      if (this.onAfterResize) this.onAfterResize();
    });
  }

  countExpectedPartitions(zone: any, accumulator: {vertical: number, horizontal: number, total: number}) {
    if (!zone.attrs || !zone.attrs.params) return;
    if (!zone.attrs.params.isContainer) return;
    const splitters = zone.attrs.params.innerSplitters || [];
    const children = zone.attrs.params.children || [];
    const direction = zone.attrs.params.containerDirection;
    for (let i = 0; i < splitters.length; i++) {
      if (this.shouldDrawPartition(children[i], children[i + 1], direction)) {
        if (direction === 'cols') accumulator.vertical++;
        else accumulator.horizontal++;
        accumulator.total++;
      }
    }
    for (const c of children) {
      this.countExpectedPartitions(c, accumulator);
    }
  }

  collectAndDrawPartitions(zone: any) {
    if (!zone.attrs || !zone.attrs.params) return;
    if (!zone.attrs.params.isContainer) return;
    const splitters = zone.attrs.params.innerSplitters || [];
    const children = zone.attrs.params.children || [];
    const direction = zone.attrs.params.containerDirection;

    console.log('[PART] container', {
      zoneName: zone.attrs.params.zoneName,
      direction: direction,
      childrenCount: children.length,
      splittersCount: splitters.length
    });

    for (let i = 0; i < splitters.length; i++) {
      const splitter = splitters[i];
      const leftZone = children[i];
      const rightZone = children[i + 1];
      const should = this.shouldDrawPartition(leftZone, rightZone, direction);
      console.log('[PART] splitter', {
        i: i,
        direction: direction,
        leftName: leftZone && leftZone.attrs && leftZone.attrs.params && leftZone.attrs.params.zoneName,
        leftKind: leftZone && leftZone.attrs && leftZone.attrs.params && leftZone.attrs.params.sectionKind,
        leftSwingDir: leftZone && leftZone.attrs && leftZone.attrs.params && leftZone.attrs.params.swingDir,
        rightName: rightZone && rightZone.attrs && rightZone.attrs.params && rightZone.attrs.params.zoneName,
        rightKind: rightZone && rightZone.attrs && rightZone.attrs.params && rightZone.attrs.params.sectionKind,
        rightSwingDir: rightZone && rightZone.attrs && rightZone.attrs.params && rightZone.attrs.params.swingDir,
        decision: should ? 'DRAW' : 'SKIP'
      });
      if (should) {
        this.drawAutoPartition(splitter, direction);
      }
    }

    for (const c of children) {
      this.collectAndDrawPartitions(c);
    }
  }

  shouldDrawPartition(leftZone: any, rightZone: any, direction: 'rows' | 'cols'): boolean {
    const leftSide = direction === 'cols' ? 'right' : 'bottom';
    const rightSide = direction === 'cols' ? 'left' : 'top';
    if (direction === 'rows'
      && this.zoneAllLeavesAreDrawers(leftZone)
      && this.zoneAllLeavesAreDrawers(rightZone)) {
      console.log('[PART] shouldDrawPartition SUPPRESSED (drawer stack continues)');
      return false;
    }
    const leftNeed = this.zoneNeedsPartitionOnSide(leftZone, leftSide);
    const rightNeed = this.zoneNeedsPartitionOnSide(rightZone, rightSide);
    console.log('[PART] shouldDrawPartition', {
      direction: direction,
      leftSide: leftSide,
      rightSide: rightSide,
      leftNeed: leftNeed,
      rightNeed: rightNeed
    });
    return leftNeed || rightNeed;
  }

  zoneAllLeavesAreDrawers(zone: any): boolean {
    if (!zone || !zone.attrs || !zone.attrs.params) return false;
    const params = zone.attrs.params;
    if (!params.isContainer) {
      return params.sectionKind === 'drawers';
    }
    const children = params.children || [];
    if (children.length === 0) return false;
    for (const c of children) {
      if (!this.zoneAllLeavesAreDrawers(c)) return false;
    }
    return true;
  }

  zoneAllLeavesHaveKind(zone: any): boolean {
    if (!zone || !zone.attrs || !zone.attrs.params) return false;
    const params = zone.attrs.params;
    if (!params.isContainer) {
      return params.sectionKind != null;
    }
    const children = params.children || [];
    if (children.length === 0) return false;
    for (const c of children) {
      if (!this.zoneAllLeavesHaveKind(c)) return false;
    }
    return true;
  }

  zoneAllLeavesOpen(zone: any): boolean {
    if (!zone || !zone.attrs || !zone.attrs.params) return false;
    const params = zone.attrs.params;
    if (!params.isContainer) {
      return params.sectionKind === 'open';
    }
    const children = params.children || [];
    if (children.length === 0) return false;
    for (const c of children) {
      if (!this.zoneAllLeavesOpen(c)) return false;
    }
    return true;
  }

  zoneNeedsPartitionOnSide(zone: any, side: 'left' | 'right' | 'top' | 'bottom'): boolean {
    if (!zone || !zone.attrs || !zone.attrs.params) return false;
    const params = zone.attrs.params;
    if (!params.isContainer) {
      return this.leafNeedsPartitionOnSide(zone, side);
    }
    const dir = params.containerDirection;
    const children = params.children || [];
    const isParallel = (dir === 'cols' && (side === 'left' || side === 'right'))
      || (dir === 'rows' && (side === 'top' || side === 'bottom'));
    if (isParallel) {
      const idx = (side === 'left' || side === 'top') ? 0 : children.length - 1;
      return this.zoneNeedsPartitionOnSide(children[idx], side);
    }
    for (const c of children) {
      if (this.zoneNeedsPartitionOnSide(c, side)) return true;
    }
    return false;
  }

  leafNeedsPartitionOnSide(leaf: any, side: 'left' | 'right' | 'top' | 'bottom'): boolean {
    const kind = leaf.attrs.params.sectionKind;
    const zoneName = leaf.attrs.params.zoneName;
    let result = false;
    let reason = '';
    if (!kind) { result = false; reason = 'kind=null'; }
    else if (kind === 'open') { result = true; reason = 'open needs all sides'; }
    else if (kind === 'drawers') {
      if (side === 'left' || side === 'right' || side === 'top') {
        result = true;
        reason = 'drawers needs ' + side;
      } else {
        result = false;
        reason = 'drawers does not need bottom';
      }
    } else if (kind === 'door') {
      const sd = leaf.attrs.params.swingDir;
      if (!sd) { result = false; reason = 'door without swingDir'; }
      else {
        if (sd === 'left' && side === 'right') { result = true; reason = 'door swing=left → hinge=right'; }
        else if (sd === 'right' && side === 'left') { result = true; reason = 'door swing=right → hinge=left'; }
        else if (sd === 'up' && side === 'bottom') { result = true; reason = 'door swing=up → hinge=bottom'; }
        else if (sd === 'down' && side === 'top') { result = true; reason = 'door swing=down → hinge=top'; }
        else { result = false; reason = `door swing=${sd} no hinge on side=${side}`; }
      }
    }
    console.log('[PART] leafNeedsPartitionOnSide', {zoneName, kind, side, result, reason});
    return result;
  }

  drawAutoPartition(splitter: any, direction: 'rows' | 'cols') {
    const visual = splitter.children && splitter.children[0];
    if (!visual) return;
    if (!this.create) return;
    const coefG = this.coef.global_coef;

    const sx = splitter.attrs.x;
    const sy = splitter.attrs.y;
    const sw = visual.attrs.width;
    const sh = visual.attrs.height;

    let dropX: number, dropY: number;
    if (direction === 'cols') {
      const centerXmm = Math.round((sx + sw / 2) * coefG);
      dropX = centerXmm / coefG;
      dropY = sy + sh / 2;
    } else {
      const centerYmm = Math.round((sy + sh / 2) * coefG);
      dropX = sx + sw / 2;
      dropY = centerYmm / coefG;
    }

    const dropXmm = Math.round(dropX * coefG);
    const dropYmm = Math.round(dropY * coefG);
    console.log('[PART] drawAutoPartition (via standard class)', {
      direction: direction,
      dropX_px: dropX,
      dropY_px: dropY,
      dropX_mm: dropXmm,
      dropY_mm: dropYmm
    });

    const pos = {evt: {layerX: dropX, layerY: dropY}};
    const xy = {x: dropX, y: dropY};

    const beforeCount = this.coef.shapesLayerw.children.length;
    try {
      if (direction === 'cols') {
        new Partition(this.coef, this.create, true).createFromParitation(pos, xy);
      } else {
        new Shelf(this.coef, this.create, true, 20).createShell(pos, xy, true);
      }
    } catch (err) {
      console.warn('[PART] standard create failed', err);
    }
    const afterCount = this.coef.shapesLayerw.children.length;
    for (let i = beforeCount; i < afterCount; i++) {
      const newElem: any = this.coef.shapesLayerw.children[i];
      if (newElem && newElem.attrs && newElem.attrs.params) {
        newElem.attrs.params.autoFromHinged = true;
        const sizes = newElem.attrs.params.size;
        if (Array.isArray(sizes)) {
          for (const s of sizes) {
            if (s && s.attrs && s.attrs.params) {
              s.attrs.params.autoFromHinged = true;
            }
          }
        }
      }
    }
  }

  splitInto(parentGroup: any, direction: 'rows' | 'cols', count: number) {
    if (!parentGroup || !parentGroup.children || !parentGroup.children[0]) return;
    const facade = parentGroup.children[0];
    const px = parentGroup.attrs.x;
    const py = parentGroup.attrs.y;
    const pw = facade.attrs.width;
    const ph = facade.attrs.height;
    const params = parentGroup.attrs.params || {};
    const isInset = params.isInset;
    const depth = (params.depth || 1) + 1;
    const baseName = params.zoneName || 'zone';
    const coefG = this.coef.global_coef;
    const hf = this.coef.hingedFacade || {};
    const gapMm = hf.facade_gap_size != null ? Math.round(hf.facade_gap_size * coefG) : 0;
    const gapPx = gapMm / coefG;

    const totalMm = direction === 'cols'
      ? Math.round(pw * coefG) - (count - 1) * gapMm
      : Math.round(ph * coefG) - (count - 1) * gapMm;
    const baseMm = Math.floor(totalMm / count);
    const lastMm = totalMm - baseMm * (count - 1);

    for (let i = parentGroup.children.length - 1; i >= 0; i--) {
      parentGroup.children[i].destroy();
    }
    parentGroup.attrs.params.isContainer = true;
    parentGroup.attrs.params.containerDirection = direction;
    parentGroup.attrs.params.children = [];
    parentGroup.attrs.params.innerSplitters = [];
    parentGroup.attrs.params.originalFacadeWidth = pw;
    parentGroup.attrs.params.originalFacadeHeight = ph;
    parentGroup.attrs.params.originalIsInset = isInset;

    const parentLastDir = params.lastDir || null;
    const parentSwitchCount = params.switchCount || 0;
    const childLastDir = direction;
    const childSwitchCount = (parentLastDir == null || parentLastDir === direction)
      ? parentSwitchCount
      : parentSwitchCount + 1;

    const newFacades: any[] = [];
    let cursor = 0;
    for (let i = 0; i < count; i++) {
      const sizeMm = i === count - 1 ? lastMm : baseMm;
      const sizePx = sizeMm / coefG;
      let cx, cy, cw, ch;
      if (direction === 'cols') {
        cw = sizePx;
        ch = ph;
        cx = px + cursor;
        cy = py;
      } else {
        cw = pw;
        ch = sizePx;
        cx = px;
        cy = py + cursor;
      }
      const g = this.createFacadeGroup(baseName + '.' + i, cx, cy, cw, ch, isInset, depth, childLastDir, childSwitchCount);
      g.attrs.params.parent = parentGroup;
      newFacades.push(g);
      cursor += sizePx + gapPx;
    }
    parentGroup.attrs.params.children = newFacades;

    const innerSplitters: any[] = [];
    for (let i = 0; i < count - 1; i++) {
      const s = this.createSplitter(newFacades[i], newFacades[i + 1], direction);
      innerSplitters.push(s);
    }
    parentGroup.attrs.params.innerSplitters = innerSplitters;

    this.ensureSplittersOnTop();
    console.log('[HINGED] splitInto', {direction, count, totalMm, baseMm, lastMm, gapMm});
    this.coefDoor.DoorWrapper.batchDraw();
    this.syncPartitionsToCorpus();
  }

  collectUntypedLeaves(): any[] {
    const result: any[] = [];
    const walk = (zone: any) => {
      if (!zone || !zone.attrs || !zone.attrs.params) return;
      const params = zone.attrs.params;
      if (params.isContainer) {
        for (const c of (params.children || [])) walk(c);
        return;
      }
      if (params.type === this.coef.id_element.hinged_facade_section) {
        // 1) Не вибраний тип секції — підсвічуємо.
        if (!params.sectionKind) { result.push(zone); return; }
        // 2) Дверка без сторони відкривання — теж блокуємо перехід.
        if (params.sectionKind === 'door' && !params.swingDir) result.push(zone);
      }
    };
    if (this.coefDoor.DoorWrapper && this.coefDoor.DoorWrapper.children) {
      for (const c of this.coefDoor.DoorWrapper.children) {
        const p = c.attrs && c.attrs.params;
        if (p && p.type === this.coef.id_element.hinged_facade_section && p.depth === 1) {
          walk(c);
        }
      }
    }
    return result;
  }

  highlightUntyped(leaves: any[]) {
    for (const leaf of leaves) {
      const facade = leaf.children && leaf.children[0];
      if (facade && facade.attrs) {
        facade.attrs.params = facade.attrs.params || {};
        facade.attrs.params.__prevStroke = facade.attrs.stroke;
        facade.attrs.params.__prevStrokeWidth = facade.attrs.strokeWidth;
        facade.stroke('#e74c3c');
        facade.strokeWidth(3);
      }
    }
    this.coefDoor.DoorWrapper.batchDraw();
  }

  clearUntypedHighlight() {
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return;
    for (const c of this.coefDoor.DoorWrapper.children) {
      const facade = c.children && c.children[0];
      if (facade && facade.attrs && facade.attrs.params && facade.attrs.params.__prevStroke !== undefined) {
        facade.stroke(facade.attrs.params.__prevStroke);
        facade.strokeWidth(facade.attrs.params.__prevStrokeWidth);
        delete facade.attrs.params.__prevStroke;
        delete facade.attrs.params.__prevStrokeWidth;
      }
    }
    this.coefDoor.DoorWrapper.batchDraw();
  }

  getAllHingedSplitters(): any[] {
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return [];
    const splType = this.coef.id_element.hinged_splitter;
    const out: any[] = [];
    for (const c of this.coefDoor.DoorWrapper.children) {
      if (c.attrs && c.attrs.params && c.attrs.params.type === splType) out.push(c);
    }
    out.sort((a: any, b: any) => {
      if (a.attrs.x !== b.attrs.x) return a.attrs.x - b.attrs.x;
      return a.attrs.y - b.attrs.y;
    });
    return out;
  }

  selectHingedSplitter(splitter: any) {
    const prev = this.coefDoor.selectedHingedSplitter;
    if (prev && prev !== splitter && prev.attrs && prev.attrs.params && prev.attrs.params.visualRect) {
      prev.attrs.params.visualRect.fill(prev.attrs.params.normalFill);
    }
    this.coefDoor.selectedHingedSplitter = splitter;
    if (splitter && splitter.attrs && splitter.attrs.params && splitter.attrs.params.visualRect) {
      splitter.attrs.params.visualRect.fill(splitter.attrs.params.selectedFill);
    }
    this.coefDoor.DoorWrapper.batchDraw();
    console.log('[HINGED] selectHingedSplitter', {
      direction: splitter && splitter.attrs && splitter.attrs.params && splitter.attrs.params.direction,
      x_mm: splitter && Math.round(splitter.attrs.x * this.coef.global_coef),
      y_mm: splitter && Math.round(splitter.attrs.y * this.coef.global_coef)
    });
  }

  clearHingedSplitterSelection() {
    const prev = this.coefDoor.selectedHingedSplitter;
    if (prev && prev.attrs && prev.attrs.params && prev.attrs.params.visualRect) {
      prev.attrs.params.visualRect.fill(prev.attrs.params.normalFill);
    }
    this.coefDoor.selectedHingedSplitter = null;
    this.coefDoor.DoorWrapper.batchDraw();
  }

  cycleHingedSplitter(direction: 'forward' | 'backward') {
    const all = this.getAllHingedSplitters();
    if (all.length === 0) return;
    const current = this.coefDoor.selectedHingedSplitter;
    let idx = -1;
    if (current) {
      idx = all.indexOf(current);
    }
    let nextIdx: number;
    if (idx === -1) {
      nextIdx = direction === 'forward' ? 0 : all.length - 1;
    } else {
      nextIdx = direction === 'forward' ? (idx + 1) % all.length : (idx - 1 + all.length) % all.length;
    }
    this.selectHingedSplitter(all[nextIdx]);
  }

  nudgeSelectedSplitter(deltaMmX: number, deltaMmY: number) {
    const splitter = this.coefDoor.selectedHingedSplitter;
    if (!splitter || !splitter.attrs || !splitter.attrs.params) return;
    const coefG = this.coef.global_coef;
    const dir = splitter.attrs.params.direction;
    const isVertical = dir === 'cols';
    let targetX = splitter.attrs.x;
    let targetY = splitter.attrs.y;
    if (isVertical && deltaMmX !== 0) {
      targetX = splitter.attrs.x + deltaMmX / coefG;
    } else if (!isVertical && deltaMmY !== 0) {
      targetY = splitter.attrs.y + deltaMmY / coefG;
    } else {
      return;
    }
    const boundFn = splitter.dragBoundFunc();
    let clamped: any = {x: targetX, y: targetY};
    if (typeof boundFn === 'function') {
      clamped = boundFn.call(splitter, {x: targetX, y: targetY});
    }
    splitter.x(clamped.x);
    splitter.y(clamped.y);
    splitter.fire('dragmove');
    splitter.fire('dragend');
  }

  unsplit(group: any) {
    if (!group || !group.attrs || !group.attrs.params) return;
    const params = group.attrs.params;
    if (!params.isContainer) return;
    // Поточні межі — з дітей (до їх знищення). Драг сплітерів міняє лише дітей контейнера,
    // його x/y і originalFacade* лишаються з моменту splitInto — відновлення по них давало
    // фасад старого розміру на старому місці (налазив на сусідів / дірка).
    let w = params.originalFacadeWidth;
    let h = params.originalFacadeHeight;
    // ДІАГНОСТИКА "Назад до батька": що було збережено, що рахуємо з дітей, хто сусіди.
    const _mm = (v: number) => (v == null || !isFinite(v)) ? v : Math.round(v * this.coef.global_coef);
    const _edges = (z: any) => ({
      name: z && z.attrs && z.attrs.params && z.attrs.params.zoneName,
      container: !!(z && z.attrs && z.attrs.params && z.attrs.params.isContainer),
      l: _mm(this.getZoneEdge(z, 'left')), r: _mm(this.getZoneEdge(z, 'right')),
      t: _mm(this.getZoneEdge(z, 'top')), b: _mm(this.getZoneEdge(z, 'bottom'))
    });
    const _neighbors: any[] = [];
    for (const c of (this.coefDoor.DoorWrapper.children || [])) {
      const sp = c && c.attrs && c.attrs.params;
      if (!sp || sp.type !== this.coef.id_element.hinged_splitter) continue;
      if (sp.leftFacade !== group && sp.rightFacade !== group) continue;
      _neighbors.push({id: sp.splitterId, dir: sp.direction, x: _mm(c.attrs.x), y: _mm(c.attrs.y),
        side: sp.leftFacade === group ? 'group is LEFT/TOP' : 'group is RIGHT/BOTTOM'});
    }
    console.log('[UNSPLIT] before', {
      zone: params.zoneName, depth: params.depth, dir: params.containerDirection,
      group_xy_mm: {x: _mm(group.attrs.x), y: _mm(group.attrs.y)},
      original_wh_mm: {w: _mm(params.originalFacadeWidth), h: _mm(params.originalFacadeHeight)},
      container_edges_mm: _edges(group),
      children_mm: (params.children || []).map(_edges),
      inner_splitters_mm: (params.innerSplitters || []).map((s: any) => ({id: s.attrs.params.splitterId, x: _mm(s.attrs.x), y: _mm(s.attrs.y)})),
      outer_splitters_mm: _neighbors
    });
    if ((params.children || []).length > 0) {
      const left = this.getZoneEdge(group, 'left');
      const right = this.getZoneEdge(group, 'right');
      const top = this.getZoneEdge(group, 'top');
      const bottom = this.getZoneEdge(group, 'bottom');
      if (isFinite(left) && isFinite(right) && isFinite(top) && isFinite(bottom)) {
        group.x(left);
        group.y(top);
        w = right - left;
        h = bottom - top;
      }
    }
    for (const s of (params.innerSplitters || [])) {
      if (s && s.destroy) s.destroy();
    }
    for (const child of (params.children || [])) {
      this.destroyZoneTree(child);
    }
    for (let i = group.children.length - 1; i >= 0; i--) {
      group.children[i].destroy();
    }
    const isInset = params.originalIsInset !== undefined ? params.originalIsInset : params.isInset;
    params.isContainer = false;
    params.containerDirection = null;
    params.children = [];
    params.innerSplitters = [];
    params.sectionKind = null;
    params.swingDir = null;
    params.openingType = null;
    this.installFacadeOnGroup(group, w, h, isInset);
    console.log('[UNSPLIT] after', {
      zone: params.zoneName,
      facade_mm: {x: _mm(group.attrs.x), y: _mm(group.attrs.y), w: _mm(w), h: _mm(h)},
      outer_splitters_mm: _neighbors
    });
    this.coefDoor.DoorWrapper.batchDraw();
    this.syncPartitionsToCorpus();
  }

  destroyZoneTree(zone: any) {
    if (!zone || !zone.attrs || !zone.attrs.params) return;
    const params = zone.attrs.params;
    if (params.isContainer) {
      for (const s of (params.innerSplitters || [])) {
        if (s && s.destroy) s.destroy();
      }
      for (const child of (params.children || [])) {
        this.destroyZoneTree(child);
      }
    }
    if (zone.destroy) zone.destroy();
  }

  installFacadeOnGroup(group: any, w: number, h: number, isInset: boolean) {
    const zoneName = (group.attrs && group.attrs.params && group.attrs.params.zoneName) || 'zone';
    const facade: any = new Konva.Rect({
      x: 0,
      y: 0,
      width: w,
      height: h,
      fill: this.coef.color,
      stroke: 'black',
      strokeWidth: 1,
      params: {
        type: this.coef.id_element.hinged_facade_section,
        zoneName: zoneName,
        isFacade: true
      }
    });
    facade.on('click', () => {
      if (this.coefDoor.reDesign && this.coefDoor.reDesign.attrs && this.coefDoor.reDesign.attrs.params) {
        const prev = this.coefDoor.reDesign;
        if (prev.attrs.params.type === this.coef.id_element.hinged_facade_section && prev.children && prev.children[0]) {
          prev.children[0].attrs.strokeWidth = 1;
          prev.children[0].attrs.stroke = 'black';
        }
      }
      this.coefDoor.reDesign = group;
      facade.attrs.strokeWidth = 3;
      facade.attrs.stroke = 'red';
      this.coefDoor.DoorWrapper.batchDraw();
      if (this.initDoor && this.initDoor.openSlid) {
        this.initDoor.openSlid.next({id: 'hinged', obj: group});
      }
    });
    group.add(facade);
    this.addSizeLabels(group, w, h);
  }

  ensureSplittersOnTop() {
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return;
    const splType = this.coef.id_element.hinged_splitter;
    const all = this.coefDoor.DoorWrapper.children;
    const splitters: any[] = [];
    for (const c of all) {
      if (c.attrs && c.attrs.params && c.attrs.params.type === splType) splitters.push(c);
    }
    for (const s of splitters) s.moveToTop();
    this.coefDoor.DoorWrapper.batchDraw();
  }

  getLeafFacadeType(leaf: any): 'vertical' | 'horizontal' {
    const lastDir = leaf.attrs && leaf.attrs.params && leaf.attrs.params.lastDir;
    if (lastDir === 'rows') return 'horizontal';
    return 'vertical';
  }

  getDoorOrientation(leaf: any): 'horizontal' | 'vertical' | null {
    const sd = leaf.attrs && leaf.attrs.params && leaf.attrs.params.swingDir;
    if (sd === 'left' || sd === 'right') return 'vertical';
    if (sd === 'up' || sd === 'down') return 'horizontal';
    return null;
  }

  getLeafKind(leaf: any): 'door' | 'open' | 'drawers' | null {
    const k = leaf.attrs && leaf.attrs.params && leaf.attrs.params.sectionKind;
    if (k === 'door' || k === 'open' || k === 'drawers') return k;
    return null;
  }

  getLeafMin(leaf: any, axis: 'width' | 'height'): number {
    const hf = this.coef.hingedFacade || {};
    const kind = this.getLeafKind(leaf);
    if (kind === 'drawers') {
      return axis === 'width'
        ? (hf.min_outer_shuttle_facade_width || 0)
        : (hf.min_outer_shuttle_facade_height || 0);
    }
    if (kind === 'door') {
      const orient = this.getDoorOrientation(leaf);
      if (orient === 'horizontal') {
        return axis === 'width' ? (hf.min_horizontal_facade_width || 0) : (hf.min_horizontal_facade_height || 0);
      }
      if (orient === 'vertical') {
        return axis === 'width' ? (hf.min_vertical_facade_width || 0) : (hf.min_vertical_facade_height || 0);
      }
    }
    return this.getLowestMinAcrossKinds(axis);
  }

  getLowestMinAcrossKinds(axis: 'width' | 'height'): number {
    const hf = this.coef.hingedFacade || {};
    const keys = axis === 'width'
      ? ['min_open_section_width', 'min_horizontal_facade_width', 'min_vertical_facade_width',
         'min_outer_shuttle_facade_width']
      : ['min_open_section_height', 'min_horizontal_facade_height', 'min_vertical_facade_height',
         'min_outer_shuttle_facade_height'];
    let lowest = Infinity;
    for (const k of keys) {
      const v = hf[k];
      if (v != null && v > 0 && v < lowest) lowest = v;
    }
    return lowest === Infinity ? 0 : lowest;
  }

  getLeafMax(leaf: any, axis: 'width' | 'height'): number {
    const hf = this.coef.hingedFacade || {};
    const kind = this.getLeafKind(leaf);
    const coefG = this.coef.global_coef;
    let key = '(none)';
    let valuePx: number = Infinity;
    if (kind === 'drawers') {
      key = axis === 'width' ? 'max_outer_shuttle_facade_width' : 'max_outer_shuttle_facade_height';
      valuePx = hf[key] != null ? hf[key] : Infinity;
    } else if (kind === 'door') {
      const orient = this.getDoorOrientation(leaf);
      if (orient === 'horizontal') {
        key = axis === 'width' ? 'max_horizontal_facade_width' : 'max_horizontal_facade_height';
        valuePx = hf[key] != null ? hf[key] : Infinity;
      } else if (orient === 'vertical') {
        key = axis === 'width' ? 'max_vertical_facade_width' : 'max_vertical_facade_height';
        valuePx = hf[key] != null ? hf[key] : Infinity;
      }
    }
    const valueMm = valuePx === Infinity ? 'Infinity' : Math.round(valuePx * coefG);
    console.log('[HINGED] getLeafMax', {
      zoneName: leaf.attrs && leaf.attrs.params && leaf.attrs.params.zoneName,
      kind: kind,
      swingDir: leaf.attrs && leaf.attrs.params && leaf.attrs.params.swingDir,
      axis: axis,
      key: key,
      valueMm: valueMm
    });
    return valuePx;
  }

  getCurrentSize(zone: any, axis: 'width' | 'height'): number {
    if (axis === 'width') {
      return this.getZoneEdge(zone, 'right') - this.getZoneEdge(zone, 'left');
    }
    return this.getZoneEdge(zone, 'bottom') - this.getZoneEdge(zone, 'top');
  }

  getMinSizeFromSide(zone: any, axis: 'width' | 'height', side: 'left' | 'right' | 'top' | 'bottom'): number {
    const params = zone.attrs && zone.attrs.params;
    if (!params || !params.isContainer) return this.getLeafMin(zone, axis);
    const dir = params.containerDirection;
    const children = params.children || [];
    if (children.length === 0) return this.getLeafMin(zone, axis);
    const isParallel = (axis === 'width' && dir === 'cols') || (axis === 'height' && dir === 'rows');
    if (isParallel) {
      const adjIdx = (side === 'left' || side === 'top') ? 0 : children.length - 1;
      const adj = children[adjIdx];
      const currentAdjSize = this.getCurrentSize(adj, axis);
      const adjMin = this.getMinSizeFromSide(adj, axis, side);
      const currentTotal = this.getCurrentSize(zone, axis);
      return currentTotal - currentAdjSize + adjMin;
    }
    let m = 0;
    for (const c of children) m = Math.max(m, this.getMinSizeFromSide(c, axis, side));
    return m;
  }

  getMaxSizeFromSide(zone: any, axis: 'width' | 'height', side: 'left' | 'right' | 'top' | 'bottom'): number {
    const params = zone.attrs && zone.attrs.params;
    if (!params || !params.isContainer) return this.getLeafMax(zone, axis);
    const dir = params.containerDirection;
    const children = params.children || [];
    if (children.length === 0) return this.getLeafMax(zone, axis);
    const isParallel = (axis === 'width' && dir === 'cols') || (axis === 'height' && dir === 'rows');
    if (isParallel) {
      const adjIdx = (side === 'left' || side === 'top') ? 0 : children.length - 1;
      const adj = children[adjIdx];
      const currentAdjSize = this.getCurrentSize(adj, axis);
      const adjMax = this.getMaxSizeFromSide(adj, axis, side);
      const currentTotal = this.getCurrentSize(zone, axis);
      return currentTotal - currentAdjSize + adjMax;
    }
    let m = Infinity;
    for (const c of children) m = Math.min(m, this.getMaxSizeFromSide(c, axis, side));
    return m;
  }

  destroyParallelAdjacentSplitters(facadeGroup: any, newDirection: 'rows' | 'cols') {
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return;
    const splType = this.coef.id_element.hinged_splitter;
    for (let i = this.coefDoor.DoorWrapper.children.length - 1; i >= 0; i--) {
      const c: any = this.coefDoor.DoorWrapper.children[i];
      if (c.attrs && c.attrs.params && c.attrs.params.type === splType) {
        const isAdj = c.attrs.params.leftFacade === facadeGroup || c.attrs.params.rightFacade === facadeGroup;
        if (isAdj && c.attrs.params.direction === newDirection) {
          c.destroy();
        }
      }
    }
  }

  getZoneEdge(zone: any, side: 'left' | 'right' | 'top' | 'bottom'): number {
    if (zone.attrs && zone.attrs.params && zone.attrs.params.isContainer) {
      const children = zone.attrs.params.children || [];
      if (children.length === 0) {
        if (side === 'left' || side === 'top') return zone.attrs.x;
        return zone.attrs.x;
      }
      let result = (side === 'left' || side === 'top') ? Infinity : -Infinity;
      for (const c of children) {
        const e = this.getZoneEdge(c, side);
        if (side === 'left' || side === 'top') result = Math.min(result, e);
        else result = Math.max(result, e);
      }
      return result;
    }
    const rect = zone.children && zone.children[0];
    if (!rect) return zone.attrs.x;
    if (side === 'left') return zone.attrs.x;
    if (side === 'right') return zone.attrs.x + (rect.attrs.width || 0);
    if (side === 'top') return zone.attrs.y;
    return zone.attrs.y + (rect.attrs.height || 0);
  }

  applyZoneLeftAndWidth(zone: any, newX: number, newWidth: number) {
    const params = zone.attrs && zone.attrs.params;
    if (!params || !params.isContainer) {
      zone.x(newX);
      if (zone.children && zone.children[0]) {
        zone.children[0].width(Math.max(0, newWidth));
      }
      this.refreshSizeLabels(zone);
      return;
    }
    const dir = params.containerDirection;
    const children = params.children || [];
    if (dir === 'rows') {
      for (const c of children) {
        this.applyZoneLeftAndWidth(c, newX, newWidth);
      }
      for (const s of (params.innerSplitters || [])) {
        s.x(newX);
        const visual = s.children && s.children[0];
        const hit = s.children && s.children[1];
        if (visual) visual.width(newWidth);
        if (hit) hit.width(newWidth);
      }
      return;
    }
    if (children.length === 0) return;
    const oldLeft = this.getZoneEdge(zone, 'left');
    const oldRight = this.getZoneEdge(zone, 'right');
    const newRight = newX + newWidth;
    const leftMoved = Math.abs(newX - oldLeft) > 1e-4;
    const rightMoved = Math.abs(newRight - oldRight) > 1e-4;
    if (leftMoved) {
      const leftmost = children[0];
      const oldLeftW = this.getCurrentSize(leftmost, 'width');
      const newLeftW = oldLeftW + (oldLeft - newX);
      this.applyZoneLeftAndWidth(leftmost, newX, newLeftW);
    }
    if (rightMoved) {
      const rightmost = children[children.length - 1];
      const oldRightX = this.getZoneEdge(rightmost, 'left');
      const oldRightW = this.getCurrentSize(rightmost, 'width');
      const newRightW = oldRightW + (newRight - oldRight);
      this.applyZoneLeftAndWidth(rightmost, oldRightX, newRightW);
    }
  }

  applyZoneTopAndHeight(zone: any, newY: number, newHeight: number) {
    const params = zone.attrs && zone.attrs.params;
    if (!params || !params.isContainer) {
      zone.y(newY);
      if (zone.children && zone.children[0]) {
        zone.children[0].height(Math.max(0, newHeight));
      }
      this.refreshSizeLabels(zone);
      return;
    }
    const dir = params.containerDirection;
    const children = params.children || [];
    if (dir === 'cols') {
      for (const c of children) {
        this.applyZoneTopAndHeight(c, newY, newHeight);
      }
      for (const s of (params.innerSplitters || [])) {
        s.y(newY);
        const visual = s.children && s.children[0];
        const hit = s.children && s.children[1];
        if (visual) visual.height(newHeight);
        if (hit) hit.height(newHeight);
      }
      return;
    }
    if (children.length === 0) return;
    const oldTop = this.getZoneEdge(zone, 'top');
    const oldBottom = this.getZoneEdge(zone, 'bottom');
    const newBottom = newY + newHeight;
    const topMoved = Math.abs(newY - oldTop) > 1e-4;
    const bottomMoved = Math.abs(newBottom - oldBottom) > 1e-4;
    if (topMoved) {
      const topmost = children[0];
      const oldTopH = this.getCurrentSize(topmost, 'height');
      const newTopH = oldTopH + (oldTop - newY);
      this.applyZoneTopAndHeight(topmost, newY, newTopH);
    }
    if (bottomMoved) {
      const bottommost = children[children.length - 1];
      const oldBotY = this.getZoneEdge(bottommost, 'top');
      const oldBotH = this.getCurrentSize(bottommost, 'height');
      const newBotH = oldBotH + (newBottom - oldBottom);
      this.applyZoneTopAndHeight(bottommost, oldBotY, newBotH);
    }
  }

  destroyAdjacentSplitters(facadeGroup: any) {
    if (!this.coefDoor.DoorWrapper || !this.coefDoor.DoorWrapper.children) return;
    const splType = this.coef.id_element.hinged_splitter;
    for (let i = this.coefDoor.DoorWrapper.children.length - 1; i >= 0; i--) {
      const c: any = this.coefDoor.DoorWrapper.children[i];
      if (c.attrs && c.attrs.params && c.attrs.params.type === splType) {
        if (c.attrs.params.leftFacade === facadeGroup || c.attrs.params.rightFacade === facadeGroup) {
          c.destroy();
        }
      }
    }
  }

  refreshSizeLabels(facadeGroup: any) {
    if (!facadeGroup || !facadeGroup.children || facadeGroup.children.length === 0) return;
    for (let i = facadeGroup.children.length - 1; i >= 1; i--) {
      facadeGroup.children[i].destroy();
    }
    const facade = facadeGroup.children[0];
    this.addSizeLabels(facadeGroup, facade.attrs.width, facade.attrs.height);
  }

  createSplitter(leftFacade: any, rightFacade: any, direction: 'rows' | 'cols') {
    const isVertical = direction === 'cols';
    const coefG = this.coef.global_coef;
    const hf = this.coef.hingedFacade || {};
    const gapMm = hf.facade_gap_size != null ? Math.round(hf.facade_gap_size * coefG) : 0;
    const gapPx = gapMm / coefG;
    const minSize = isVertical
      ? (hf.min_vertical_facade_width || 0)
      : (hf.min_horizontal_facade_height || 0);
    const maxSize = isVertical
      ? (hf.max_vertical_facade_width || Infinity)
      : (hf.max_horizontal_facade_height || Infinity);

    const leftRect = leftFacade.children[0];
    const rightRect = rightFacade.children[0];

    const splitterX = isVertical
      ? leftFacade.attrs.x + leftRect.attrs.width
      : leftFacade.attrs.x;
    const splitterY = isVertical
      ? leftFacade.attrs.y
      : leftFacade.attrs.y + leftRect.attrs.height;
    const splitterW = isVertical ? gapPx : leftRect.attrs.width;
    const splitterH = isVertical ? leftRect.attrs.height : gapPx;

    this.coef.countNameElement++;
    const splitterId = 'split_' + this.coef.countNameElement;
    const splitter: any = new Konva.Group({
      x: splitterX,
      y: splitterY,
      draggable: true,
      params: {
        type: this.coef.id_element.hinged_splitter,
        splitterId: splitterId,
        leftFacade: leftFacade,
        rightFacade: rightFacade,
        direction: direction
      }
    });

    const visual = new Konva.Rect({
      x: 0,
      y: 0,
      width: splitterW,
      height: splitterH,
      fill: 'rgba(220, 30, 30, 0.9)',
      listening: false
    });
    const hitW = isVertical ? 14 : splitterW;
    const hitH = isVertical ? splitterH : 14;
    const hitDx = isVertical ? (splitterW - hitW) / 2 : 0;
    const hitDy = isVertical ? 0 : (splitterH - hitH) / 2;
    const hit = new Konva.Rect({
      x: hitDx,
      y: hitDy,
      width: hitW,
      height: hitH,
      // Невидима зона хвату (ширша за зазор, щоб легко влучити). Fill потрібен для hit-детекту.
      fill: 'rgba(0, 0, 0, 0)'
    });

    splitter.add(visual, hit);

    splitter.attrs.params.visualRect = visual;
    splitter.attrs.params.normalFill = 'rgba(220, 30, 30, 0.9)';
    splitter.attrs.params.selectedFill = 'rgba(40, 180, 40, 0.95)';

    const cursor = isVertical ? 'ew-resize' : 'ns-resize';
    splitter.on('mouseenter', () => {
      const stage = this.coefDoor.DoorWrapper.getStage();
      if (stage && stage.container()) stage.container().style.cursor = cursor;
    });
    splitter.on('mouseleave', () => {
      const stage = this.coefDoor.DoorWrapper.getStage();
      if (stage && stage.container()) stage.container().style.cursor = 'default';
    });

    hit.on('click', () => {
      this.selectHingedSplitter(splitter);
    });
    splitter.on('click', () => {
      this.selectHingedSplitter(splitter);
    });

    splitter.dragBoundFunc((pos: any) => {
      const axis: 'width' | 'height' = isVertical ? 'width' : 'height';
      const lSide = isVertical ? 'right' : 'bottom';
      const rSide = isVertical ? 'left' : 'top';
      const lMin = this.getMinSizeFromSide(leftFacade, axis, lSide);
      const lMax = this.getMaxSizeFromSide(leftFacade, axis, lSide);
      const rMin = this.getMinSizeFromSide(rightFacade, axis, rSide);
      const rMax = this.getMaxSizeFromSide(rightFacade, axis, rSide);
      if (isVertical) {
        const leftStart = this.getZoneEdge(leftFacade, 'left');
        const rightEnd = this.getZoneEdge(rightFacade, 'right');
        const minX = Math.max(leftStart + lMin, rightEnd - rMax - gapPx);
        const maxX = Math.min(leftStart + lMax, rightEnd - rMin - gapPx);
        const clamped = Math.max(minX, Math.min(maxX, pos.x));
        return {x: clamped, y: splitter.attrs.y};
      } else {
        const leftStart = this.getZoneEdge(leftFacade, 'top');
        const rightEnd = this.getZoneEdge(rightFacade, 'bottom');
        const minY = Math.max(leftStart + lMin, rightEnd - rMax - gapPx);
        const maxY = Math.min(leftStart + lMax, rightEnd - rMin - gapPx);
        const clamped = Math.max(minY, Math.min(maxY, pos.y));
        return {x: splitter.attrs.x, y: clamped};
      }
    });

    splitter.on('dragmove', () => {
      if (isVertical) {
        const leftStart = this.getZoneEdge(leftFacade, 'left');
        const rightEnd = this.getZoneEdge(rightFacade, 'right');
        const newLeftWidth = splitter.attrs.x - leftStart;
        const newRightX = splitter.attrs.x + gapPx;
        const newRightWidth = rightEnd - newRightX;
        this.applyZoneLeftAndWidth(leftFacade, leftStart, newLeftWidth);
        this.applyZoneLeftAndWidth(rightFacade, newRightX, newRightWidth);
      } else {
        const leftStart = this.getZoneEdge(leftFacade, 'top');
        const rightEnd = this.getZoneEdge(rightFacade, 'bottom');
        const newLeftHeight = splitter.attrs.y - leftStart;
        const newRightY = splitter.attrs.y + gapPx;
        const newRightHeight = rightEnd - newRightY;
        this.applyZoneTopAndHeight(leftFacade, leftStart, newLeftHeight);
        this.applyZoneTopAndHeight(rightFacade, newRightY, newRightHeight);
      }
      this.coefDoor.DoorWrapper.batchDraw();
    });

    splitter.on('dragend', () => {
      if (isVertical) {
        const mm = Math.round(splitter.attrs.x * coefG);
        splitter.x(mm / coefG);
      } else {
        const mm = Math.round(splitter.attrs.y * coefG);
        splitter.y(mm / coefG);
      }
      splitter.fire('dragmove');
      // ДІАГНОСТИКА "Назад до батька": межі сусідів після драгу (контейнер — з дітей)
      const _mmD = (v: number) => Math.round(v * coefG);
      const _ed = (z: any) => ({
        name: z && z.attrs && z.attrs.params && z.attrs.params.zoneName,
        container: !!(z && z.attrs && z.attrs.params && z.attrs.params.isContainer),
        group_x: _mmD(z.attrs.x), group_y: _mmD(z.attrs.y),
        l: _mmD(this.getZoneEdge(z, 'left')), r: _mmD(this.getZoneEdge(z, 'right')),
        t: _mmD(this.getZoneEdge(z, 'top')), b: _mmD(this.getZoneEdge(z, 'bottom'))
      });
      console.log('[UNSPLIT] splitter dragend', {
        id: splitter.attrs.params.splitterId, dir: direction,
        x: _mmD(splitter.attrs.x), y: _mmD(splitter.attrs.y),
        left: _ed(leftFacade), right: _ed(rightFacade)
      });
      this.refreshSizeLabels(leftFacade);
      this.refreshSizeLabels(rightFacade);
      this.coefDoor.DoorWrapper.batchDraw();
      this.syncPartitionsToCorpus();
      if (this.onAfterResize) this.onAfterResize();
    });

    this.coefDoor.DoorWrapper.add(splitter);
    return splitter;
  }
}
